import React, { useState, useEffect, useRef, useMemo } from "react";
import { useParams, useNavigate, Link, useLocation } from "react-router-dom";
import "./ProductDetail.css";
import {
  Info,
  Heart,
  BookOpen,
  Share2,
  ChevronDown,
  Gift,
  Tag,
  Lock,
  Check,
  Zap,
  Wind,
  ChevronRight,
  CalendarDays,
  Calendar,
  Bookmark,
  Package,
  History,
  MousePointerClick,
  ShoppingCart,
  ChevronLeft,
  X,
  Play,
  CirclePlay,
  Ticket,
  TriangleAlert,
  CircleSmall,
  Building2,
  Search,
  Minus,
  Plus,
} from "lucide-react";
import CBM from "../../assets/img/cbm.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faXTwitter,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import Breadcrums from "../../components/breadcrums_v2/Breadcrums";
import PurchaseHistory from "../../components/purchasehistory_v2/PurchaseHistory";
import AddToCart from "../../components/addtocart/AddToCart";
import AddToCartSuccess from "../../components/addtocart_v2/AddToCartSuccess.js";
import ApiService from "../../components/Api_services";
import MultiPurpose from "../../components/multipurpose_v2/MultiPurpose.js";
import FallbackImg from "../../components/FallbackImg";
import { REDIRECT_LOGIN_URL, SHOW_REGION_POPUP } from "../../constants";
import { useSelector } from "react-redux";
import { ACCESS_KEYS } from "../../constants";
import { hasAccess } from "../../utils/Permission";
import { useEffectEvent } from "react";

const ProductDetailv2 = ({ fetchCounts }) => {
  const { item_id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [branchCount, setBranchCount] = useState(1);
  const [slideIndex, setSlideIndex] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [showPurchaseHistory, setShowPurchaseHistory] = useState(false);
  const isBuyNowRef = useRef(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [showPromoTip, setShowPromoTip] = useState(false);
  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Derived state
  const product = productData?.product?.[0] || {};
  const pricing = productData?.pricing || {};
  const specifications = productData?.specification || [];
  const features = productData?.features || [];
  const whatsInBox = productData?.whats_in_box || [];
  const itemReplacement = productData?.item_replacement || [];

  // Magnifier states
  const [showMagnifier, setShowMagnifier] = useState(false);
  const [magnifierPosition, setMagnifierPosition] = useState({ x: 0, y: 0 });
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const magnifierRef = useRef(null);
  const imageRef = useRef(null);
  const videoRef = useRef(null);
  const sellingPoints = productData?.selling_point || [];

  const [wishlistLoading, setWishlistLoading] = useState(false);
  const [favoriteLoading, setFavoriteLoading] = useState(false);
  const wishlistId = productData?.wishlist_id || "";
  const favouriteId = productData?.favourite_id || "";
  const inWishlist = !!wishlistId;
  const isFavourite = !!favouriteId;
  const isLoggedIn = !!localStorage.getItem("access_token");
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [notice, setNotice] = useState({ show: false, message: "" });
  const [showPromotionPack, setShowPromotionPack] = useState(false);
  // 初始化 selectedPromotionIds
  const [selectedPromotionIds, setSelectedPromotionIds] = useState([]);
  // PWP quantities for each PWP promotion
  const [pwpQuantities, setPwpQuantities] = useState({});
  const [showPwpZeroQtyConfirm, setShowPwpZeroQtyConfirm] = useState(false);
  const [pricing_type, setPricingType] = useState("1");
  const [showQuantityOffer, setShowQuantityOffer] = useState(false);
  const [invalidPackingQty, setInvalidPackingQty] = useState(false);
  const [invalidDiscountQty, setInvalidDiscountQty] = useState(false);
  const [quantityInputStr, setQuantityInputStr] = useState("0");
  const [youMayAlsoLikeItems, setYouMayAlsoLikeItems] = useState([]);
  const [youMayAlsoLikePage, setYouMayAlsoLikePage] = useState(1);
  const [youMayAlsoLikeTotalPages, setYouMayAlsoLikeTotalPages] = useState(1);
  const [youMayAlsoLikeLoading, setYouMayAlsoLikeLoading] = useState(false);
  const product_code = product?.product;
  const [promotionForDisplay, setPromotionForDisplay] = useState(false);

  // Promotion magnifier states
  const [showPromotionMagnifier, setShowPromotionMagnifier] = useState(false);
  const [promotionMagnifierImg, setPromotionMagnifierImg] = useState("");
  const [promotionMagnifierPosition, setPromotionMagnifierPosition] = useState({
    x: 0,
    y: 0,
  });
  const promotionMagnifierRef = useRef(null);
  const promotionTagsRef = useRef(null);
  const shouldScrollPromotionRowRef = useRef(false);
  const [showPromotionImageModal, setShowPromotionImageModal] = useState(false);
  const [modalPromotionImageUrl, setModalPromotionImageUrl] = useState("");

  const [showPromotionBody, setShowPromotionBody] = useState(false);
  const [isDistributionOpen, setIsDistributionOpen] = useState(false);
  const [isDistributionVisited, setIsDistributionVisited] = useState(false);
  // Keyed by PWP tag id — multiple PWP promotions can be selected at once,
  // each needs its own open/visited state.
  const [isPwpDistributionOpen, setIsPwpDistributionOpen] = useState({});
  const [isPwpDistributionVisited, setIsPwpDistributionVisited] = useState({});
  const [distributionMode, setDistributionMode] = useState("hq");
  const [allowAddToCart, setAllowAddToCart] = useState(false);
  const [activeDetailTab, setActiveDetailTab] = useState("specification");

  // Region selection state
  const [branchRegions, setBranchRegions] = useState([]);
  const [showRegionPopup, setShowRegionPopup] = useState(false);
  const [tempSelectedRegion, setTempSelectedRegion] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [regionAvailability, setRegionAvailability] = useState(null);

  const REGION_LABELS = {
    west_malaysia: "West Malaysia",
    sabah: "Sabah",
    sarawak: "Sarawak",
  };

  const formatCurrency = (value) => {
    if (value === null || value === undefined || value === "") return "";
    return parseFloat(value).toLocaleString("en-MY", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleString("en-MY", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const [pendingStep, setPendingStep] = useState("");
  const [orpMsg, setOrpMsg] = useState("");
  const [orpShown, setOrpShown] = useState(false);
  const sub_role = useSelector((state) => state.auth.sub_role) || [];
  const is_subuser =
    useSelector((state) => state.auth.user?.is_subuser) || false;

  const canOrder = !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_ORDER);
  const canView =
    !is_subuser ||
    hasAccess(sub_role, ACCESS_KEYS.HOME || ACCESS_KEYS.MY_ORDER);

  useEffect(() => {
    if (isLoggedIn) {
      const fetchBranchRegions = async () => {
        try {
          if (SHOW_REGION_POPUP !== 1) return;
          const searchParams = new URLSearchParams(location.search || "");
          const isBundleFromUrl =
            searchParams.get("isBundle") === "1" ||
            searchParams.get("isBundle") === "true";
          const bundleIdFromUrl = searchParams.get("bundleId");
          const res = await ApiService.getBranchListWithRegions(
            isBundleFromUrl
              ? { bundle_id: bundleIdFromUrl || item_id }
              : { item_id },
          );
          setRegionAvailability(res.regionAvailability || null);
          if (res.regions.length === 1) {
            setSelectedRegion(res.regions[0]);
          } else {
            setBranchRegions(res.regions || []);
            if (res.regions.length > 0) {
              // Default to the first region that actually has stock for this item,
              // falling back to the first region if none do.
              const availability = res.regionAvailability || {};
              const inStockRegion = res.regions.find((r) => availability[r]);
              setTempSelectedRegion(inStockRegion || res.regions[0]);
            }
            setShowRegionPopup(true);
          }
        } catch (error) {
          console.error("Error fetching branch regions:", error);
        }
      };
      fetchBranchRegions();
    }
  }, [isLoggedIn, item_id, location.search]);

  useEffect(() => {
    const fetchProductDetail = async () => {
      if (!item_id) return;
      if (isLoggedIn && SHOW_REGION_POPUP === 1 && !selectedRegion) return;

      // read from state first, fallback to query
      const searchParams = new URLSearchParams(location.search || "");
      const isBundleFromUrl =
        searchParams.get("isBundle") === "1" ||
        searchParams.get("isBundle") === "true";
      const bundleIdFromUrl = searchParams.get("bundleId");

      try {
        setLoading(true);
        setError(null);
        let response;
        if (isBundleFromUrl) {
          const bundleId = bundleIdFromUrl || item_id;
          response = await ApiService.getBundleDetail(bundleId, selectedRegion);
        } else {
          response = await ApiService.getItemDetail(item_id, selectedRegion);
        }

        if (response && response.status === 200) {
          let data = response.data;
          if (data && data.data) data = data.data;

          // bundle shape handling
          if (
            data &&
            (data.bundle_info || data.bundle_items || data.bundle_pricing)
          ) {
            const info = data.bundle_info || {};
            const bundlePricing = data.bundle_pricing || {};
            const items = Array.isArray(data.bundle_items)
              ? data.bundle_items
              : [];

            const mergeUnique = (a = [], b = [], key) => {
              const map = {};
              a.concat(b).forEach((it) => {
                const k = key ? it[key] : JSON.stringify(it);
                map[k] = it;
              });
              return Object.values(map);
            };

            const grouped = {};
            items.forEach((it) => {
              const prod = it.product || {};
              const pid = String(prod.id || prod.item_id || Math.random());
              if (!grouped[pid]) {
                grouped[pid] = {
                  id: prod.id,
                  item_id: prod.id,
                  item_code: prod.item_code,
                  item_name: prod.item_name,
                  nick_name: prod.nick_name,
                  photo_url:
                    prod.photo_url || it.item_photo?.[0]?.photo_url || "",
                  thumb_url:
                    it.item_photo?.[0]?.thumb_url || prod.photo_url || "",
                  product: prod.product,
                  // preserve mag_link from product if present
                  mag_link: prod.mag_link || prod.magazine || "",
                  product_type: it.product_type || prod.product_type || "",
                  used_pricing_type: it.used_pricing_type || "",
                  specification: Array.isArray(it.specification)
                    ? it.specification.slice()
                    : [],
                  features: Array.isArray(it.features)
                    ? it.features.slice()
                    : [],
                  selling_point: Array.isArray(it.selling_point)
                    ? it.selling_point.slice()
                    : [],
                  packing: Array.isArray(it.packing) ? it.packing.slice() : [],
                  whats_in_box: Array.isArray(it.whats_in_box)
                    ? it.whats_in_box.slice()
                    : [],
                  item_photo: Array.isArray(it.item_photo)
                    ? it.item_photo.slice()
                    : [],
                  more_photo: Array.isArray(it.more_photo)
                    ? it.more_photo.slice()
                    : [],
                  item_video: it.item_video || "",
                  pricing: it.pricing || prod.pricing || {},
                };
              } else {
                grouped[pid].specification = mergeUnique(
                  grouped[pid].specification,
                  it.specification || [],
                  "spec_id",
                );
                grouped[pid].features = mergeUnique(
                  grouped[pid].features,
                  it.features || [],
                  "feat_id",
                );
                grouped[pid].selling_point = mergeUnique(
                  grouped[pid].selling_point,
                  it.selling_point || [],
                );
                grouped[pid].packing = mergeUnique(
                  grouped[pid].packing,
                  it.packing || [],
                  "id",
                );
                grouped[pid].whats_in_box = mergeUnique(
                  grouped[pid].whats_in_box,
                  it.whats_in_box || [],
                  "id",
                );
                grouped[pid].item_photo = mergeUnique(
                  grouped[pid].item_photo,
                  it.item_photo || [],
                  "photo_url",
                );
                grouped[pid].product_type =
                  grouped[pid].product_type ||
                  it.product_type ||
                  prod.product_type ||
                  grouped[pid].product_type;
                grouped[pid].more_photo = mergeUnique(
                  grouped[pid].more_photo,
                  it.more_photo || [],
                  "image_url",
                );
                if (
                  !grouped[pid].pricing ||
                  Object.keys(grouped[pid].pricing).length === 0
                ) {
                  grouped[pid].pricing = it.pricing || prod.pricing || {};
                }
              }
            });

            const combinedItems = Object.values(grouped);

            // derive package-level mag_link: prefer package info, else first item mag_link
            const firstItemWithMag = combinedItems.find((it) => it.mag_link);
            const derivedPackageMagLink =
              info.mag_link ||
              (firstItemWithMag && firstItemWithMag.mag_link) ||
              "";

            // helpers
            const toNumber = (v) =>
              v === null || v === undefined || v === "" ? 0 : Number(v);

            // collect package main photo (must be first)
            const packagePhotoObj = info.photo_url
              ? { photo_url: info.photo_url, thumb_url: info.photo_url }
              : null;

            // collect all item photos (flatten)
            const allItemPhotos = combinedItems.flatMap((it) =>
              (it.item_photo || []).map((p) => ({
                photo_url: p.photo_url || p.image_url || p,
                thumb_url: p.thumb_url || p.photo_url || p.image_url || p,
              })),
            );

            // unique preserve order (package photo first)
            const photoSeen = new Set();
            const morePhotos = [];
            if (packagePhotoObj) {
              photoSeen.add(packagePhotoObj.photo_url);
              morePhotos.push(packagePhotoObj);
            }
            allItemPhotos.forEach((p) => {
              if (p && p.photo_url && !photoSeen.has(p.photo_url)) {
                photoSeen.add(p.photo_url);
                morePhotos.push(p);
              }
            });

            // collect all videos (preserve order)
            const allItemVideos = combinedItems
              .flatMap((it) => (it.item_video ? [it.item_video] : []))
              .filter(Boolean);

            // top-level packing / whats_in_box: keep all entries
            const mergedPacking = combinedItems.flatMap(
              (it) => it.packing || [],
            );
            const mergedWhatsInBox = (() => {
              const map = {};
              combinedItems
                .flatMap((it) => it.whats_in_box || [])
                .forEach((w) => {
                  const key = String(
                    w.box_id ?? w.id ?? w.name ?? JSON.stringify(w),
                  );
                  const qty = Number(
                    w.quantity ?? w.qty ?? w.packing_quantity ?? 0,
                  );
                  if (!map[key]) {
                    map[key] = { ...w, quantity: qty, items: [] };
                    if (w.item_id) map[key].items.push(String(w.item_id));
                  } else {
                    map[key].quantity = (Number(map[key].quantity) || 0) + qty;
                    if (
                      w.item_id &&
                      !map[key].items.includes(String(w.item_id))
                    ) {
                      map[key].items.push(String(w.item_id));
                    }
                  }
                });
              return Object.values(map);
            })();

            const normalized = {
              package_id: info.package_id || "",
              package_name: info.package_name || "",
              // use package photo as main / first image
              photo_url: info.photo_url || combinedItems[0]?.photo_url || "",
              updated_date: info.updated_date || "",
              pricing: {
                brand_price: toNumber(
                  bundlePricing.final_brand_price ??
                    bundlePricing.original_price ??
                    0,
                ),
                rcp: toNumber(
                  bundlePricing.final_rcp_price ?? bundlePricing.rcp_price ?? 0,
                ),
                stock_warehouse: toNumber(bundlePricing.stock_quantity ?? 0),
                bundle_pricing: bundlePricing,
                brand_quantity:
                  toNumber(bundlePricing.brand_quantity) ||
                  toNumber(combinedItems[0]?.pricing?.brand_quantity) ||
                  1,
              },
              stock_warehouse: toNumber(bundlePricing.stock_quantity ?? 0),
              actual_stock: toNumber(data.actual_stock ?? 0),
              virtual_stock: toNumber(data.virtual_stock ?? 0),
              stock_display: Array.isArray(data.stock_display)
                ? data.stock_display.map((row) => ({
                    key: row.key ?? "",
                    label: row.label ?? "",
                    qty: toNumber(row.qty ?? 0),
                    show: toNumber(row.show ?? 0),
                    region: row.region ?? "",
                    location_id: toNumber(row.location_id ?? 0),
                  }))
                : [],
              promotion: [], // do not create discount promo
              bundle_items: combinedItems,
              packing: mergedPacking,
              whats_in_box: mergedWhatsInBox,
              // use package_description as display name (fallback to package_name)
              package_description:
                info.package_description || info.package_name || "",
              product: [
                {
                  id: info.package_id || "",
                  item_code: info.package_name || "",
                  // replace item_name with package_description
                  item_name:
                    info.package_description || info.package_name || "",
                  photo_url: info.photo_url || "",
                  product: items[0].product.product || "",
                },
              ],
              package_item: "1",
              // aggregated media: package photo first, then all item photos
              more_photo: morePhotos,
              // item_photo keep first/main image for legacy templates (package photo)
              item_photo: packagePhotoObj
                ? [packagePhotoObj]
                : morePhotos.length
                  ? [morePhotos[0]]
                  : [],
              // videos aggregated
              item_videos: allItemVideos,
              item_video: allItemVideos.length ? allItemVideos[0] : "",
              // expose mag_link at top level for bundle/package
              mag_link: derivedPackageMagLink,
              history: data.purchase_history,
              filter_label: data.filter_label,
              wishlist_id: data.wishlist_id,
              favourite_id: data.favourite_id,
            };

            // compatibility: expose first item specs etc.
            const mainItem = combinedItems[0] || {};
            normalized.specification = mainItem.specification || [];
            normalized.features = mainItem.features || [];
            normalized.selling_point = mainItem.selling_point || [];
            normalized.more_photo =
              normalized.more_photo || mainItem.more_photo || [];
            normalized.thumb_url =
              mainItem.thumb_url || normalized.photo_url || "";
            // special case: if either one is RCP, both is RCP,since it is bundle item
            normalized.product_type = combinedItems.some(
              (it) => it.product_type === "RCP",
            )
              ? "RCP"
              : mainItem.product_type || mainItem.product?.product_type || "";
            normalized.product = normalized.product.map((p) => ({
              ...p,
              product_type: normalized.product_type || p.product_type || "",
            }));
            normalized.used_pricing_type = mainItem.used_pricing_type || "";
            setProductData(normalized);
            setPricingType(pricing?.pricing_type || "bundle");
          } else {
            // normal item
            let d = data;
            if (d && d.package) d = d.package;
            setProductData(d);
            if (d?.pricing?.pricing_type)
              setPricingType(d.pricing.pricing_type);
          }
        } else {
          setError(response?.message || "Failed to load product details");
          setProductData(null);
        }
      } catch (error) {
        setError("Failed to load product details");
        setProductData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchProductDetail();
  }, [item_id, location.search, location.state, selectedRegion]);

  const fetchYouMayAlsoLikeItems = async (page = 1) => {
    if (!product_code) {
      setYouMayAlsoLikeItems([]);
      return;
    }
    setYouMayAlsoLikeLoading(true);
    try {
      const params = {
        product_code,
        page,
        limit: 4,
      };
      const response = await ApiService.getYouMayAlsoLikeItems(params);
      if (response.status === 200) {
        const itemList = response.data?.item_list || [];
        const totalPages = response.data?.pagination?.total_pages || 1;
        setYouMayAlsoLikeTotalPages(totalPages);
        if (page === 1) {
          setYouMayAlsoLikeItems(itemList);
        } else {
          setYouMayAlsoLikeItems((prev) => [...prev, ...itemList]);
        }
      }
    } catch (err) {
      setError(err);
    } finally {
      setYouMayAlsoLikeLoading(false);
    }
  };

  useEffect(() => {
    setYouMayAlsoLikePage(1);
    fetchYouMayAlsoLikeItems(1);
  }, [product_code]);

  const handleLoadMoreYouMayAlsoLike = async () => {
    setYouMayAlsoLikeLoading(true);
    try {
      let currentPage = youMayAlsoLikePage + 1;
      let allNewItems = [];

      // Loop through all remaining pages
      while (currentPage <= youMayAlsoLikeTotalPages) {
        const params = {
          product_code,
          page: currentPage,
          limit: 4,
        };
        const response = await ApiService.getYouMayAlsoLikeItems(params);
        if (response.status === 200) {
          const itemList = response.data?.item_list || [];
          allNewItems = [...allNewItems, ...itemList];
        }
        currentPage++;
      }

      setYouMayAlsoLikeItems((prev) => [...prev, ...allNewItems]);
      setYouMayAlsoLikePage(youMayAlsoLikeTotalPages); // Mark all pages as loaded
    } catch (err) {
      setError(err);
    } finally {
      setYouMayAlsoLikeLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [item_id]);

  const actuallyAddToCart = () => {
    handleAddToCart({ orp: true, term: true, virtual: true, bestDeal: true });
  };

  const refreshDetailFlags = async () => {
    const searchParams = new URLSearchParams(location.search || "");
    const isBundleFromUrl =
      searchParams.get("isBundle") === "1" ||
      searchParams.get("isBundle") === "true";
    const bundleIdFromUrl = searchParams.get("bundleId");

    const response = isBundleFromUrl
      ? await ApiService.getBundleDetail(
          bundleIdFromUrl || item_id,
          selectedRegion,
        )
      : await ApiService.getItemDetail(item_id, selectedRegion);

    if (!response || response.status !== 200) return;

    let data = response.data;
    if (data && data.data) data = data.data;

    setProductData((prev) =>
      prev
        ? {
            ...prev,
            wishlist_id: data.wishlist_id,
            favourite_id: data.favourite_id,
          }
        : prev,
    );
  };

  const handleWishlistToggle = async () => {
    if (wishlistLoading) return;
    // Read bundle params from URL when on detail page
    const params = new URLSearchParams(location.search || "");
    const urlIsBundle = params.get("isBundle") ?? params.get("is_bundle");
    const urlBundleId = params.get("bundleId") ?? params.get("bundle_id");

    try {
      setWishlistLoading(true);

      if (inWishlist) {
        const response = await ApiService.removeFromWishlist({
          wishlist_id: wishlistId,
          pricing_type: pricing_type || "1",
        });
        if (response.status === 200) {
          await refreshDetailFlags();
          if (typeof fetchCounts === "function") fetchCounts();
        } else {
          throw new Error(response.message || "Failed to remove from wishlist");
        }
      } else {
        const payload = {
          item_id: item_id,
          pricing_type: pricing_type || "1",
        };

        if (urlBundleId) payload.bundle_id = urlBundleId;
        if (typeof urlIsBundle !== "undefined" && urlIsBundle !== null)
          payload.is_bundle = urlIsBundle;

        const response = await ApiService.addToWishlist(payload);
        if (response.status === 200) {
          await refreshDetailFlags();
          if (typeof fetchCounts === "function") fetchCounts();
        } else if (response.message === "Wishlist cannot exceed 20 items.") {
          setNotice({
            show: true,
            message: "Wishlist cannot exceed 20 items.",
          });
        } else {
          throw new Error(response.message || "Failed to add to wishlist");
        }
      }
    } catch (error) {
      setNotice({
        show: true,
        message:
          error.message || "Failed to update wishlist. Please try again.",
      });
    } finally {
      setWishlistLoading(false);
    }
  };

  const handleFavoriteToggle = async (itemIdParam, product_type) => {
    if (favoriteLoading) return;
    // allow calling without args on detail page
    const targetItemId = itemIdParam || item_id;

    // Read bundle params from URL when on detail page
    const params = new URLSearchParams(location.search || "");
    const urlIsBundle = params.get("isBundle") ?? params.get("is_bundle");
    const urlBundleId = params.get("bundleId") ?? params.get("bundle_id");

    try {
      setFavoriteLoading(true);

      if (isFavourite) {
        const res = await ApiService.removeFromFavorite({
          favorite_id: favouriteId,
          pricing_type: product_type || pricing_type || "1",
        });
        if (res.status === 200) {
          await refreshDetailFlags();
        } else {
          throw new Error(res.message || "Failed to remove from favorite");
        }
      } else {
        const payload = {
          item_id: targetItemId,
          pricing_type: product_type || pricing_type || "1",
        };

        if (urlBundleId) payload.bundle_id = urlBundleId;
        if (typeof urlIsBundle !== "undefined" && urlIsBundle !== null)
          payload.is_bundle = urlIsBundle;

        const res = await ApiService.addToFavorite(payload);
        if (res.status === 200) {
          await refreshDetailFlags();
        } else {
          throw new Error(res.message || "Failed to add to favorite");
        }
      }
    } catch (error) {
      setNotice({
        show: true,
        message:
          error.message || "Failed to update favorite. Please try again.",
      });
    } finally {
      setFavoriteLoading(false);
    }
  };

  const getCurrentStock = () => {
    if (productData?.item_limit_info?.is_limited || pricing?.is_limited) {
      return 0;
    }
    return parseInt(productData?.stock_warehouse || 0);
  };

  const getActualStock = () => {
    if (productData?.item_limit_info?.is_limited || pricing?.is_limited) {
      return 0;
    }
    return parseInt(productData?.actual_stock || 0);
  };

  const getVirtualStock = () => {
    if (productData?.item_limit_info?.is_limited || pricing?.is_limited) {
      return 0;
    }
    return parseInt(productData?.virtual_stock || 0);
  };

  const getStockDisplayRows = () => {
    const resolveRowQty = (row) => {
      if (row.key === "warehouse") {
        return getActualStock();
      }
      if (row.key === "virtual") {
        return getVirtualStock();
      }
      return Number(row.qty ?? 0);
    };

    const rows = productData?.stock_display;
    if (!Array.isArray(rows) || rows.length === 0) {
      return [
        {
          key: "warehouse",
          label: "Warehouse Quantity",
          qty: getActualStock(),
          show: 1,
        },
        {
          key: "virtual",
          label: "Virtual Quantity",
          qty: getVirtualStock(),
          show: 1,
        },
      ];
    }
    return rows
      .filter((row) => Number(row.show) === 1)
      .map((row) => ({
        ...row,
        qty: resolveRowQty(row),
      }));
  };

  const isInStock = () => {
    const bp = pricing.bundle_pricing;

    if (bp) {
      if (isLoggedIn) {
        if (
          bp.stock_quantity !== undefined &&
          parseFloat(bp.stock_quantity) === 0
        )
          return false;
        if (!bp.final_brand_price || parseFloat(bp.final_brand_price) === 0)
          return false;
      }
    } else {
      if (isLoggedIn) {
        if (
          pricing.stock_quantity !== undefined &&
          parseFloat(pricing.stock_quantity) === 0
        )
          return false;
        if (!pricing.brand_price || parseFloat(pricing.brand_price) === 0)
          return false;
      }
    }

    return getCurrentStock() > 0;
  };

  const isQuantityValid = () => {
    const stock = getCurrentStock();
    return stock > 0 && quantity <= stock;
  };

  const isItemLimited = () => {
    return (
      productData?.item_limit_info?.is_limited || pricing?.is_limited || false
    );
  };

  function handleDecrease() {
    if (hasDisplayDiscountSelected) {
      const displayTag = selectedTags.find((tag) => tag.type === 6);
      const promo = productData.promotion.find((p) => p.id === displayTag?.id);
      const dd = promo?.display_discount?.display_discount?.[0];
      const groupQty = dd ? parseInt(dd.order, 10) + 1 : 1;
      setQuantity((prev) => {
        const next = prev > groupQty ? prev - groupQty : groupQty;
        applyPromotionSelection(displayTag?.id, next);
        return next;
      });
      return;
    }

    if (hasFocSelected) {
      const focTag = selectedTags.find((tag) => tag.type === 4);
      if (!focTag) return;

      const minQty = 0;
      setQuantity((prev) => {
        const next = prev - stepValue >= minQty ? prev - stepValue : minQty;
        applyPromotionSelection(focTag.id, next);
        return next;
      });
      return;
    }

    setQuantity((prev) => {
      const next = prev - stepValue >= 0 ? prev - stepValue : 0;
      applyPromotionSelection(promotionId, next);
      return next;
    });
  }

  function handleIncrease() {
    // if (currentType === 5) {
    //   const displayTag = selectedTags.find((tag) => tag.type === 5);
    //   const maxQty = getPWPMaxQty();
    //   setQuantity((prev) => {
    //     const next = prev + stepValue <= maxQty ? prev + stepValue : prev;
    //     if (next !== prev) applyPromotionSelection(displayTag?.id, next);
    //     return next;
    //   });
    //   return;
    // }

    if (hasDisplayDiscountSelected) {
      const displayTag = selectedTags.find((tag) => tag.type === 6);
      const promo = productData.promotion.find((p) => p.id === displayTag?.id);
      const dd = promo?.display_discount?.display_discount?.[0];
      const groupQty = dd ? parseInt(dd.order, 10) + 1 : 1;
      const maxQty = getDisplayDiscountMaxQty();
      setQuantity((prev) => {
        const next = prev + groupQty <= maxQty ? prev + groupQty : prev;
        if (next !== prev) applyPromotionSelection(displayTag?.id, next);
        return next;
      });
      return;
    }

    if (hasFocSelected) {
      const focTag = selectedTags.find((tag) => tag.type === 4);
      if (!focTag) return;

      const [, offerIdPart] = focTag.id.split("_");
      if (String(offerIdPart) === "0") {
        const maxQty = getMaxQuantity();
        setQuantity((prev) => {
          const next = prev + stepValue <= maxQty ? prev + stepValue : prev;
          if (next !== prev) applyPromotionSelection(focTag.id, next);
          return next;
        });
        return;
      }

      const focPromo = productData.promotion.find((p) =>
        focTag.id.startsWith(p.id),
      );
      if (focPromo && focPromo.quantity_offer) {
        const offerId = focTag.id.split("_")[1];
        const focOffer = focPromo.quantity_offer.find(
          (qo) => String(qo.id) === String(offerId),
        );
        if (focOffer) {
          const maxQty = getFocMaxQty(focOffer, focPromo);
          setQuantity((prev) => {
            const next = prev + stepValue <= maxQty ? prev + stepValue : prev;
            if (next !== prev) applyPromotionSelection(focTag.id, next);
            return next;
          });
          return;
        }
      }
      return;
    }

    let maxQty;
    if (hasItemDiscountSelected && hasPwpSelected) {
      maxQty = getMaxQuantity();
    } else if (hasPwpSelected) {
      maxQty = getPWPMaxQty();
    } else {
      maxQty = getMaxQuantity();
    }

    setQuantity((prev) => {
      const next = prev + stepValue <= maxQty ? prev + stepValue : prev;
      if (next !== prev) applyPromotionSelection(promotionId, next);
      return next;
    });
  }

  function hasOnlyFreeGiftOrNoPromo(promotions) {
    if (!Array.isArray(promotions) || promotions.length === 0) return true;
    const nonFreeGiftPromos = promotions.filter(
      (p) => parseInt(p.promotion_type) !== 2,
    );
    return nonFreeGiftPromos.length === 0;
  }

  // 处理 ORP 弹窗
  const handleOrpClose = () => {
    setOrpMsg("");
    setPendingStep("");
    handleAddToCart({ orp: true });
  };

  // 修改 Notice 弹窗处理（用于 Term 和 Virtual）
  const handleNoticeClose = () => {
    const currentStep = pendingStep;
    setNotice({ show: false, message: "" });
    setPendingStep("");

    if (currentStep === "term") {
      handleAddToCart({ orp: true, term: true });
    } else if (currentStep === "virtual") {
      handleAddToCart({ orp: true, term: true, virtual: true });
    }
  };

  // 处理 BestDeal 弹窗
  const handlePromoTipClose = () => {
    setShowPromoTip(false);
    setPendingStep("");
    handleAddToCart({
      orp: true,
      term: true,
      virtual: true,
      bestDeal: true,
    });
  };

  const getProductImages = () => {
    const images = [];
    const seen = new Set();
    const push = (type, url, thumb) => {
      if (!url) return;
      if (seen.has(url)) return;
      seen.add(url);
      images.push({ type, url, thumb: thumb || url });
    };

    // For bundle: show package photo first, then all photos+videos from every bundle item
    if (
      productData?.package_item === "1" ||
      Array.isArray(productData?.bundle_items)
    ) {
      // package main photo first
      if (productData?.photo_url)
        push("image", productData.photo_url, productData.photo_url);

      const items = productData.bundle_items || [];
      for (const it of items) {
        // item videos (could be single string or array)
        if (it.item_video) {
          if (Array.isArray(it.item_video)) {
            it.item_video.forEach((v) =>
              push("video", v, it.item_photo?.[0]?.thumb_url || it.photo_url),
            );
          } else {
            push(
              "video",
              it.item_video,
              it.item_photo?.[0]?.thumb_url || it.photo_url,
            );
          }
        }
        // item_photo array
        if (Array.isArray(it.item_photo) && it.item_photo.length) {
          it.item_photo.forEach((p) => {
            const url = p.photo_url || p.image_url || p;
            const thumb = p.thumb_url || p.photo_url || p.image_url || url;
            push("image", url, thumb);
          });
        }
        // more_photo on item
        if (Array.isArray(it.more_photo) && it.more_photo.length) {
          it.more_photo.forEach((p) => {
            const url = p.photo_url || p.image_url || p;
            const thumb = p.thumb_url || p.photo_url || p.image_url || url;
            push("image", url, thumb);
          });
        }
      }

      return images;
    }

    // Non-bundle fallback (existing behavior)
    if (
      Array.isArray(productData?.item_videos) &&
      productData.item_videos.length
    ) {
      productData.item_videos.forEach((vid) =>
        push(
          "video",
          vid,
          productData.item_photo?.[0]?.thumb_url || productData.photo_url || "",
        ),
      );
    } else if (productData?.item_video) {
      push(
        "video",
        productData.item_video,
        productData.item_photo?.[0]?.thumb_url || productData.photo_url || "",
      );
    }

    if (productData?.photo_url)
      push("image", productData.photo_url, productData.photo_url);

    if (
      Array.isArray(productData?.item_photo) &&
      productData.item_photo.length > 0
    ) {
      productData.item_photo.forEach((p) => {
        const url = p.photo_url || p.image_url || p;
        const thumb = p.thumb_url || p.photo_url || p.image_url || url;
        push("image", url, thumb);
      });
    } else if (productData?.item_photo) {
      push("image", productData.item_photo, productData.item_photo);
    }

    if (
      Array.isArray(productData?.more_photo) &&
      productData.more_photo.length > 0
    ) {
      productData.more_photo.forEach((p) => {
        const url = p.photo_url || p.image_url || p.url || p;
        const thumb =
          p.thumb_url || p.thumb || p.photo_url || p.image_url || url;
        push("image", url, thumb);
      });
    }

    return images;
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      const video = videoRef.current;
      if (!video) return;

      // Check if the video is the fullscreen element
      const isFullscreen =
        document.fullscreenElement === video ||
        document.webkitFullscreenElement === video;

      if (isFullscreen) {
        video.muted = false;
      } else {
        video.muted = true; // Optional: mute when not fullscreen
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange,
      );
    };
  }, []);

  const handleMagazineClick = () => {
    const mag =
      product?.mag_link ||
      productData?.mag_link ||
      (productData?.bundle_items &&
        productData.bundle_items.find((it) => it.mag_link)?.mag_link) ||
      (productData?.bundle_items &&
        productData.bundle_items.find((it) => it.product && it.product.mag_link)
          ?.product.mag_link) ||
      "";

    if (mag) {
      window.open(mag, "_blank");
    }
  };

  const getPurchaseHistory = () => {
    if (!productData?.history || !Array.isArray(productData.history)) {
      return [];
    }

    const validHistory = productData.history.filter((item) => {
      return item.id && item.qty && item.inserted_date;
    });

    return validHistory.sort(
      (a, b) => new Date(b.inserted_date) - new Date(a.inserted_date),
    );
  };

  const getPackingDetails = () => {
    if (!productData?.packing || !Array.isArray(productData.packing))
      return { items: [], columnCount: 0 };

    const packingItems = productData.packing;
    const columnCount = packingItems.length + 1; // +1 for the label column

    return { items: packingItems, columnCount };
  };

  const handleMouseMove = (e) => {
    if (!imageRef.current) return;

    const elem = imageRef.current;
    const { left, top, width, height } = elem.getBoundingClientRect();

    const x = e.pageX - left - window.pageXOffset;
    const y = e.pageY - top - window.pageYOffset;

    // Calculate percentages with boundary checks
    const xPercent = Math.max(0, Math.min(100, (x / width) * 100));
    const yPercent = Math.max(0, Math.min(100, (y / height) * 100));

    // Update magnifier position
    setMagnifierPosition({ x: xPercent, y: yPercent });

    // Update cursor position for lens with boundary checks
    const lensX = Math.max(25, Math.min(width - 25, x));
    const lensY = Math.max(25, Math.min(height - 25, y));

    setCursorPosition({ x: lensX, y: lensY });
  };

  const handleMouseEnter = () => {
    setShowMagnifier(true);
  };

  const handleMouseLeave = () => {
    setShowMagnifier(false);
  };

  const handlePrevImage = () => {
    setSlideIndex((prev) => (prev > 0 ? prev - 1 : images.length - 1));
  };

  const handleNextImage = () => {
    setSlideIndex((prev) => (prev < images.length - 1 ? prev + 1 : 0));
  };

  const handleImageClick = () => {
    setShowImageModal(true);
    setShowMagnifier(false);
  };

  const handleCloseModal = () => {
    setShowImageModal(false);
  };

  const handlePlayIconClick = (e, idx) => {
    e.stopPropagation();
    setSlideIndex(idx);

    // Wait for the video to be rendered
    setTimeout(() => {
      const video = document.querySelector(".main-product-video");
      if (video) {
        video.play().catch((error) => {
          console.error("Error playing video:", error);
        });
      }
    }, 100);
  };

  // Footer visibility based on scroll position
  const [showFooter, setShowFooter] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setShowFooter(true);
      } else {
        setShowFooter(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Share functionality
  const shareMenuRef = useRef(null);
  const [showShareMenu, setShowShareMenu] = useState(false);
  const handleShareClick = () => {
    setShowShareMenu((prev) => !prev);
  };

  useEffect(() => {
    if (!showShareMenu) return;

    const handleClickOutside = (event) => {
      if (
        shareMenuRef.current &&
        !shareMenuRef.current.contains(event.target)
      ) {
        setShowShareMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showShareMenu]);

  const handleShareOption = (type) => {
    const shareUrl = window.location.href;
    const shareText = `Check out this product: ${product.item_name || ""}`;
    if (type === "facebook") {
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          shareUrl,
        )}`,
        "_blank",
      );
    } else if (type === "twitter") {
      window.open(
        `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          shareUrl,
        )}&text=${encodeURIComponent(shareText)}`,
        "_blank",
      );
    } else if (type === "whatsapp") {
      window.open(
        `https://wa.me/?text=${encodeURIComponent(shareText + " " + shareUrl)}`,
        "_blank",
      );
    } else if (type === "copy") {
      navigator.clipboard.writeText(shareUrl);
      alert("Link copied!");
    } else if (type === "webshare") {
      if (navigator.share) {
        navigator.share({
          title: product.item_name || "Product",
          text: shareText,
          url: shareUrl,
        });
      }
    }
    setShowShareMenu(false);
  };

  // Keep input display in sync when quantity is changed by buttons or external sources
  useEffect(() => {
    setQuantityInputStr(String(quantity));
  }, [quantity]);

  const selectedTags = getPromotionTags(productData?.promotion || []).filter(
    (tag) => selectedPromotionIds.includes(tag.id),
  );

  const getPromotionInfo = () => {
    if (
      productData?.promotion &&
      Array.isArray(productData.promotion) &&
      productData.promotion.length > 0
    ) {
      const promoTag = selectedTags.find((tag) => tag.type !== 2);
      if (promoTag) {
        const promo = productData.promotion.find(
          (p) =>
            promoTag.id.startsWith(p.id) &&
            parseInt(p.promotion_type) === promoTag.type,
        );
        // Handle Discount (type 3)
        if (
          promo &&
          parseInt(promo.promotion_type) === 3 &&
          promo.brand_price
        ) {
          return {
            minQty: parseInt(promo.brand_quantity || 1),
            price: parseFloat(promo.brand_price),
            promotion_id: promo.id,
          };
        }
        // Handle FOC (type 4)
        if (
          promo &&
          parseInt(promo.promotion_type) === 4 &&
          promo.quantity_offer
        ) {
          const offerId = promoTag.id.split("_")[1];
          const focOffer = promo.quantity_offer.find((qo) => qo.id === offerId);
          if (focOffer) {
            // If discount type
            if (focOffer.type === "1" && focOffer.discount) {
              const price = getQuantityOfferDiscountedPrice(promoTag.id);
              return {
                minQty: parseInt(focOffer.order || 1),
                price,
                promotion_id: promo.id,
              };
            } else {
              // Buy X Free Y: calculate effective unit price
              const buyQty = parseInt(focOffer.order, 10);
              const freeQty = parseInt(focOffer.foc, 10);
              const totalQty = buyQty + freeQty;
              const pricePerUnit =
                (parseFloat(pricing.brand_price || 0) * buyQty) / totalQty;
              return {
                minQty: buyQty,
                price: pricePerUnit,
                promotion_id: promo.id,
              };
            }
          }
        }
      }
    }
    return null;
  };

  const getDisplayPrice = () => {
    if (isLoggedIn && !productData?.filter_label?.includes("out_of_stock")) {
      const promo = getPromotionInfo();
      if (promo) {
        const result = {
          price: promo.price,
          original: parseFloat(pricing.brand_price),
          discount:
            promo.price < parseFloat(pricing.brand_price || 0)
              ? Math.round(
                  ((parseFloat(pricing.brand_price) - promo.price) /
                    parseFloat(pricing.brand_price)) *
                    100,
                )
              : 0,
        };
        return result;
      } else if (pricing.bundle_pricing) {
        const result = {
          price: parseFloat(pricing.bundle_pricing.final_brand_price || 0),
          original: null,
          discount: 0,
        };
        return result;
      }

      const result = {
        price: parseFloat(pricing.brand_price || 0),
        original: null,
        discount: 0,
      };
      return result;
    } else {
      const result = {
        price: parseFloat(pricing?.rcp ?? product.rcp ?? 0),
        original: null,
        discount: 0,
      };

      return result;
    }
  };

  const images = getProductImages();
  const packingDetails = getPackingDetails();
  const history = getPurchaseHistory();
  const promotionInfo = getPromotionInfo();
  const displayPrice = getDisplayPrice();
  // const isDiscontinued = product.status === "2";
  const isDiscontinued = productData?.filter_label?.includes("discontinued");

  function getPromotionTags(promotions = []) {
    const tags = [];
    let hasFreeGift = false;
    let hasPWP = false;
    let hasDisplayDiscount = false;
    let hasQuantityOffer = false;
    let hasItemDiscount = false;

    promotions.forEach((promo) => {
      switch (parseInt(promo.promotion_type)) {
        case 2: // Free Gift
          if (promo.free_gift && promo.free_gift.length > 0) {
            tags.push({
              id: promo.id,
              label: "Free Gift",
              type: 2,
              icon: <Gift size={14} />,
            });
            hasFreeGift = true;
          }
          break;

        case 3: // Discount
          tags.push({
            id: promo.id,
            label: `Item Discount`,
            type: 3,
            icon: <Tag size={14} />,
          });
          hasItemDiscount = true;
          break;

        case 4: // FOC / Quantity Offer
          if (promo.quantity_offer && promo.quantity_offer.length > 0) {
            const sortedOffers = [...promo.quantity_offer].sort((a, b) => {
              return String(a.id).localeCompare(String(b.id), undefined, {
                numeric: true,
              });
            });
            const maxId = sortedOffers[sortedOffers.length - 1]?.id;

            // Fake "offer_id 0" entry representing the base tier
            const firstOffer = sortedOffers[0];
            if (firstOffer) {
              tags.push({
                id: `${promo.id}_0`,
                label: firstOffer.type === "1" ? "No Discount" : "No FOC",
                type: 4,
                promoId: promo.id,
                offerId: "0",
                icon: <Tag size={14} />,
                isLast: false,
                order: "0",
                offerType: firstOffer.type,
                offerDiscount: "0",
              });
            }

            sortedOffers.forEach((offer) => {
              // FIX: string-normalize so a real offer with id 0 still compares correctly
              const isLast = String(offer.id) === String(maxId);
              let label;
              if (offer.type === "1" && offer.discount) {
                label = `Buy ${offer.order} - ${parseFloat(offer.discount)}% Off`;
              } else {
                label = `Buy ${offer.order} FOC ${offer.foc}`;
              }
              tags.push({
                id: `${promo.id}_${offer.id}`,
                label,
                type: 4,
                promoId: promo.id,
                offerId: String(offer.id), // FIX: normalize for downstream === comparisons
                icon: <Tag size={14} />,
                isLast,
                order: offer.order,
                offerType: offer.type,
                offerDiscount: offer.discount,
              });
              hasQuantityOffer = true;
            });
          }
          break;

        case 5: // PWP
          if (promo.pwp_info && Array.isArray(promo.pwp_info.pwp_info)) {
            promo.pwp_info.pwp_info.forEach((pwpEntry) => {
              tags.push({
                id: `${promo.id}_${pwpEntry.id}`, // composite, matches backend tag_id
                label: "PWP",
                type: 5,
                promoId: promo.id,
                pwpEntryId: pwpEntry.id,
                icon: <Tag size={14} />,
              });
              hasPWP = true;
            });
          }
          break;

        case 6: // Display Discount
          if (
            promo.display_discount &&
            promo.display_discount.display_discount &&
            promo.display_discount.display_discount.length > 0
          ) {
            promo.display_discount.display_discount.forEach((dd) => {
              tags.push({
                id: promo.id,
                label: `Display Discount`,
                type: 6,
                icon: <Tag size={14} />,
              });
              hasDisplayDiscount = true;
            });
          }
          break;
        default:
          break;
      }
    });

    // Add Normal Price tag if needed
    if (
      !hasItemDiscount &&
      (hasFreeGift || hasQuantityOffer || hasPWP || hasDisplayDiscount)
    ) {
      tags.unshift({
        id: "normal-price",
        label: "Normal Price",
        type: 0,
      });
    }

    // Always put Free Gift (type 2) first, then Normal Price (type 0)
    return tags.sort((a, b) => {
      if (a.type === 2 && b.type !== 2) return -1;
      if (a.type !== 2 && b.type === 2) return 1;
      if (a.type === 0 && b.type !== 0) return -1;
      if (a.type !== 0 && b.type === 0) return 1;
      return 0;
    });
  }

  const isPackageItem = product.package_item === "1";
  const brandQuantity = parseInt(pricing.brand_quantity || 1, 10);

  const package_seperate = product.package_seperate;
  const packing_quantity = parseInt(product.packing_quantity || 1, 10);

  const stepValue =
    isPackageItem && packing_quantity > 0 ? packing_quantity : 1;

  // Keep invalidPackingQty in sync with quantity regardless of how quantity changed
  useEffect(() => {
    if (isPackageItem && packing_quantity > 0) {
      setInvalidPackingQty(quantity % packing_quantity !== 0);
    } else {
      setInvalidPackingQty(false);
    }
  }, [quantity, isPackageItem, packing_quantity]);

  function handlePromotionTagClick(tagId) {
    setInvalidPackingQty(false);
    setInvalidDiscountQty(false);
    setInvalidBranchQty({});

    const tags = getPromotionTags(productData.promotion);
    const tag = tags.find((t) => t.id === tagId);
    if (!tag) return;

    // Free Gift不能取消选择
    if (tag.type === 2) return;

    // Prevent unpick if Item Discount is the only promotion
    const onlyItemDiscount = tags.length === 1 && tags[0].type === 3;
    if (
      onlyItemDiscount &&
      selectedPromotionIds.includes(tagId) &&
      tag.type === 3
    ) {
      // Don't allow unpick
      return;
    }

    const clampMainQtyToZero = () => {
      setQuantity(0);
      setInvalidPackingQty(false);
      setInvalidDiscountQty(false);
      return 0;
    };

    const resolveNewQty = (targetTag, isDeselecting = false) => {
      if (targetTag.type === 3) {
        // if (isDeselecting && hasPwpSelected) {
        //   const pwpMaxQty = getPWPMaxQty();
        //   const nextQty = Math.min(quantity, pwpMaxQty);
        //   setQuantity(nextQty);
        //   if (isPackageItem && packing_quantity > 0) {
        //     setInvalidPackingQty(pwpMaxQty % packing_quantity !== 0);
        //   } else {
        //     setInvalidPackingQty(false);
        //   }
        //   return pwpMaxQty;
        if (isDeselecting) {
          return clampMainQtyToZero();
        }
        return quantity;
      }

      if (targetTag.type === 4) {
        if (isDeselecting) {
          // if (hasPwpSelected) {
          //   const pwpMaxQty = getPWPMaxQty();
          //   // Only clamp down if current quantity exceeds the PWP limit —
          //   // don't force it up/down to pwpMaxQty when it's already valid.
          //   const nextQty = Math.min(quantity, pwpMaxQty);
          //   setQuantity(nextQty);
          //   if (isPackageItem && packing_quantity > 0) {
          //     setInvalidPackingQty(nextQty % packing_quantity !== 0);
          //   } else {
          //     setInvalidPackingQty(false);
          //   }
          //   return nextQty;
          // }
          // return quantity;
          return clampMainQtyToZero();
        }

        const newQty = parseInt(targetTag.order, 10);
        setQuantity(newQty);
        if (isPackageItem && packing_quantity > 0) {
          setInvalidPackingQty(newQty % packing_quantity !== 0);
        } else {
          setInvalidPackingQty(false);
        }
        return newQty;
      }

      if (targetTag.type === 5) {
        if (isDeselecting) {
          // Deselecting must actually clear this PWP's quantity back to 0 —
          // otherwise the stepper keeps showing the old qty (looking
          // "stuck") even though the tag is no longer selected.
          setPwpQuantities((prev) => ({
            ...prev,
            [targetTag.id]: 0,
          }));
          return quantity;
        }

        const promo = productData.promotion.find(
          (p) => p.id === targetTag.promoId,
        );
        let maxPwpQty = quantity;
        if (promo) {
          const promoQty = parseInt(promo.promo_qty, 10);
          let promoLimit =
            !isNaN(promoQty) && promoQty > 0 ? promoQty : getCurrentStock();

          if (freeGiftTag) {
            const freeGiftPromo = productData.promotion.find(
              (p) => p.id === freeGiftTag.id,
            );
            const fgPromoQty = parseInt(freeGiftPromo?.promo_qty, 10);
            const stock = getCurrentStock();
            promoLimit = Math.min(
              promoLimit,
              isNaN(fgPromoQty) ? stock : Math.min(fgPromoQty, stock),
            );
          }

          maxPwpQty = Math.min(maxPwpQty, promoLimit);
        }

        // Selecting a PWP tag directly (not via the "+" stepper): only
        // default its quantity to 1 if it's currently 0/unset. If it already
        // has a quantity (e.g. left over from a prior selection), keep it —
        // just clamp down to the current max if needed.
        setPwpQuantities((prev) => {
          const existingQty = prev[targetTag.id] || 0;
          const nextQty =
            existingQty === 0
              ? Math.min(1, maxPwpQty)
              : Math.min(existingQty, maxPwpQty);
          return {
            ...prev,
            [targetTag.id]: nextQty,
          };
        });

        return quantity;
      }

      if (targetTag.type === 6) {
        if (isDeselecting) {
          return clampMainQtyToZero();
        }
        return quantity;
      }

      return quantity;
    };

    // 检查是否已选中
    const isSelected = selectedPromotionIds.includes(tagId);

    // 判断是否有Free Gift
    const freeGiftTag = tags.find((t) => t.type === 2);

    // Display Discount(type 6) 和其它所有促销互斥（包括 PWP），选中它时
    // 清掉其余非 Free Gift 的标签；取消时切回其它可用标签之一。
    if (tag.type === 6) {
      if (isSelected) {
        const otherTags = tags.filter((t) => t.type !== 2 && t.id !== tagId);
        if (otherTags.length > 0) {
          const nextTag = otherTags[0];
          resolveNewQty(nextTag);
          setSelectedPromotionIds(
            freeGiftTag ? [freeGiftTag.id, nextTag.id] : [nextTag.id],
          );
        } else {
          resolveNewQty(tag, true);
          setSelectedPromotionIds(freeGiftTag ? [freeGiftTag.id] : []);
        }
        return;
      }

      resolveNewQty(tag);
      setSelectedPromotionIds(freeGiftTag ? [freeGiftTag.id, tagId] : [tagId]);
      return;
    }

    // Free Gift(2)/Discount(3)/Quantity Offer(4)/PWP(5) 之间：
    // - Free Gift 一旦有其它促销可选，不能取消到零，只能切换。
    // - Discount(3)/Quantity Offer(4) 互相互斥（商品自身的促销只能选一个）。
    // - PWP(5) 可以和 Free Gift / Discount / Quantity Offer 同时选中。
    const hasOtherPromos = tags.some((t) => t.type !== 2);
    if (freeGiftTag && hasOtherPromos && isSelected) {
      const switchableTags = tags.filter(
        (t) => t.type !== 2 && t.type !== 5 && t.id !== tagId,
      );
      if (switchableTags.length === 0) {
        // Nothing left to fall back to for the item's own promo — just unpick.
        resolveNewQty(tag, true);
        setSelectedPromotionIds((prev) => prev.filter((id) => id !== tagId));
        return;
      }
    }

    resolveNewQty(tag, isSelected);

    if (isSelected) {
      setSelectedPromotionIds((prev) => prev.filter((id) => id !== tagId));
      return;
    }

    setSelectedPromotionIds((prev) => {
      // Dropping any previously selected Display Discount — it cannot
      // coexist with Free Gift/Discount/Quantity Offer/PWP.
      const withoutDisplayDiscount = prev.filter((id) => {
        const t = tags.find((tt) => tt.id === id);
        return !t || t.type !== 6;
      });

      if (tag.type === 5) {
        // PWP stacks on top of whatever else is already selected.
        return [...withoutDisplayDiscount, tagId];
      }

      // tag.type === 3 or 4: the item's own promo — mutually exclusive with
      // any other type 3/4 already selected, but keeps PWP (type 5) intact.
      const withoutSameGroup = withoutDisplayDiscount.filter((id) => {
        const t = tags.find((tt) => tt.id === id);
        return !t || (t.type !== 3 && t.type !== 4);
      });
      return [...withoutSameGroup, tagId];
    });
  }

  // const notforsell = product?.out_of_stock === "1";
  const notforsell = productData?.filter_label?.includes("not_for_sell");
  const mustPromotion = pricing?.[0]?.must_promotion === "1";
  const hasFreeGiftSelected = selectedTags.some((tag) => tag.type === 2);
  const allFocTags = getPromotionTags(productData?.promotion || []).filter(
    (tag) => tag.type === 4,
  );
  const lastFocTag = allFocTags[allFocTags.length - 1];
  const currentFocTag = allFocTags.find((tag) =>
    selectedPromotionIds.includes(tag.id),
  );
  const isCurrentFocLast = !!(
    currentFocTag &&
    lastFocTag &&
    currentFocTag.id === lastFocTag.id
  );
  const currentFocOrder = currentFocTag ? parseInt(currentFocTag.order, 10) : 1;
  const focTag = selectedTags.find((tag) => tag.type === 4);
  // const currentType =
  //   focTag && isCurrentFocLast
  //     ? 4
  //     : selectedTags.length > 0
  //       ? selectedTags[selectedTags.length - 1].type
  //       : null;
  const hasItemDiscountSelected = selectedTags.some((tag) => tag.type === 3);
  const hasFocSelected = selectedTags.some((tag) => tag.type === 4);
  const hasPwpSelected = selectedTags.some((tag) => tag.type === 5);
  const hasDisplayDiscountSelected = selectedTags.some((tag) => tag.type === 6);
  // const isFocQtyExceeded = hasFocSelected && quantity > getFocMaxQty();

  // 检查Free Gift库存限制
  let freeGiftOutOfStock = false;
  const freeGiftTag = selectedTags.find((tag) => tag.type === 2);

  if (freeGiftTag) {
    const freeGiftPromo = (productData?.promotion || []).find(
      (p) => p.id === freeGiftTag.id,
    );
    if (freeGiftPromo?.promo_qty) {
      // 计算需要的Free Gift总数量
      let totalFreeGiftNeeded = quantity;

      if (totalFreeGiftNeeded > parseInt(freeGiftPromo.promo_qty)) {
        freeGiftOutOfStock = true;
      }
    }
  }

  const canBuy = !productData?.filter_label?.includes("out_of_stock");

  // 获取最大可选择数量
  function getMaxQuantity() {
    let maxQty = getCurrentStock();

    // 如果选中了Free Gift，需要根据Free Gift库存限制
    const freeGiftTag = selectedTags.find((tag) => tag.type === 2);
    if (freeGiftTag) {
      const promo = (productData?.promotion || []).find(
        (p) => p.id === freeGiftTag.id,
      );
      if (promo?.promo_qty) {
        const freeGiftLimit = parseInt(promo.promo_qty, 10);

        // 直接用Free Gift限制
        maxQty = Math.min(maxQty, freeGiftLimit);
      }
    }

    return maxQty;
  }

  function getPWPMaxQty() {
    const displayTag = selectedTags.find((tag) => tag.type === 5);
    if (!displayTag) throw new Error("No PWP promotion selected.");

    const promo = productData.promotion.find(
      (p) => p.id === displayTag.promoId,
    );
    if (!promo)
      throw new Error(`PWP promotion id "${displayTag.id}" not found.`);

    const promoQty = parseInt(promo.promo_qty, 10);
    if (isNaN(promoQty) || promoQty <= 0) return getCurrentStock();

    let maxQty = promoQty;
    const freeGiftTag = selectedTags.find((tag) => tag.type === 2);
    if (freeGiftTag) {
      const freeGiftPromo = productData.promotion.find(
        (p) => p.id === freeGiftTag.id,
      );
      const fgPromoQty = parseInt(freeGiftPromo?.promo_qty, 10);
      const stock = getCurrentStock();
      maxQty = Math.min(
        maxQty,
        isNaN(fgPromoQty) ? stock : Math.min(fgPromoQty, stock),
      );
    }

    return maxQty;
  }

  // Keep every selected PWP's quantity from exceeding the main item quantity.
  // If quantity drops to 0, no PWP can have a nonzero quantity — clamp them
  // all to 0 and deselect any PWP tag that had a quantity, since a "selected"
  // PWP with 0 quantity is an inconsistent state.
  useEffect(() => {
    if (quantity === 0) {
      const idsToClear = Object.keys(pwpQuantities).filter(
        (tagId) => (pwpQuantities[tagId] || 0) > 0,
      );

      if (idsToClear.length === 0) return;

      setPwpQuantities((prev) => {
        const next = { ...prev };
        idsToClear.forEach((tagId) => {
          next[tagId] = 0;
        });
        return next;
      });

      setSelectedPromotionIds((prev) =>
        prev.filter((id) => !idsToClear.includes(id)),
      );
      return;
    }

    // Otherwise just clamp any PWP quantity that now exceeds the main qty.
    setPwpQuantities((prev) => {
      let changed = false;
      const next = { ...prev };
      Object.keys(next).forEach((tagId) => {
        if ((next[tagId] || 0) > quantity) {
          next[tagId] = quantity;
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [quantity]);

  function getDisplayDiscountMaxQty() {
    const displayTag = selectedTags.find((tag) => tag.type === 6);
    if (!displayTag) throw new Error("No Display Discount promotion selected.");

    const promo = productData.promotion.find((p) => p.id === displayTag.id);
    if (!promo)
      throw new Error(
        `Display Discount promotion id "${displayTag.id}" not found.`,
      );

    const promoQty = parseInt(promo.promo_qty, 10);
    if (isNaN(promoQty) || promoQty <= 0)
      throw new Error(`Invalid promo_qty for promotion id "${promo.id}".`);

    let maxQty = promoQty;

    const freeGiftTag = selectedTags.find((tag) => tag.type === 2);
    if (freeGiftTag) {
      const freeGiftPromo = productData.promotion.find(
        (p) => p.id === freeGiftTag.id,
      );
      const fgPromoQty = parseInt(freeGiftPromo?.promo_qty, 10);
      const stock = getCurrentStock();
      maxQty = Math.min(
        maxQty,
        isNaN(fgPromoQty) ? stock : Math.min(fgPromoQty, stock),
      );
    }

    return maxQty;
  }

  function getFocMaxQty() {
    const displayTag = selectedTags.find((tag) => tag.type === 4);
    if (!displayTag) throw new Error("No Quantity Offer promotion selected.");

    const [promoId, offerId] = displayTag.id.split("_");

    if (String(offerId) === "0") {
      return getMaxQuantity();
    }

    const promo = productData.promotion.find((p) => p.id === promoId);
    if (!promo)
      throw new Error(`Quantity Offer promotion id "${promoId}" not found.`);

    const offer = promo.quantity_offer?.find((qo) => qo.id === offerId);
    if (!offer)
      throw new Error(
        `Quantity offer id "${offerId}" not found in promotion "${promoId}".`,
      );

    const promoQty = parseInt(promo.promo_qty, 10);
    if (isNaN(promoQty) || promoQty <= 0) return getCurrentStock();

    // promo_qty = max units of main product that can be ordered (FOC items don't count against it)
    let maxQty = Math.min(getCurrentStock(), promoQty);

    const freeGiftTag = selectedTags.find((tag) => tag.type === 2);
    if (freeGiftTag) {
      const freeGiftPromo = productData.promotion.find(
        (p) => p.id === freeGiftTag.id,
      );
      const fgPromoQty = parseInt(freeGiftPromo?.promo_qty, 10);
      const stock = getCurrentStock();
      const fgLimit = isNaN(fgPromoQty) ? stock : Math.min(fgPromoQty, stock);
      maxQty = Math.min(maxQty, fgLimit);
    }

    return maxQty;
  }

  function getFreeGiftQty(promo, qty, focOffer = null, focOfferType) {
    if (!promo?.free_gift?.length) return 0;
    // 只要传了 focOffer，就加上送的数量
    if (focOffer && focOfferType !== "1") {
      const times = Math.floor(qty / focOffer.order);
      const focQty = times * focOffer.foc;
      return qty + focQty;
    }
    // 其它类型，送 qty 个
    return qty;
  }

  function getItemDiscountPricePerUnit(promo) {
    if (!promo || !promo.brand_price) return "0.00";
    return formatCurrency(promo.brand_price);
  }

  // function getFocPricePerUnit(selectedTags, productData, quantity) {
  //   const focTag = selectedTags.find((tag) => tag.type === 4);
  //   if (focTag) {
  //     const focPromo = productData.promotion.find((p) =>
  //       focTag.id.startsWith(p.id),
  //     );
  //     if (focPromo && focPromo.quantity_offer) {
  //       const offerId = focTag.id.split("_")[1];
  //       const focOffer = focPromo.quantity_offer.find(
  //         (qo) => qo.id === offerId,
  //       );
  //       if (focOffer) {
  //         const totalqty =
  //           quantity + focOffer.foc * Math.floor(quantity / focOffer.order);
  //         const postdiscount_subtotal = pricing.brand_price * quantity;
  //         const postdiscount_priceperunit = postdiscount_subtotal / totalqty;
  //         return postdiscount_priceperunit
  //           ? formatCurrency(postdiscount_priceperunit)
  //           : "0.00";
  //       }
  //     }
  //   }
  //   return "0.00";
  // }

  // function getFocDiscountPricePerUnit(selectedTags, productData) {
  //   // Find the selected FOC tag with discount (offerType === "1")
  //   const focTag = selectedTags.find(
  //     (tag) => tag.type === 4 && tag.offerType === "1",
  //   );
  //   if (!focTag || !pricing?.brand_price || !focTag.offerDiscount) {
  //     return "0.00";
  //   }
  //   const brandPrice = parseFloat(pricing.brand_price);
  //   const discount = parseFloat(focTag.offerDiscount);
  //   // Calculate discounted unit price
  //   const postdiscount_subtotal = (brandPrice * (100 - discount)) / 100;
  //   return postdiscount_subtotal ? postdiscount_subtotal.toFixed(2) : "0.00";
  // }

  function getQuantityOfferDiscountedPrice(tagId) {
    const promos = promotionForDisplay || [];
    for (const promo of promos) {
      if (promo.tag_type !== 4) continue;
      const offer = (promo.quantity_offers || []).find(
        (qo) => String(qo.tag_id) === String(tagId),
      );
      if (offer?.discounted_price) {
        return parseFloat(offer.discounted_price);
      }
    }
    return null;
  }

  function getFocPricePerUnit(selectedTags) {
    const focTag = selectedTags.find(
      (tag) => tag.type === 4 && tag.offerType === "0",
    );
    if (!focTag) return "0.00";

    const tagId = String(focTag.id);
    const promos = promotionForDisplay || [];
    for (const promo of promos) {
      if (promo.tag_type !== 4) continue;
      const offer = (promo.quantity_offers || []).find(
        (qo) => String(qo.tag_id) === tagId,
      );
      if (offer?.discounted_price) {
        return formatCurrency(offer.discounted_price);
      }
    }
    return "0.00";
  }

  function getFocDiscountPricePerUnit(selectedTags) {
    const focTag = selectedTags.find(
      (tag) => tag.type === 4 && tag.offerType === "1",
    );
    if (!focTag) return "0.00";

    const tagId = String(focTag.id);
    const promos = promotionForDisplay || [];
    for (const promo of promos) {
      if (promo.tag_type !== 4) continue;
      const offer = (promo.quantity_offers || []).find(
        (qo) => String(qo.tag_id) === tagId,
      );
      if (offer?.discounted_price) {
        return formatCurrency(offer.discounted_price);
      }
    }
    return "0.00";
  }

  function getDisplayDiscountPricePerUnit(displayDiscount, displayPricing) {
    if (!displayDiscount || !displayPricing || !displayPricing.brand_price)
      return "0.00";
    const normalPrice = parseFloat(displayPricing.brand_price);
    const discountPrice =
      (normalPrice * (100 - displayDiscount.discount)) / 100;
    return formatCurrency(discountPrice);
  }

  function handlePwpQuantityInputChange(e, tagId) {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) return;
    let numValue = parseInt(value, 10);
    if (isNaN(numValue)) numValue = 0;
    if (numValue < 0) numValue = 0;

    const maxQty = selectedTags.some((t) => t.type === 5)
      ? Math.min(getPWPMaxQty(), quantity)
      : quantity;
    if (numValue > maxQty) numValue = maxQty;

    setPwpQuantities((prev) => ({
      ...prev,
      [tagId]: numValue,
    }));
  }

  function getSelectedPromotionsForDisplay() {
    const promos = promotionForDisplay || [];
    const allTagsFlat = [];

    promos.forEach((promo) => {
      if (promo.tag_type === 4) {
        (promo.quantity_offers || [])
          .filter((qo) => qo.offer_id !== 0 && qo.offer_id !== "0")
          .forEach((qo) => {
            allTagsFlat.push({ id: qo.tag_id, type: 4, promo, offer: qo });
          });
      } else {
        allTagsFlat.push({
          id: promo.tag_id ?? promo.id,
          type: promo.tag_type,
          promo,
        });
      }
    });

    return allTagsFlat.filter(
      (tag) =>
        selectedPromotionIds.includes(tag.id) && tag.id !== "normal-price",
    );
  }

  function renderSelectedPromotion() {
    const selectedTagsSorted = getSelectedPromotionsForDisplay();

    if (selectedTagsSorted.length === 0) return null;

    // Shared styling per promo type — color + fixed badge text
    const TYPE_STYLE = {
      2: { color: "green", badge: null },
      3: { color: "orange", badge: null }, // badge falls back to promo.tag_text
      5: { color: "blue", badge: null },
      6: { color: "yellow", badge: null },
      4: { color: "purple", badge: "VOLUME" },
    };

    return (
      <div>
        {selectedTagsSorted.map((tag) => {
          const promo = tag.promo;
          const focOffer = tag.type === 4 ? tag.offer : null;
          const style = TYPE_STYLE[tag.type];
          if (!style) return null;

          let price = null;
          let discount = null;
          let badgeText = style.badge ?? promo.tag_text;

          if (tag.type === 2 && promo.free_gift) {
            const freeGiftQty = quantity + focTotal;
            price = (
              <span className="selectpromotion-price">
                Free Gift x{freeGiftQty}
              </span>
            );
            discount = (
              <span className={`selectpromotion-discount ${style.color}`}>
                FREE
              </span>
            );
            badgeText = promo.tag_text;
          } else if (tag.type === 4 && focOffer) {
            price = (
              <span className="selectpromotion-price">
                {focOffer.selected_text_1}
              </span>
            );
            discount = (
              <span className={`selectpromotion-discount ${style.color}`}>
                {focOffer.selected_text_2}
              </span>
            );
          } else if (
            tag.type === 3 ||
            (tag.type === 5 && promo.pwp_info && promo.pwp_pricing) ||
            (tag.type === 6 && promo.display_discount && promo.dd_pricing)
          ) {
            price = (
              <span className="selectpromotion-price">
                RM{" "}
                {promo.discount_price
                  ? formatCurrency(promo.discount_price)
                  : "0.00"}
              </span>
            );
            discount = (
              <span className={`selectpromotion-discount ${style.color}`}>
                -{Math.round(promo.discount_pct)}%
              </span>
            );
          }

          return (
            <div key={tag.id} style={{ position: "relative" }}>
              <div className={`selectpromotion-branch ${style.color}border`}>
                <div className={`allpromotion-discount-badge ${style.color}`}>
                  {badgeText}
                </div>

                <div className="selectpromotion-left">
                  <FallbackImg
                    ref={promotionMagnifierRef}
                    src={promo.thumb_url}
                    alt={badgeText}
                    width="40"
                    height="40"
                    onClick={() => handlePromotionImageClick(promo.img_url)}
                    style={{ cursor: "pointer" }}
                  />
                </div>

                <div className="selectpromotion-right">
                  <div>
                    <div className="allpromotion-branch-code">
                      {promo.item_code}
                    </div>
                    {price}
                  </div>
                  {discount}
                </div>
              </div>

              {showPromotionImageModal && (
                <div
                  className="image-modal"
                  onClick={() => setShowPromotionImageModal(false)}
                >
                  <div
                    className="image-modal-content"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      className="modal-close"
                      onClick={() => setShowPromotionImageModal(false)}
                    >
                      <X size={16} />
                    </button>
                    <FallbackImg
                      src={modalPromotionImageUrl}
                      alt="Promotion"
                      className="modal-image"
                    />
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  const handleQuantityInputChange = (e) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) return;
    setQuantityInputStr(value);
    if (value === "") return;
    let numValue = parseInt(value);
    if (isNaN(numValue)) return;

    if (hasDisplayDiscountSelected) {
      setInvalidPackingQty(false);

      const displayTag = selectedTags.find((tag) => tag.type === 6);
      const promo = productData.promotion.find((p) => p.id === displayTag?.id);
      const dd = promo?.display_discount?.display_discount?.[0];
      const groupQty = dd ? parseInt(dd.order, 10) + 1 : 1;
      const maxQty = getDisplayDiscountMaxQty();
      if (numValue % groupQty !== 0) {
        setInvalidDiscountQty(true);
      } else {
        setInvalidDiscountQty(false);
      }
      if (numValue > maxQty) {
        setNotice({
          show: true,
          noticeTitle: "Quantity Limit Reached",
          message: `The quantity you selected exceeds available stock. Only ${maxQty} items are currently available.`,
          yesText: "Noted",
        });
        setPendingStep("quantity");
        setQuantity(groupQty); // <-- set to lowest allowed groupQty
        setQuantityInputStr(String(groupQty));
        return;
      }
      setQuantity(numValue);
      return;
    }

    let maxQty;
    if (hasFocSelected && hasPwpSelected) {
      maxQty = getFocMaxQty();
    } else if (hasItemDiscountSelected && hasPwpSelected) {
      maxQty = getMaxQuantity();
    } else if (hasPwpSelected) {
      maxQty = getPWPMaxQty();
    } else if (hasFocSelected) {
      maxQty = getFocMaxQty();
    } else {
      maxQty = getMaxQuantity();
    }

    if (numValue > maxQty) {
      setNotice({
        show: true,
        noticeTitle: "Quantity Limit Reached",
        message: `The quantity you selected exceeds available stock. Only ${maxQty} items are currently available.`,
      });
      setPendingStep("quantity");
      let finalQty;
      if (hasFocSelected && currentFocOrder) {
        finalQty = currentFocOrder;
      } else {
        finalQty = 0;
      }
      setQuantity(finalQty);
      setQuantityInputStr(String(finalQty));

      // Check if the finalQty is a valid multiple for package items
      if (
        isPackageItem &&
        packing_quantity > 0 &&
        finalQty % packing_quantity !== 0
      ) {
        setInvalidPackingQty(true);
      } else {
        setInvalidPackingQty(false);
      }
    } else {
      setQuantity(numValue);
    }
  };

  const focTotal = (() => {
    const focTag = selectedTags.find((tag) => tag.type === 4);
    if (focTag) {
      const focPromo = productData.promotion.find((p) =>
        focTag.id.startsWith(p.id),
      );
      if (focPromo && focPromo.quantity_offer) {
        const offerId = focTag.id.split("_")[1];
        const focOffer = focPromo.quantity_offer.find(
          (qo) => qo.id === offerId,
        );
        if (focOffer) {
          const order = parseInt(focOffer.order, 10);
          const foc = parseInt(focOffer.foc, 10);
          return Math.floor(quantity / order) * foc;
        }
      }
    }
    return 0;
  })();

  const displayDiscountTag = selectedTags.find((tag) => tag.type === 6);
  let displayDiscountInfo = null;
  let groupQty = 1;
  if (displayDiscountTag) {
    const promo = productData.promotion.find(
      (p) => p.id === displayDiscountTag.id,
    );
    const dd = promo?.display_discount?.display_discount?.[0];
    const displayPricing = promo?.display_discount?.pricing;
    if (dd && displayPricing) {
      const normalPrice = parseFloat(displayPricing.brand_price || 0);
      const discountPrice = (normalPrice * (100 - dd.discount)) / 100;
      const orderQty = parseInt(dd.order, 10);
      const groupQty = orderQty + 1;
      displayDiscountInfo = {
        normalPrice,
        discountPrice,
        orderQty,
        groupQty,
        discount: dd.discount,
      };
    }
    if (dd && dd.order) {
      groupQty = parseInt(dd.order, 10) + 1;
    }
  }

  function getBestPromotionId(promotions = [], pricing) {
    let bestId = null;
    let minUnitPrice = Number.POSITIVE_INFINITY;

    promotions.forEach((promo) => {
      // Item Discount (type 3)
      if (parseInt(promo.promotion_type) === 3 && promo.brand_price) {
        const unitPrice = parseFloat(promo.brand_price);
        if (unitPrice < minUnitPrice) {
          minUnitPrice = unitPrice;
          bestId = promo.id;
        }
      }

      // Display Discount (type 6)
      // if (
      //   parseInt(promo.promotion_type) === 6 &&
      //   promo.display_discount?.display_discount?.[0]
      // ) {
      //   const dd = promo.display_discount.display_discount[0];
      //   if (dd.order && dd.discount && pricing?.brand_price) {
      //     const buyQty = parseInt(dd.order, 10);
      //     const totalQty = buyQty + 1;
      //     const discountPrice =
      //       (parseFloat(pricing.brand_price) * (100 - dd.discount)) / 100;
      //     const totalPrice =
      //       buyQty * parseFloat(pricing.brand_price) + discountPrice;
      //     const unitPrice = totalPrice / totalQty;
      //     if (unitPrice < minUnitPrice) {
      //       minUnitPrice = unitPrice;
      //       bestId = promo.id;
      //     }
      //   }
      // }

      // Buy X Free Y (type 4) - 多个方案
      if (
        parseInt(promo.promotion_type) === 4 &&
        Array.isArray(promo.quantity_offer)
      ) {
        promo.quantity_offer.forEach((offer) => {
          const buyQty = parseInt(offer.order, 10);

          /// Buy X Discount Y
          if (offer.type === "1" && offer.discount) {
            const tagId = `${promo.id}_${offer.id}`;
            const pricePerUnit = getQuantityOfferDiscountedPrice(tagId);
            // 这里Buy X Discount Y通常是买X件都打折，不送
            // 计算平均单价
            if (buyQty > 0 && pricePerUnit !== null) {
              const unitPrice = pricePerUnit;
              if (unitPrice < minUnitPrice) {
                minUnitPrice = unitPrice;
                bestId = tagId;
              }
            }
          }
          // Buy X Free Y
          else {
            const freeQty = parseInt(offer.foc, 10);
            const totalQty = buyQty + freeQty;
            // 用原价或促销价
            const pricePerUnit = parseFloat(pricing.brand_price);
            // 总价 = buyQty * 单价
            const totalPrice = buyQty * pricePerUnit;
            if (totalQty > 0) {
              const unitPrice = totalPrice / totalQty;
              const tagId = `${promo.id}_${offer.id}`;
              if (unitPrice < minUnitPrice) {
                minUnitPrice = unitPrice;
                bestId = tagId;
              }
            }
          }
        });
      }
    });
    return bestId;
  }
  const bestId = getBestPromotionId(productData?.promotion, pricing);
  const isBest = selectedPromotionIds.includes(bestId);

  let freegiftItems = [];
  if (freeGiftTag) {
    const promo = productData.promotion.find((p) => p.id === freeGiftTag.id);
    if (promo && Array.isArray(promo.free_gift)) {
      freegiftItems = promo.free_gift.map((fg) => ({
        free_gift_id: fg.promotion_id,
        item_id: fg.free_gift_item_id,
      }));
    }
  }

  function getBestDealLabel() {
    if (!bestId) return "";

    const tags = getPromotionTags(productData.promotion);
    const tag = tags.find((t) => t.id === bestId);
    if (!tag) return "";

    // For FOC, show label like "Buy 3 Free 1"
    if (tag.type === 4) return `Best Deal: ${tag.label}`;

    return `Best Deal: ${tag.label}`;
  }

  const freegiftId = freeGiftTag ? freeGiftTag.id : "";

  // 取 promotionId：商品自身的促销（type 3/4/6），不含 PWP —— PWP 现在
  // 可以和它同时被选中，所以要单独取，不能互相覆盖。
  const promoTag = selectedTags.find((tag) => tag.type !== 2 && tag.type !== 5);
  const promotionId =
    promoTag && promoTag.id !== "normal-price" ? promoTag.id : "";

  // PWP 促销 id，独立于商品自身的促销。多个 PWP 可以同时选中时，这里只取
  // 第一个用于主商品行上的关联展示；每个 PWP 加购品自己真正的 promotion_id
  // 是通过 cargo_pwp_distribution 数组逐条传的，不受这里影响。
  const pwpTag = selectedTags.find((tag) => tag.type === 5);
  const pwpPromotionId = pwpTag ? pwpTag.id : "";

  const formatProductCategory = (item) => {
    const arr = [];

    // spec value
    for (let i = 1; i <= 3; i++) {
      const value = item[`spec_${i}`];
      const sequence = Number(item[`spec_sequence_${i}`]);
      if (value && [1, 2, 3].includes(sequence)) {
        arr.push({ value, sequence });
      }
    }
    // spec desc
    for (let i = 1; i <= 3; i++) {
      const desc = item[`spec_desc_${i}`];
      const desc_sequence = Number(item[`spec_desc_sequence_${i}`]);
      if (desc && [1, 2, 3].includes(desc_sequence)) {
        arr.push({ value: desc, sequence: desc_sequence });
      }
    }
    // feature value
    for (let i = 1; i <= 3; i++) {
      const value = item[`features_${i}`];
      const sequence = Number(item[`features_sequence_${i}`]);
      if (value && [1, 2, 3].includes(sequence)) {
        arr.push({ value, sequence });
      }
    }
    // feature desc
    for (let i = 1; i <= 3; i++) {
      const desc = item[`features_desc_${i}`];
      const desc_sequence = Number(item[`features_desc_sequence_${i}`]);
      if (desc && [1, 2, 3].includes(desc_sequence)) {
        arr.push({ value: desc, sequence: desc_sequence });
      }
    }

    // 按 sequence 排序
    arr.sort((a, b) => a.sequence - b.sequence);

    // 拼接
    return arr.map((x) => x.value).join(" . ");
  };

  const isOutOfStock_YouMayAlsoLike = (item, pricing, isLoggedIn) => {
    if (!isLoggedIn) {
      return pricing.displayPrice === 0;
    } else {
      return (
        parseInt(item.stock_quantity || 0) === 0 || pricing.displayPrice === 0
      );
    }
  };

  const getProductPricing = (item, isLoggedIn) => {
    const lowestPrice = parseFloat(item.lowest_price || 0);
    const brandPrice = parseFloat(item.brand_price || 0);

    if (lowestPrice > 0) {
      let discountPercent = 0;
      if (brandPrice > 0 && lowestPrice < brandPrice) {
        discountPercent = Math.round(
          ((brandPrice - lowestPrice) / brandPrice) * 100,
        );
      }
      return {
        displayPrice: lowestPrice,
        originalPrice:
          brandPrice > 0 && lowestPrice < brandPrice ? brandPrice : null,
        discountPercent,
      };
    }

    // 优先查找 type 3 promotion
    const type3Promo = (item.promotions || []).find(
      (promo) => String(promo.promotion_type) === "3",
    );
    if (type3Promo && type3Promo.brand_price) {
      const brandPrice = parseFloat(item.brand_price || 0);
      const promoPrice = parseFloat(type3Promo.brand_price || 0);
      let discountPercent = 0;
      if (promoPrice > 0 && promoPrice < brandPrice) {
        discountPercent = Math.round(
          ((brandPrice - promoPrice) / brandPrice) * 100,
        );
      }
      return {
        displayPrice: promoPrice,
        originalPrice: brandPrice,
        discountPercent,
      };
    }

    // 其它类型按原有逻辑
    if (isLoggedIn) {
      const brandPrice = parseFloat(item.brand_price || 0);
      const promotionPrice = parseFloat(item.promotion_price || 0);

      let displayPrice = brandPrice;
      let originalPrice = null;
      let discountPercent = 0;

      if (promotionPrice > 0 && promotionPrice < brandPrice) {
        displayPrice = promotionPrice;
        originalPrice = brandPrice;
        discountPercent = Math.round(
          ((brandPrice - promotionPrice) / brandPrice) * 100,
        );
      }

      return {
        displayPrice,
        originalPrice,
        discountPercent,
      };
    } else {
      const rcp = parseFloat(item.rcp || 0);
      return {
        displayPrice: rcp,
        originalPrice: null,
        discountPercent: 0,
      };
    }
  };

  const handlePromotionMagnifierMouseMove = (e) => {
    if (!promotionMagnifierRef.current) return;
    const elem = promotionMagnifierRef.current;
    const { left, top, width, height } = elem.getBoundingClientRect();
    const x = e.pageX - left - window.pageXOffset;
    const y = e.pageY - top - window.pageYOffset;
    const xPercent = Math.max(0, Math.min(100, (x / width) * 100));
    const yPercent = Math.max(0, Math.min(100, (y / height) * 100));
    setPromotionMagnifierPosition({ x: xPercent, y: yPercent });
    const lensX = Math.max(75, Math.min(width - 75, x));
    const lensY = Math.max(75, Math.min(height - 75, y));
  };

  const handlePromotionMagnifierEnter = (imgUrl) => {
    setPromotionMagnifierImg(imgUrl);
    setShowPromotionMagnifier(true);
  };

  const handlePromotionMagnifierLeave = () => {
    setShowPromotionMagnifier(false);
  };

  function handlePromotionImageClick(imgUrl) {
    setModalPromotionImageUrl(imgUrl);
    setShowPromotionImageModal(true);
  }

  const getSubtotal = ({
    tag,
    promo,
    pwpInfo,
    pwpPricing,
    pwpQty,
    displayDiscount,
    displayPricing,
    focOffer,
    productData,
    quantity,
  }) => {
    let qty = quantity;
    let subtotal = null;

    // Item Discount
    if (tag.type === 3 && promo) {
      subtotal = promo.brand_price * qty;
    }

    // PWP
    else if (tag.type === 5 && pwpInfo && pwpPricing) {
      subtotal = pricing.brand_price * qty;
    }

    // Display Discount
    else if (tag.type === 6 && displayDiscount && displayPricing) {
      const normalPrice = parseFloat(displayPricing.brand_price || 0);
      const discountPrice =
        (normalPrice * (100 - displayDiscount.discount)) / 100;
      const orderQty = parseInt(displayDiscount.order, 10); // 5
      const groupQty = orderQty + 1; // 6

      // 计算有多少组
      const groupCount = Math.floor(quantity / groupQty);
      const remain = quantity % groupQty;
      subtotal =
        groupCount * (normalPrice * orderQty + discountPrice) +
        remain * normalPrice;
    }

    // FOC
    else if (tag.type === 4 && focOffer) {
      if (tag.offerType === "1") {
        const apiPrice = getQuantityOfferDiscountedPrice(tag.id);
        subtotal = apiPrice !== null ? apiPrice * qty : null;
      } else {
        subtotal = parseFloat(pricing.brand_price || 0) * qty;
      }
    }

    return subtotal;
  };

  const getRenderablePromotionCount = () => {
    const tags = getPromotionTags(productData.promotion).filter(
      (tag) => tag.id !== "normal-price",
    );
    const groupedType4PromoIds = new Set();
    let count = 0;

    tags.forEach((tag) => {
      if (tag.type === 4) {
        const basePromoId = tag.promoId || String(tag.id).split("_")[0];
        if (!groupedType4PromoIds.has(basePromoId)) {
          groupedType4PromoIds.add(basePromoId);
          count += 1;
        }
        return;
      }
      count += 1;
    });

    return count;
  };

  function renderAllPromotion() {
    const promos = promotionForDisplay || [];

    // Flatten promos into tag-like entries. Type 4 (Quantity Offer) promos
    // expand into one entry per offer tier
    const allTagsSorted = [];
    promos.forEach((promo) => {
      if (promo.tag_type === 4) {
        (promo.quantity_offers || []).forEach((qo) => {
          allTagsSorted.push({
            id: qo.tag_id,
            type: 4,
            promo,
            offer: qo,
          });
        });
      } else {
        allTagsSorted.push({
          id: promo.tag_id ?? promo.id,
          type: promo.tag_type,
          promo,
        });
      }
    });

    if (allTagsSorted.length === 0) return <div></div>;

    const type4Tags = allTagsSorted.filter((t) => t.type === 4);
    const otherTags = allTagsSorted.filter((t) => t.type !== 4);

    const selectedType4Tag = type4Tags.find((t) =>
      selectedPromotionIds.includes(t.id),
    );
    const activeType4Tag = selectedType4Tag || type4Tags[0];
    const isLastTier = !!(
      activeType4Tag && type4Tags[type4Tags.length - 1].id === activeType4Tag.id
    );
    const promotionSubheader = activeType4Tag?.offer?.header;
    const selectedPromotionCount = allTagsSorted.filter((tag) =>
      selectedPromotionIds.includes(tag.id),
    ).length;

    return (
      <div className="allpromotion-body">
        <div className="allpromotion-alltags-header">
          <div className="allpromotion-alltags-header-title">
            <Ticket size={14} />
            PROMOTIONS
            <div
              className="allpromotion-alltags-header-tag"
              style={
                selectedPromotionCount === 0
                  ? { backgroundColor: "#e5e5e5b3", color: "#737373" }
                  : undefined
              }
            >
              <Check size={10} />
              {selectedPromotionCount} applied
            </div>
          </div>
          {promotionSubheader && (
            <div style={{ color: "#a1a1a1" }}>
              {isLastTier && <Check size={12} />}
              {promotionSubheader}
            </div>
          )}
        </div>

        <div className="allpromotion-alltags-wrapper">
          {allTagsSorted.length >= 5 && (
            <button
              type="button"
              className="image-nav-button-v2 image-nav-prev"
              onClick={() => {
                if (promotionTagsRef.current) {
                  promotionTagsRef.current.scrollLeft -= 158;
                }
              }}
            >
              <ChevronLeft size={16} />
            </button>
          )}

          <div className="allpromotion-alltags" ref={promotionTagsRef}>
            {otherTags.map((tag) => {
              const isSelected = selectedPromotionIds.includes(tag.id);
              const tagId = tag.id;
              const promo = tag.promo;

              let promotionClassName = "";
              let tagText = promo.tag_text;
              let discount = "";
              let price = "";

              if (tag.type === 3 || tag.type === 5 || tag.type === 6) {
                promotionClassName =
                  tag.type === 3
                    ? "orange"
                    : tag.type === 5
                      ? "blue"
                      : "yellow";

                discount = `-${Math.round(promo.discount_pct)}%`;

                price = (
                  <div className="allpromotion-branch-price-container">
                    <span className="allpromotion-branch-rm">RM</span>
                    <div className="allpromotion-branch-prices">
                      <span className="allpromotion-branch-price">
                        {promo.discount_price
                          ? formatCurrency(promo.discount_price)
                          : "0.00"}
                      </span>
                      {tag.type !== 5 && (
                        <span className="allpromotion-branch-ori-price">
                          {promo.normal_price
                            ? formatCurrency(promo.normal_price)
                            : "0.00"}
                        </span>
                      )}
                    </div>
                  </div>
                );
              } else if (tag.type === 2 && promo.free_gift) {
                promotionClassName = "green";

                price = (
                  <div className="allpromotion-branch-price-container">
                    <span className="allpromotion-branch-price">FREE</span>
                  </div>
                );
              }

              return (
                <div
                  key={tagId}
                  data-promotion-id={tagId}
                  style={{ position: "relative" }}
                >
                  <div
                    className={`allpromotion-branch ${promotionClassName} ${isSelected ? "selected" : ""}`}
                    onClick={() => handlePromotionTagClick(tagId)}
                    style={{ cursor: tag.type === 2 ? "default" : "pointer" }}
                  >
                    <div
                      className={`allpromotion-branch-header ${promotionClassName}`}
                    >
                      <div>{tagText}</div>
                      <div>{discount}</div>
                    </div>

                    <div className="allpromotion-branch-photo">
                      <FallbackImg
                        ref={promotionMagnifierRef}
                        src={promo.thumb_url}
                        alt={tagText}
                        width="48"
                        height="48"
                        // onClick={() => handlePromotionImageClick(promo.img_url)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="allpromotion-branch-info">
                      <div className="allpromotion-branch-code">
                        {promo.item_code}
                      </div>
                      {price}

                      {tag.type === 5 && (
                        <div
                          className="allpromotion-productqty"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            className="allpromotion-minus-btn"
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              const nextQty = Math.max(
                                0,
                                (pwpQuantities[tagId] || 0) - 1,
                              );
                              if (nextQty === 0) {
                                // Manually decreasing to 0 should deselect the
                                // PWP, same as clicking the card again would.
                                handlePromotionTagClick(tagId);
                                return;
                              }
                              setPwpQuantities((prev) => ({
                                ...prev,
                                [tagId]: nextQty,
                              }));
                            }}
                            disabled={
                              !isSelected || (pwpQuantities[tagId] || 0) === 0
                            }
                          >
                            −
                          </button>
                          <input
                            type="text"
                            className="allpromotion-productqty-value"
                            value={pwpQuantities[tagId] || 0}
                            readOnly
                          />
                          <button
                            className={`allpromotion-plus-btn ${isSelected && "selected"}`}
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (quantity <= 0) return;
                              if (!isSelected) {
                                handlePromotionTagClick(tagId);
                                return;
                              }
                              const maxQty = selectedTags.some(
                                (t) => t.type === 5,
                              )
                                ? getPWPMaxQty()
                                : quantity;
                              setPwpQuantities((prev) => ({
                                ...prev,
                                [tagId]: Math.min(
                                  maxQty,
                                  (prev[tagId] || 0) + 1,
                                ),
                              }));
                            }}
                            disabled={
                              quantity <= 0 ||
                              (isSelected &&
                                (pwpQuantities[tagId] || 0) >=
                                  (selectedTags.some((t) => t.type === 5)
                                    ? Math.min(getPWPMaxQty(), quantity)
                                    : quantity))
                            }
                          >
                            +
                          </button>
                        </div>
                      )}
                    </div>

                    {isSelected && (
                      <div
                        className={`allpromotion-branch-tick  ${promotionClassName}`}
                      >
                        <Check size={10} color={"#ffffff"} />
                      </div>
                    )}
                  </div>

                  {showPromotionImageModal && (
                    <div
                      className="image-modal"
                      onClick={() => setShowPromotionImageModal(false)}
                    >
                      <div
                        className="image-modal-content"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <button
                          className="modal-close"
                          onClick={() => setShowPromotionImageModal(false)}
                        >
                          <X size={16} />
                        </button>
                        <FallbackImg
                          src={modalPromotionImageUrl}
                          alt="Promotion"
                          className="modal-image"
                        />
                      </div>
                    </div>
                  )}
                </div>
              );
            })}

            {type4Tags.map((tag) => {
              const isSelected = selectedPromotionIds.includes(tag.id);
              const tagId = tag.id;
              const promo = tag.promo;
              const focOffer = tag.offer;

              let tagText = "VOLUME";
              let discount = "";
              let price = "";
              let fakePhoto = "";

              if (focOffer.offer_type == 1) {
                discount = `${focOffer.tag_text}`;
              } else if (focOffer.offer_type == 0) {
                discount = `FOC + ${focOffer.foc}`;
              }

              price = (
                <div className="allpromotion-branch-price-container">
                  <span className="allpromotion-branch-rm">RM</span>
                  <div className="allpromotion-branch-prices">
                    <span className="allpromotion-branch-price">
                      {focOffer.discounted_price
                        ? formatCurrency(focOffer.discounted_price)
                        : "0.00"}
                    </span>
                    {focOffer.is_insufficient_stock ? (
                      <span className="allpromotion-qtyoffer-badge no-stock">
                        Insufficient Stock
                      </span>
                    ) : focOffer.offer_type == 1 ? (
                      <span className="allpromotion-branch-ori-price">
                        {promo.normal_price
                          ? formatCurrency(promo.normal_price)
                          : "0.00"}
                      </span>
                    ) : focOffer.offer_type == 0 ? (
                      <span className="allpromotion-branch-descrip">
                        {focOffer.offer_id != 0
                          ? isSelected
                            ? `avg ${Number(quantity) + Number(focOffer.foc)} units`
                            : `avg ${Number(focOffer.order) + Number(focOffer.foc)} units`
                          : "/unit"}
                      </span>
                    ) : null}
                  </div>
                </div>
              );

              return (
                <div
                  key={tagId}
                  data-promotion-id={tagId}
                  style={{ position: "relative" }}
                >
                  <div
                    className={`allpromotion-branch purple ${isSelected ? "selected" : ""}`}
                    onClick={() =>
                      !focOffer.is_insufficient_stock &&
                      handlePromotionTagClick(tagId)
                    }
                    style={{
                      cursor: focOffer.is_insufficient_stock
                        ? "not-allowed"
                        : "pointer",
                    }}
                  >
                    <div className={`allpromotion-branch-header purple`}>
                      <div>{tagText}</div>
                      <div>{discount}</div>
                    </div>

                    <div className="allpromotion-branch-photo">
                      <FallbackImg
                        ref={promotionMagnifierRef}
                        src={promo.thumb_url}
                        alt={tagText}
                        width="48"
                        height="48"
                        // onClick={() => handlePromotionImageClick(promo.img_url)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="allpromotion-branch-info">
                      <div className="allpromotion-branch-code">
                        {focOffer.description}
                      </div>
                      {price}
                    </div>

                    {isSelected && (
                      <div className="allpromotion-branch-tick purple">
                        <Check size={10} color={"#ffffff"} />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {allTagsSorted.length >= 5 && (
            <button
              type="button"
              className="image-nav-button-v2 image-nav-next"
              onClick={() => {
                if (promotionTagsRef.current) {
                  promotionTagsRef.current.scrollLeft += 158;
                }
              }}
            >
              <ChevronRight size={16} />
            </button>
          )}
        </div>
      </div>
    );
  }

  // Add to cart states
  const price = selectedTags.some((tag) => tag.type === 4)
    ? (() => {
        const focTag = selectedTags.find((tag) => tag.type === 4);
        const promo = productData.promotion.find((p) =>
          focTag.id.startsWith(p.id),
        );
        if (promo && promo.quantity_offer) {
          const offerId = focTag.id.split("_")[1];
          const focOffer = promo.quantity_offer.find((qo) => qo.id === offerId);
          if (focOffer && focOffer.discount && focOffer.type === "1") {
            return getQuantityOfferDiscountedPrice(focTag.id);
          }
        }
        return parseFloat(pricing.brand_price || 0);
      })()
    : selectedTags.some((tag) => tag.type === 3)
      ? promotionInfo && promotionInfo.price
        ? promotionInfo.price
        : parseFloat(pricing.brand_price || 0)
      : pricing.bundle_pricing
        ? pricing.bundle_pricing.final_brand_price
        : parseFloat(pricing.brand_price || 0);
  const promotionIds = selectedPromotionIds;
  const pwpItems = selectedTags
    .filter((tag) => tag.type === 5)
    .map((tag) => {
      const promo = productData.promotion.find((p) => p.id === tag.promoId);
      const pwpInfo = promo?.pwp_info?.pwp_info?.find(
        (pi) => String(pi.id) === String(tag.pwpEntryId),
      );
      const pwpPricing = promo?.pwp_info?.pricing?.[pwpInfo?.item_id];
      const qty = pwpQuantities[tag.id] || 0;
      return {
        promotionId: tag.id, // keep composite id for cart payload
        item_id: pwpPricing?.item_id,
        item_code: pwpPricing?.item_code,
        item_name: pwpPricing?.item_name,
        original_price: pwpPricing?.brand_price || pwpPricing?.rcp,
        price:
          pwpPricing && pwpInfo
            ? ((pwpPricing.rcp || pwpPricing.brand_price) *
                (100 - pwpInfo.discount)) /
              100
            : 0,
        ori_price: pwpPricing
          ? Number(pwpPricing.rcp) || Number(pwpPricing.brand_price)
          : 0,
        discount_price:
          pwpPricing && pwpInfo
            ? ((pwpPricing.rcp || pwpPricing.brand_price) * pwpInfo.discount) /
              100
            : 0,
        quantity: qty,
      };
    });
  // Stable string key that changes whenever the set of selected PWP
  // promotions (or any of their quantities) changes — used as an effect
  // dependency since `pwpItems` itself is a new array every render.
  const pwpItemsKey = pwpItems
    .map((p) => `${p.promotionId}:${p.quantity}`)
    .join("|");
  const selectedPwpDisplayTag = selectedTags.find((tag) => tag.type === 5);
  const selectedPwpPromo = (promotionForDisplay || []).find(
    (p) => (p.tag_id ?? p.id) === selectedPwpDisplayTag?.id,
  );
  const bundleId = productData?.package_id || null;
  const isBundle = !!productData?.package_id;
  const onCartOperationSuccess = null;
  const [branches, setBranches] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  // Keyed by PWP tag id — one search box per selected PWP promotion.
  const [pwpSearchInput, setPwpSearchInput] = useState({});
  const [branchQuantities, setBranchQuantities] = useState({});
  const [branchFocQuantities, setBranchFocQuantities] = useState({});
  // Shape: { [pwpTagId]: { [branchId]: qty } } — one distribution map per
  // selected PWP promotion, since multiple PWP promotions can be selected
  // on the same item at once.
  const [branchPwpQuantities, setBranchPwpQuantities] = useState({});
  const [branchDiscountQuantities, setBranchDiscountQuantities] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [promotionLoading, setPromotionLoading] = useState(false);
  const [showPromotionLoadingOverlay, setShowPromotionLoadingOverlay] =
    useState(false);
  const [showAddToCartSuccess, setShowAddToCartSuccess] = useState({
    show: false,
    tick: false,
    text: "",
  });
  // Per-tag PWP pricing lookup (multiple PWP promotions can be selected).
  const getPwpPricing = (pwpItem) => ({
    price: typeof pwpItem?.price === "number" ? pwpItem.price : 0,
    oriPrice: typeof pwpItem?.ori_price === "number" ? pwpItem.ori_price : 0,
    discountPrice:
      typeof pwpItem?.discount_price === "number" ? pwpItem.discount_price : 0,
  });
  const totalQuantity = quantity;
  const currentPrice = price;
  const originalPrice = productData?.pricing?.brand_price || 0;
  const hasPwp = pwpItems.length > 0;
  const [isInCart, setIsInCart] = useState(false);
  const [invalidBranchQty, setInvalidBranchQty] = useState({});
  const usedCustomerId =
    productData?.pricing?.used_customer_id ||
    productData?.pricing?.bundle_pricing?.used_customer_id ||
    productData?.bundle_items?.[0]?.pricing?.used_customer_id ||
    "";
  let groupCount = 0;
  let remain = 0;
  let normalQty = quantity;
  let discountQty = 0;
  if (displayDiscountInfo && displayDiscountInfo.groupQty > 1) {
    groupCount = Math.floor(quantity / displayDiscountInfo.groupQty);
    remain = quantity % displayDiscountInfo.groupQty;
    normalQty = groupCount * displayDiscountInfo.orderQty + remain;
    discountQty = groupCount;
  }
  const hasInvalidBranchQty = Object.values(invalidBranchQty).some(Boolean);

  useEffect(() => {
    const fetchBranches = async () => {
      if (isLoggedIn && SHOW_REGION_POPUP === 1 && !selectedRegion) return;

      try {
        const rawBranches = await ApiService.getBranchList(
          SHOW_REGION_POPUP === 1 ? { region: selectedRegion } : {},
        );
        // Ensure HQ (branch_id === "0") is always first; if absent (region-only list), first element becomes default
        const branchData = [
          ...rawBranches.filter((b) => String(b.branch_id) === "0"),
          ...rawBranches.filter((b) => String(b.branch_id) !== "0"),
        ];
        setBranches(branchData);
        setBranchCount(branchData.length || 1);
      } catch (error) {
        alert("Failed to load branches");
        setBranchCount(1);
      }
    };
    fetchBranches();
  }, [selectedRegion]);

  // Runs when quantities/branches/discount changes — no API call
  useEffect(() => {
    if (!branches.length) return;

    // Calculate normalQty
    let groupCount = 0,
      remain = 0,
      normalQty = quantity;
    if (displayDiscountInfo && displayDiscountInfo.groupQty > 1) {
      groupCount = Math.floor(quantity / displayDiscountInfo.groupQty);
      remain = quantity % displayDiscountInfo.groupQty;
      normalQty = groupCount * displayDiscountInfo.orderQty + remain;
    }

    // Main product allocation
    const initialQuantities = {};
    branches.forEach((branch, idx) => {
      initialQuantities[branch.branch_id] = idx === 0 ? normalQty : 0;
    });
    setBranchQuantities(initialQuantities);

    // Display Discount allocation
    if (displayDiscountInfo && displayDiscountInfo.groupQty > 1) {
      const maxDiscount = Math.floor(quantity / displayDiscountInfo.groupQty);
      const initialDiscount = {};
      branches.forEach((branch, idx) => {
        initialDiscount[branch.branch_id] = idx === 0 ? maxDiscount : 0;
      });
      setBranchDiscountQuantities(initialDiscount);
    }

    // FOC allocation
    const initialFoc = {};
    branches.forEach((branch, idx) => {
      initialFoc[branch.branch_id] = idx === 0 ? focTotal : 0;
    });
    setBranchFocQuantities(initialFoc);
  }, [
    branches,
    quantity,
    focTotal,
    displayDiscountInfo?.groupQty,
    displayDiscountInfo?.orderQty,
    selectedPromotionIds,
  ]);

  useEffect(() => {
    setAllowAddToCart(false);
  }, [quantity]);

  useEffect(() => {
    if (
      branches.length === 1 &&
      canBuy &&
      quantity > 0 &&
      !invalidPackingQty &&
      !invalidDiscountQty &&
      isQuantityValid() &&
      !freeGiftOutOfStock &&
      // !isFocQtyExceeded &&
      quantityInputStr !== "" &&
      !Object.values(invalidBranchQty).some(Boolean)
    ) {
      setAllowAddToCart(true);
    }
  }, [branches.length, quantity]);

  useEffect(() => {
    if (branches.length > 0) {
      const nextByTag = {};
      pwpItems.forEach((pwpItem) => {
        const initial = {};
        branches.forEach((branch, idx) => {
          initial[branch.branch_id] = idx === 0 ? pwpItem.quantity : 0;
        });
        nextByTag[pwpItem.promotionId] = initial;
      });
      setBranchPwpQuantities(nextByTag);
    }
  }, [branches, pwpItemsKey]);

  useEffect(() => {
    const checkInCart = async () => {
      try {
        const item_id = product.id;
        // console.log("Checking if item is in cart:", item_id);
        if (!item_id) return;
        const res = await ApiService.checkingIsIncart(item_id);
        setIsInCart(res.exists === true);
      } catch (e) {
        setIsInCart(false);
      }
    };
    checkInCart();
  }, [product]);

  const calculateHQQuantity = () => {
    if (branches.length === 0) return normalQty;
    const hqBranchId = branches[0].branch_id;
    let distributedQty = 0;
    Object.entries(branchQuantities).forEach(([branchId, qty]) => {
      if (branchId !== hqBranchId) distributedQty += qty;
    });
    return normalQty - distributedQty;
  };

  const getCurrentFocTotal = () => {
    // focTotal 是 props 传进来的，表示应得的 FOC 总数
    return focTotal || 0;
  };

  const calculateHQPwpQuantity = (pwpTagId) => {
    if (branches.length === 0) return 0;
    const hqBranchId = branches[0].branch_id;
    const pwpItem = pwpItems.find((p) => p.promotionId === pwpTagId);
    const tagQuantities = branchPwpQuantities[pwpTagId] || {};
    let distributed = 0;
    Object.entries(tagQuantities).forEach(([bid, qty]) => {
      if (bid !== hqBranchId) distributed += qty;
    });
    // HQ = 总PWP - 其他分店已分配
    return Math.max(0, (pwpItem?.quantity || 0) - distributed);
  };

  const calculateHQFocQuantity = () => {
    if (branches.length === 0) return getCurrentFocTotal();
    const hqBranchId = branches[0].branch_id;
    let distributed = 0;
    Object.entries(branchFocQuantities).forEach(([bid, qty]) => {
      if (bid !== hqBranchId) distributed += qty;
    });
    return getCurrentFocTotal() - distributed;
  };

  const calculateHQDiscountQuantity = () => {
    if (branches.length === 0) return 0;
    const hqBranchId = branches[0].branch_id;
    let distributed = 0;
    Object.entries(branchDiscountQuantities).forEach(([bid, qty]) => {
      if (bid !== hqBranchId) distributed += qty;
    });
    const maxDiscount = Math.floor(
      totalQuantity / (displayDiscountInfo?.groupQty || 1),
    );
    return Math.max(0, maxDiscount - distributed);
  };

  const handleDiscountDecrease = (branchId) => {
    if (branches.length === 0) return;
    const hqBranchId = branches[0].branch_id;
    if (branchId === hqBranchId) return;
    setBranchDiscountQuantities((prev) => ({
      ...prev,
      [branchId]: Math.max(0, (prev[branchId] || 0) - 1),
    }));
  };

  const handleDiscountIncrease = (branchId) => {
    if (branches.length === 0) return;
    const hqBranchId = branches[0].branch_id;
    if (branchId === hqBranchId) return;
    const maxDiscount = Math.floor(
      totalQuantity / (displayDiscountInfo?.groupQty || 1),
    );
    const totalAssigned = Object.entries(branchDiscountQuantities).reduce(
      (sum, [bid, qty]) => (bid === hqBranchId ? sum : sum + (qty || 0)),
      0,
    );
    if (totalAssigned < maxDiscount) {
      setBranchDiscountQuantities((prev) => {
        const newQuantities = { ...prev };
        newQuantities[branchId] = (newQuantities[branchId] || 0) + 1;
        // Recalculate HQ
        newQuantities[hqBranchId] =
          maxDiscount -
          Object.entries(newQuantities)
            .filter(([bid]) => bid !== hqBranchId)
            .reduce((sum, [, qty]) => sum + (qty || 0), 0);
        return newQuantities;
      });
    }
  };

  const handleFocDecrease = (branchId) => {
    setBranchFocQuantities((prev) => ({
      ...prev,
      [branchId]: Math.max(0, (prev[branchId] || 0) - 1),
    }));
  };

  const handleFocIncrease = (branchId) => {
    const hqBranchId = branches[0]?.branch_id;
    if (branchId === hqBranchId) return;
    setBranchFocQuantities((prev) => {
      const distributed = Object.entries(prev).reduce(
        (sum, [bid, qty]) => (bid === hqBranchId ? sum : sum + qty),
        0,
      );
      if (distributed < getCurrentFocTotal()) {
        return { ...prev, [branchId]: (prev[branchId] || 0) + 1 };
      }
      return prev;
    });
  };

  const stepValueTemp =
    package_seperate === "1" && packing_quantity > 0 ? packing_quantity : 1;

  const handleBranchDecrease = (branchId) => {
    if (branches.length === 0) return;

    const hqBranchId = branches[0].branch_id;

    // Cannot modify HQ
    if (branchId === hqBranchId) return;

    setBranchQuantities((prev) => {
      const newQuantities = { ...prev };
      const currentQty = newQuantities[branchId] || 0;

      if (currentQty >= stepValueTemp) {
        // Decrease from this branch
        newQuantities[branchId] = currentQty - stepValueTemp;
        // Update HQ to reflect the change
        newQuantities[hqBranchId] = calculateHQQuantity() + stepValueTemp;
      }

      return newQuantities;
    });
  };

  const handleBranchIncrease = (branchId) => {
    if (branches.length === 0) return;
    const hqBranchId = branches[0].branch_id;
    if (branchId === hqBranchId) return;

    setBranchQuantities((prev) => {
      const newQuantities = { ...prev };
      const currentHQQty = calculateHQQuantity();

      // 计算所有分店已分配总数（不含HQ）
      const totalAssigned = Object.entries(newQuantities)
        .filter(([bid]) => bid !== hqBranchId)
        .reduce((sum, [, qty]) => sum + qty, 0);

      if (totalAssigned + stepValueTemp <= normalQty) {
        newQuantities[branchId] =
          (newQuantities[branchId] || 0) + stepValueTemp;
        // HQ 自动分配剩余
        newQuantities[hqBranchId] =
          normalQty -
          Object.entries(newQuantities)
            .filter(([bid]) => bid !== hqBranchId)
            .reduce((sum, [, qty]) => sum + qty, 0);
      }

      return newQuantities;
    });
  };

  const handlePwpDecrease = (pwpTagId, branchId) => {
    if (branches.length === 0) return;
    const hqBranchId = branches[0].branch_id;
    if (branchId === hqBranchId) return; // HQ 不允许手动减

    setBranchPwpQuantities((prev) => ({
      ...prev,
      [pwpTagId]: {
        ...prev[pwpTagId],
        [branchId]: Math.max(0, (prev[pwpTagId]?.[branchId] || 0) - 1),
      },
    }));
  };

  const handlePwpIncrease = (pwpTagId, branchId) => {
    if (branches.length === 0) return;
    const hqBranchId = branches[0].branch_id;
    if (branchId === hqBranchId) return; // HQ 不允许手动加

    // 计算已分配总数
    const tagQuantities = branchPwpQuantities[pwpTagId] || {};
    const totalAssigned = Object.entries(tagQuantities).reduce(
      (sum, [bid, qty]) => (bid === hqBranchId ? sum : sum + (qty || 0)),
      0,
    );
    const pwpItem = pwpItems.find((p) => p.promotionId === pwpTagId);
    const maxPwp = pwpItem?.quantity || 0;
    if (totalAssigned < maxPwp) {
      setBranchPwpQuantities((prev) => ({
        ...prev,
        [pwpTagId]: {
          ...prev[pwpTagId],
          [branchId]: (prev[pwpTagId]?.[branchId] || 0) + 1,
        },
      }));
    }
  };

  const handleBranchQuantityInputChange = (branchId, value) => {
    if (branches.length === 0) return;
    const hqBranchId = branches[0].branch_id;
    if (branchId === hqBranchId) return;
    if (!/^\d*$/.test(value)) return;
    let numValue = parseInt(value) || 0;

    setBranchQuantities((prev) => {
      const newQuantities = { ...prev };
      let otherBranchesTotal = 0;
      Object.entries(prev).forEach(([bId, qty]) => {
        if (bId !== branchId && bId !== hqBranchId) {
          otherBranchesTotal += qty;
        }
      });
      const maxValue = normalQty - otherBranchesTotal;
      if (numValue > maxValue) {
        newQuantities[branchId] = maxValue;
      } else {
        newQuantities[branchId] = numValue;
      }
      const newDistributedTotal = otherBranchesTotal + newQuantities[branchId];
      newQuantities[hqBranchId] = normalQty - newDistributedTotal;

      // After updating, check if the actual value is valid and update invalid state accordingly
      let actualValue = newQuantities[branchId];
      let actualInvalid = false;
      if (package_seperate === "1" && packing_quantity > 0) {
        if (actualValue % packing_quantity !== 0) {
          actualInvalid = true;
        }
      }
      setInvalidBranchQty((prev) => ({ ...prev, [branchId]: actualInvalid }));

      return newQuantities;
    });
  };

  const getPricingTypeAndCustomerId = () => {
    const pricing = productData?.pricing || {};

    const usedPricingType = String(
      pricing.used_pricing_type || productData.used_pricing_type || 1,
    );
    const usedCustomerId = String(pricing.used_customer_id || "");

    return {
      pricing_type: usedPricingType,
      customer_id: usedCustomerId,
    };
  };

  const handleAddToCart = async (skipChecks = {}) => {
    if (typeof skipChecks.buyNow === "boolean") {
      isBuyNowRef.current = skipChecks.buyNow;
    }

    if (!isLoggedIn) {
      setShowLoginPrompt(true);
      return;
    }

    if (
      isItemLimited() ||
      productData?.filter_label?.includes("out_of_stock")
    ) {
      setNotice({ show: true, message: "Sorry, this item is out of stock." });
      return;
    }

    if (!isQuantityValid()) {
      setNotice({
        show: true,
        noticeTitle: "Quantity Limit Reached",
        message: `The quantity you selected exceeds available stock. Only ${getCurrentStock()} items are currently available.`,
        yesText: "Noted",
      });
      return;
    }

    // 1. ORP message（每次都检查，除非明确跳过）
    if (!skipChecks.orp && product.orp && parseFloat(product.orp) > 0) {
      setOrpMsg(
        "Please follow the recommended Online Recommended Price (ORP) for this product when listing it on your online store. Thank you for your cooperation.",
      );
      setPendingStep("orp");
      return;
    }

    // 2. Term message（每次都检查，除非明确跳过）
    if (!skipChecks.term) {
      try {
        const termRes = await ApiService.getTermMessage(
          product.id || product.item_id,
        );
        if (
          termRes &&
          (termRes.data.title || termRes.data.body || termRes.data.footer)
        ) {
          setNotice({
            show: true,
            message: (
              <div>
                <h4>{termRes.data.title}</h4>
                <div dangerouslySetInnerHTML={{ __html: termRes.data.body }} />
                <div
                  style={{ marginTop: 16, color: "#888" }}
                  dangerouslySetInnerHTML={{ __html: termRes.data.footer }}
                />
              </div>
            ),
            yesText: "Agree",
          });
          setPendingStep("term");
          return;
        }
      } catch (error) {
        console.error("Error fetching term message:", error);
      }
    }

    // 3. Virtual stock checking（每次都检查，除非明确跳过）
    if (!skipChecks.virtual) {
      try {
        //const test = 200;
        const qty = quantity;
        const res = await ApiService.virtualStockChecking(
          product.id || product.item_id,
          qty,
        );
        if (res && res.checking && res.checking.chk_stock === "1") {
          setNotice({
            show: true,
            noticeTitle: "Shipping Notice",
            message: "This item requires 2-4 working days to be shipped.",
            yesText: "Noted",
          });
          setPendingStep("virtual");
          return;
        }
      } catch (error) {
        console.error("Error checking virtual stock:", error);
      }
    }

    // 4. Best Deal checking（除非明确跳过）
    if (!skipChecks.bestDeal) {
      // Do not show PromoTip if the user is choosing PWP
      const isChoosingPwp = selectedTags.some((tag) => tag.type === 5);
      // Do not show PromoTip if the user is choosing Display Discount
      const isChoosingDisplayDiscount = selectedTags.some(
        (tag) => tag.type === 6,
      );
      // if (!isChoosingPwp && !isChoosingNormalPrice) {
      if (!isChoosingPwp && !isChoosingDisplayDiscount) {
        // Do not show PromoTip if the item has no promo or having free gift only
        const onlyFreeGiftOrNoPromo = hasOnlyFreeGiftOrNoPromo(
          productData.promotion,
        );
        if (!isBest && !onlyFreeGiftOrNoPromo) {
          setShowPromoTip(true);
          setPendingStep("bestdeal");
          return;
        }
      }
    }

    // 5. Check if any selected PWP promo has qty 0
    if (!skipChecks.pwp) {
      const hasPwp = selectedTags.some((tag) => tag.type === 5);
      const hasZeroPwp = selectedTags
        .filter((tag) => tag.type === 5)
        .some((tag) => (pwpQuantities[tag.id] || 0) === 0);
      if (hasPwp && hasZeroPwp) {
        setShowPwpZeroQtyConfirm(true);
        return;
      }
    }

    try {
      setIsSubmitting(true);

      const cartItems = [];
      const displayDiscountItems = [];

      // 主商品分配
      Object.entries(branchQuantities).forEach(([branchId, qty]) => {
        let quantity_offer_id = "";
        let promo = "";
        if (promotionId && promotionId.includes("_")) {
          const offerId = promotionId.split("_")[1];
          quantity_offer_id = offerId === "0" ? "" : offerId;
          promo = offerId === "0" ? "" : promotionId.split("_")[0];
        } else {
          quantity_offer_id = "";
          promo = promotionId;
        }
        if (qty > 0) {
          cartItems.push({
            branch_id: branchId,
            quantity: qty,
            price: displayDiscountInfo
              ? displayDiscountInfo.normalPrice
              : currentPrice,
            type: "normal",
            item_id: product.id || product.item_id,
            free_gift_id: freegiftId,
            promotion_id: promo || freegiftId,
            quantity_offer_id: quantity_offer_id,
            discount: originalPrice - currentPrice || 0,
          });
        }
      });

      // Display Discount 分配
      if (displayDiscountInfo && displayDiscountInfo.groupQty > 1) {
        Object.entries(branchDiscountQuantities).forEach(([branchId, qty]) => {
          if (qty > 0) {
            displayDiscountItems.push({
              branch_id: branchId,
              quantity: qty,
              type: "display_discount",
              item_id: product.id || product.item_id,
              price: displayDiscountInfo.discountPrice,
              discount:
                displayDiscountInfo.normalPrice -
                displayDiscountInfo.discountPrice,
              free_gift_id: freegiftId,
              promotion_id: promotionId,
            });
          }
        });
      }

      // FOC 分配
      const focItems = [];
      Object.entries(branchFocQuantities).forEach(([branchId, qty]) => {
        if (branchId === branches[0].branch_id) {
          // HQ: 用自动计算的
          const hqQty = calculateHQFocQuantity();
          let quantity_offer_id = "";
          let promo = "";
          if (promotionId && promotionId.includes("_")) {
            const offerId = promotionId.split("_")[1];
            quantity_offer_id = offerId === "0" ? "" : offerId;
            promo = offerId === "0" ? "" : promotionId.split("_")[0];
          } else {
            quantity_offer_id = "";
            promo = promotionId;
          }
          if (hqQty > 0) {
            focItems.push({
              branch_id: branchId,
              quantity: hqQty,
              type: "foc",
              item_id: product.id || product.item_id,
              price: "",
              discount: "",
              free_gift_id: freegiftId,
              quantity_offer_id: quantity_offer_id,
              promotion_id: promo,
            });
          }
        } else if (qty > 0) {
          let quantity_offer_id = "";
          let promo = "";
          if (promotionId && promotionId.includes("_")) {
            const offerId = promotionId.split("_")[1];
            quantity_offer_id = offerId === "0" ? "" : offerId;
            promo = offerId === "0" ? "" : promotionId.split("_")[0];
          } else {
            quantity_offer_id = "";
            promo = promotionId;
          }
          focItems.push({
            branch_id: branchId,
            quantity: qty,
            type: "foc",
            item_id: product.id || product.item_id,
            price: "",
            discount: "",
            free_gift_id: freegiftId,
            promotion_id: promo,
            quantity_offer_id: quantity_offer_id,
          });
        }
      });
      // PWP 分配 —— 每个被选中的 PWP 促销各自独立分配到各分店
      const pwpItemsArr = [];
      pwpItems.forEach((pwpItem) => {
        const tagQuantities = branchPwpQuantities[pwpItem.promotionId] || {};
        const { price: pwpItemPrice } = getPwpPricing(pwpItem);
        Object.entries(tagQuantities).forEach(([branchId, qty]) => {
          if (branchId === branches[0].branch_id) {
            const hqQty = calculateHQPwpQuantity(pwpItem.promotionId);
            if (hqQty > 0) {
              pwpItemsArr.push({
                branch_id: branchId,
                quantity: hqQty,
                type: "pwp",
                item_id: pwpItem.item_id,
                price: pwpItemPrice,
                discount: pwpItem.original_price - pwpItemPrice,
                free_gift_id: "",
                promotion_id: pwpItem.promotionId,
              });
            }
          } else if (qty > 0) {
            pwpItemsArr.push({
              branch_id: branchId,
              quantity: qty,
              type: "pwp",
              item_id: pwpItem.item_id,
              price: pwpItemPrice,
              discount: pwpItem.original_price - pwpItemPrice,
              free_gift_id: "",
              promotion_id: pwpItem.promotionId,
            });
          }
        });
      });

      const pwpBranchIds = Object.values(branchPwpQuantities || {}).flatMap(
        (tagQuantities) =>
          Object.keys(tagQuantities || {}).filter(
            (branchId) => tagQuantities[branchId] > 0,
          ),
      );

      // 主产品赠品分配（只统计主产品数量，不含FOC/PWP/Display Discount）
      const freegiftDistribution = [];
      Object.entries(branchQuantities).forEach(([branchId, qty]) => {
        if (qty > 0) {
          freegiftItems.forEach((fg) => {
            freegiftDistribution.push({
              branch_id: branchId,
              quantity: qty, // 只统计主产品数量
              item_id: fg.item_id,
              free_gift_id: fg.free_gift_id,
              promotion_id: freegiftId,
            });
          });
        }
      });

      // 促销产品赠品分配（只统计 FOC 和 Display Discount，PWP 不要）
      const promofreegiftDistribution = [];

      // FOC 赠品
      if (focTotal > 0) {
        const hqBranchId = branches[0]?.branch_id;
        const otherFocTotal = Object.entries(branchFocQuantities)
          .filter(([branchId]) => branchId !== hqBranchId)
          .reduce((sum, [, qty]) => sum + Number(qty || 0), 0);
        const hqFocQty = Math.max(focTotal - otherFocTotal, 0);

        branches.forEach((branch) => {
          const branchId = branch.branch_id;
          let qty = 0;
          if (branchId === hqBranchId) {
            qty = hqFocQty;
          } else {
            qty = Number(branchFocQuantities[branchId] || 0);
          }
          if (qty > 0) {
            freegiftItems.forEach((fg) => {
              promofreegiftDistribution.push({
                branch_id: branchId,
                quantity: qty,
                item_id: fg.item_id,
                free_gift_id: fg.free_gift_id,
                promotion_id: fg.free_gift_id,
                promo_type: "foc",
              });
            });
          }
        });
      }

      // FOC 和 Display Discount 共用一个分配参数；PWP 单独一个参数，
      // 这样后端才能把 PWP 和商品自身的促销分别存到不同字段，二者可以并存。
      const focAndDisplayDiscountItems = [...focItems, ...displayDiscountItems];
      const hqBranchId = branches[0]?.branch_id;
      const { pricing_type } = getPricingTypeAndCustomerId();

      const requestData = {
        item_id: product.id || product.item_id,
        customer_id: usedCustomerId,
        ori_price: price,
        // include bundle_id only when bundle
        ...(isBundle && bundleId ? { bundle_id: bundleId } : {}),
        promotion_id: (promotionIds || []).filter(
          (id) => !String(id).endsWith("_0"),
        ),
        pwp_promotion_id: pwpPromotionId || "",
        cargo_distribution: JSON.stringify(cartItems),
        cargo_foc_distribution: JSON.stringify(focAndDisplayDiscountItems),
        cargo_pwp_distribution: JSON.stringify(pwpItemsArr),
        cargo_freegift_distribution: JSON.stringify(freegiftDistribution),
        cargo_promofreegift_distribution: JSON.stringify(
          promofreegiftDistribution,
        ),
        free_gift_id: freegiftId || "",
        is_buy_now: isBuyNowRef.current ? "1" : "0",
      };
      //("Request Data:", requestData);
      //return;
      const response = await ApiService.addToCart(requestData);

      if (response.status === 200) {
        if (!isBuyNowRef.current && typeof fetchCounts === "function")
          fetchCounts();
        if (onCartOperationSuccess) {
          onCartOperationSuccess(response.data || response);
        } else if (isBuyNowRef.current) {
          const cartId = Array.isArray(response.results?.id)
            ? response.results.id.join(",")
            : response.results?.id;
          const pricingType = pricing_type;
          if (cartId && pricingType) {
            navigate(`/checkout?pricingtype=${pricingType}&cart_ids=${cartId}`);
          } else {
            setShowAddToCartSuccess({
              show: true,
              tick: false,
              text: "Failed to add item to your shoppping cart, please try again",
            });
          }
        } else {
          setShowAddToCartSuccess({
            show: true,
            tick: true,
            text: "Item has been added to your shopping cart",
          });
        }
      } else {
        setShowAddToCartSuccess({
          show: true,
          tick: false,
          text: "Failed to add item to your shoppping cart, please try again",
        });
      }
    } catch (error) {
      console.error("Error with cart operation:", error);
      alert("Error with cart operation: " + (error.message || "Network error"));
    } finally {
      setIsSubmitting(false);
    }
  };

  const itemDistributionRaw = useMemo(() => {
    const singleProduct = productData?.product?.[0];

    if (!singleProduct) return [];

    return [
      {
        label: singleProduct.item_code || "",
        name: singleProduct.item_name || null,
        item_id: singleProduct.item_id || null,
        qty: quantity,
      },
    ];
  }, [productData, quantity]);

  const handleAllToHQ = () => {
    if (!Array.isArray(branches) || branches.length === 0) return;

    const nextQuantities = {};
    const nextFocQuantities = {};
    const nextPwpQuantities = {};
    const nextDiscountQuantities = {};
    const maxDiscount =
      displayDiscountInfo && displayDiscountInfo.groupQty > 1
        ? Math.floor(quantity / displayDiscountInfo.groupQty)
        : 0;

    pwpItems.forEach((pwpItem) => {
      const perTag = {};
      branches.forEach((branch, index) => {
        perTag[branch.branch_id] = index === 0 ? pwpItem.quantity : 0;
      });
      nextPwpQuantities[pwpItem.promotionId] = perTag;
    });

    branches.forEach((branch, index) => {
      nextQuantities[branch.branch_id] = index === 0 ? quantity : 0;
      nextFocQuantities[branch.branch_id] = index === 0 ? focTotal : 0;
      nextDiscountQuantities[branch.branch_id] = index === 0 ? maxDiscount : 0;
    });

    setBranchQuantities(nextQuantities);
    setBranchFocQuantities(nextFocQuantities);
    setBranchPwpQuantities(nextPwpQuantities);
    setBranchDiscountQuantities(nextDiscountQuantities);

    setInvalidBranchQty({});
    setDistributionMode("hq");
    setAllowAddToCart(false);
  };

  const toggleOpen = () => {
    setIsDistributionOpen((prev) => !prev);
    setIsDistributionVisited(true);
  };

  const distributionItem = itemDistributionRaw[0] ?? { qty: 0 };
  const distributionPrefix = "dist-0";
  const hasAllocatableDistribution = distributionItem.qty > 0;
  const pwpDistTriggerVisited =
    !hasPwp ||
    pwpItems.every((pwpItem) => isPwpDistributionVisited[pwpItem.promotionId]);
  const allDistTriggersVisited =
    (!hasAllocatableDistribution || isDistributionVisited) &&
    pwpDistTriggerVisited;

  const allocatedBranchSummary = useMemo(() => {
    if (!Array.isArray(branches) || branches.length === 0) {
      return "N/A";
    }

    const getBranchTotalAllocated = (branch, branchIdx) => {
      const mainQty =
        branchIdx === 0
          ? calculateHQQuantity()
          : Number(branchQuantities[branch.branch_id] || 0);

      const focQty =
        branchIdx === 0
          ? calculateHQFocQuantity()
          : Number(branchFocQuantities[branch.branch_id] || 0);

      const pwpQty = pwpItems.reduce((sum, pwpItem) => {
        const tagQty =
          branchIdx === 0
            ? calculateHQPwpQuantity(pwpItem.promotionId)
            : Number(
                branchPwpQuantities[pwpItem.promotionId]?.[branch.branch_id] ||
                  0,
              );
        return sum + tagQty;
      }, 0);

      return mainQty + focQty + pwpQty;
    };

    const allocatedNames = branches
      .map((branch, branchIdx) => {
        const totalAllocated = getBranchTotalAllocated(branch, branchIdx);
        if (totalAllocated <= 0) return null;
        return (
          branch.branch_name || branch.branch_code || String(branch.branch_id)
        );
      })
      .filter(Boolean);

    if (allocatedNames.length > 0) {
      return allocatedNames.join(", ");
    }

    return (
      branches[0]?.branch_name ||
      branches[0]?.branch_code ||
      String(branches[0]?.branch_id || "N/A")
    );
  }, [
    branches,
    branchQuantities,
    branchFocQuantities,
    branchPwpQuantities,
    pwpItemsKey,
    quantity,
  ]);

  const selectedItemSubtotal =
    (displayPrice.original ?? displayPrice.price) * quantity;

  const getTotalPwpQuantity = (pwpTagId) => {
    const tagQuantities = branchPwpQuantities[pwpTagId] || {};
    return Object.values(tagQuantities).reduce(
      (sum, qty) => sum + (parseInt(qty) || 0),
      0,
    );
  };

  const calculatePwpSubtotal = () => {
    return pwpItems.reduce((sum, pwpItem) => {
      const { price } = getPwpPricing(pwpItem);
      return sum + getTotalPwpQuantity(pwpItem.promotionId) * price;
    }, 0);
  };

  const calculatePwpDiscount = () => {
    return pwpItems.reduce((sum, pwpItem) => {
      const { discountPrice } = getPwpPricing(pwpItem);
      return sum + getTotalPwpQuantity(pwpItem.promotionId) * discountPrice;
    }, 0);
  };

  const calculatePwpTotal = () => {
    return pwpItems.reduce((sum, pwpItem) => {
      const { price } = getPwpPricing(pwpItem);
      return sum + getTotalPwpQuantity(pwpItem.promotionId) * price;
    }, 0);
  };

  const calculateType3Discount = () => {
    const type3Tag = selectedTags.find((tag) => tag.type === 3);
    if (type3Tag) {
      const type3Promo = productData?.promotion?.find(
        (p) => p.id === type3Tag.id,
      );
      if (type3Promo && type3Promo.brand_price) {
        return (
          quantity *
          (parseFloat(pricing.brand_price || 0) -
            parseFloat(type3Promo.brand_price))
        );
      }
    }
    return 0;
  };

  const calculateType6Discount = () => {
    const type6Tag = selectedTags.find((tag) => tag.type === 6);
    if (type6Tag) {
      const type6Promo = productData?.promotion?.find(
        (p) => p.id === type6Tag.id,
      );
      if (type6Promo && type6Promo.display_discount?.display_discount?.[0]) {
        const discount = parseFloat(
          type6Promo.display_discount.display_discount[0].discount || 0,
        );
        const brandPrice = parseFloat(pricing.brand_price || 0);
        return (brandPrice * discount) / 100;
      }
    }
    return 0;
  };

  const calculateType4Discount = () => {
    const focTag = selectedTags.find(
      (tag) => tag.type === 4 && tag.offerType === "1" && tag.offerId !== "0",
    );
    if (focTag && focTag.offerDiscount && pricing?.brand_price) {
      const brandPrice = parseFloat(pricing.brand_price || 0);
      const apiPrice = getQuantityOfferDiscountedPrice(focTag.id);
      if (apiPrice !== null) {
        return quantity * (brandPrice - apiPrice);
      }
    }
    return 0;
  };

  const calculateSubtotal = () => {
    if (displayDiscountInfo && displayDiscountInfo.groupQty > 1) {
      return selectedItemSubtotal;
    }
    // 其它类型
    return quantity * (originalPrice || 0);
  };

  const calculateDiscount = () => {
    return (
      calculateType3Discount() +
      calculateType4Discount() +
      calculateType6Discount()
    );
  };

  const calculateTotal = () => {
    if (displayDiscountInfo && displayDiscountInfo.groupQty > 1) {
      // 只用 props.quantity 计算，不用 getTotalPaidQuantity()
      return (
        groupCount *
          (displayDiscountInfo.normalPrice * displayDiscountInfo.orderQty +
            displayDiscountInfo.discountPrice) +
        remain * displayDiscountInfo.normalPrice
      );
    }
    // 其它类型
    if (currentPrice === null) return null;
    return quantity * (currentPrice || 0) + calculatePwpTotal();
  };

  function getFocPricePerUnitForOffer(focOffer) {
    if (!focOffer || !pricing?.brand_price) return "0.00";
    const order = parseInt(focOffer.order, 10);
    const foc = parseInt(focOffer.foc, 10);
    const totalQty = order + foc;
    if (!totalQty) return "0.00";

    const preDiscountSubtotal = parseFloat(pricing.brand_price) * order;
    const pricePerUnit = preDiscountSubtotal / totalQty;
    return pricePerUnit ? formatCurrency(pricePerUnit) : "0.00";
  }

  useEffect(() => {
    if (isLoggedIn && SHOW_REGION_POPUP === 1 && !selectedRegion) return;
    if (!item_id) return;

    const getPromotionSelectionOnMount = async () => {
      setPromotionLoading(true);
      try {
        const response = await ApiService.getPromotionSelection(
          item_id,
          selectedRegion,
          quantity,
        );

        if (response && response.status === 200) {
          setPromotionForDisplay(response.data.promotion_for_display);
          const ids = (response.data?.selected_promotion_ids || []).map(
            (p) => p.id,
          );
          setSelectedPromotionIds(ids);
          shouldScrollPromotionRowRef.current = true;
        }
      } catch (error) {
        console.error("Error fetching promotion selection:", error);
      } finally {
        setPromotionLoading(false);
      }
    };
    getPromotionSelectionOnMount();
  }, [selectedRegion]);

  useEffect(() => {
    if (!promotionLoading) {
      setShowPromotionLoadingOverlay(false);
      return;
    }

    const timer = setTimeout(() => {
      setShowPromotionLoadingOverlay(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, [promotionLoading]);

  useEffect(() => {
    if (promotionLoading || !shouldScrollPromotionRowRef.current) return;

    const frame = requestAnimationFrame(() => {
      const container = promotionTagsRef.current;
      if (!container || selectedPromotionIds.length === 0) {
        shouldScrollPromotionRowRef.current = false;
        return;
      }

      const selectedIds = selectedPromotionIds.map(String);
      const selectedWrappers = Array.from(container.children).filter((el) =>
        selectedIds.includes(el.dataset.promotionId),
      );
      if (selectedWrappers.length === 0) {
        shouldScrollPromotionRowRef.current = false;
        return;
      }

      const target = selectedWrappers[selectedWrappers.length - 1];
      const maxScroll = Math.max(
        0,
        container.scrollWidth - container.clientWidth,
      );
      const desired =
        target.offsetLeft - (container.clientWidth - target.offsetWidth) / 2;

      container.scrollTo({
        left: Math.min(maxScroll, Math.max(0, desired)),
        behavior: "smooth",
      });
      shouldScrollPromotionRowRef.current = false;
    });

    return () => cancelAnimationFrame(frame);
  }, [promotionLoading, selectedPromotionIds, promotionForDisplay]);

  const applyPromotionSelection = async (promoIdParam, qty) => {
    setPromotionLoading(true);
    try {
      const response = await ApiService.getPromotionSelection(
        item_id,
        selectedRegion,
        qty,
      );
      if (response && response.status === 200) {
        setPromotionForDisplay(response.data.promotion_for_display);
        const ids = (response.data?.selected_promotion_ids || []).map(
          (p) => p.id,
        );
        setSelectedPromotionIds(ids);
        shouldScrollPromotionRowRef.current = true;

        // Any PWP tag no longer present in the server's selection must have
        // its quantity cleared back to 0.
        setPwpQuantities((prev) => {
          let changed = false;
          const next = { ...prev };
          Object.keys(next).forEach((tagId) => {
            if (!ids.includes(tagId) && (next[tagId] || 0) !== 0) {
              next[tagId] = 0;
              changed = true;
            }
          });
          return changed ? next : prev;
        });
      }
    } catch (error) {
      console.error("Error fetching promotion selection:", error);
    } finally {
      setPromotionLoading(false);
    }
  };

  const handleQuantityBlur = () => {
    if (quantityInputStr === "") {
      let finalQty;
      if (hasFocSelected && currentFocOrder) {
        finalQty = currentFocOrder;
      } else if (isPackageItem && packing_quantity > 0) {
        finalQty = packing_quantity;
      } else {
        finalQty = 0;
      }

      setQuantity(finalQty);
      setQuantityInputStr(String(finalQty));
      setInvalidPackingQty(false);
      setInvalidDiscountQty(false);
      return;
    }

    if (promotionId) {
      applyPromotionSelection(promotionId, quantity);
    }
  };

  // ── Render ───────────────────────────────────
  return (
    <div className="productdetail">
      {loading ? (
        <div style={{ textAlign: "center", padding: "50px" }}>
          Loading product details...
        </div>
      ) : error ? (
        <div style={{ textAlign: "center", padding: "50px", color: "red" }}>
          {error}
        </div>
      ) : !productData ? (
        <div style={{ textAlign: "center", padding: "50px" }}>
          Product not found
        </div>
      ) : (
        <>
          {promotionLoading && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                zIndex: 9999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(255,255,255,0.55)",
                opacity: showPromotionLoadingOverlay ? 1 : 0,
              }}
            >
              <div className="loading-spinner" />
            </div>
          )}
          <Breadcrums productName={product.item_name} />

          {showLoginPrompt && (
            <MultiPurpose
              title="Login Required"
              message="You need to login to buy this product."
              yesText="Login"
              noText="Cancel"
              showYesLink={true}
              yesLink={REDIRECT_LOGIN_URL}
              onNo={() => setShowLoginPrompt(false)}
              onClose={() => setShowLoginPrompt(false)}
            />
          )}

          {notice.show && pendingStep === "quantity" && (
            <MultiPurpose
              title={notice.noticeTitle || "Notice"}
              message={notice.message}
              yesText={notice.yesText || "OK"}
              onYes={() => {
                setNotice({ show: false, message: "" });
                setPendingStep("");
              }}
              onClose={() => {
                setNotice({ show: false, message: "" });
                setPendingStep("");
              }}
              hideNo={true}
            />
          )}

          {showPurchaseHistory && (
            <PurchaseHistory
              onClose={() => setShowPurchaseHistory(false)}
              history={history}
              pricingtype={pricing_type}
              item_id={item_id}
              bundle_id={bundleId}
            />
          )}

          {/* ORP 弹窗 */}
          {orpMsg && pendingStep === "orp" && (
            <MultiPurpose
              title="ORP Notice"
              message={<span dangerouslySetInnerHTML={{ __html: orpMsg }} />}
              yesText="Noted"
              onYes={handleOrpClose}
              onClose={handleOrpClose}
              hideNo={true}
            />
          )}

          {/* Term 和 Virtual 弹窗 */}
          {notice.show &&
            (pendingStep === "term" || pendingStep === "virtual") && (
              <MultiPurpose
                title={notice.noticeTitle || "Notice"}
                message={notice.message}
                yesText={notice.yesText || "OK"}
                onYes={handleNoticeClose}
                onClose={handleNoticeClose}
                hideNo={true}
              />
            )}

          {showPromoTip && (
            <MultiPurpose
              title="Better Deal Available"
              message={
                <>
                  A more cost-effective promotion is available for this order.
                  <br />
                  <span style={{ color: "#2e7d32", fontWeight: "bold" }}>
                    {getBestDealLabel()}
                  </span>
                </>
              }
              yesText="Switch to Best Deal"
              noText="Continue Anyway"
              onYes={() => {
                const tags = getPromotionTags(productData.promotion);
                const freeGiftTag = tags.find((t) => t.type === 2);

                // 自动设置 quantity
                let newQuantity = 0;
                if (bestId && bestId.includes("_")) {
                  // type 4: Buy X Free Y
                  const [promoId, offerId] = bestId.split("_");
                  const promo = productData.promotion.find(
                    (p) => p.id === promoId,
                  );
                  const offer = promo?.quantity_offer?.find(
                    (o) => o.id === offerId,
                  );
                  if (offer) {
                    newQuantity = parseInt(offer.order, 10);
                  }
                } else if (bestId) {
                  // type 6: Display Discount
                  const tag = tags.find((t) => t.id === bestId);
                  if (tag && tag.type === 6) {
                    const promo = productData.promotion.find(
                      (p) => p.id === tag.id,
                    );
                    const dd = promo?.display_discount?.display_discount?.[0];
                    if (dd?.order) newQuantity = parseInt(dd.order, 10) + 1;
                  }
                  // 其它类型默认1
                }

                if (freeGiftTag) {
                  setSelectedPromotionIds([freeGiftTag.id, bestId]);
                } else {
                  setSelectedPromotionIds([bestId]);
                }
                setQuantity(newQuantity); // 自动设置数量
                setShowPromoTip(false);
              }}
              onNo={() => {
                setShowPromoTip(false);
                actuallyAddToCart();
              }}
              onClose={() => setShowPromoTip(false)}
            />
          )}

          {showPwpZeroQtyConfirm && (
            <MultiPurpose
              title="Notice"
              message="You have selected a PWP promotion with quantity 0. Do you want to continue without adding any quantity?"
              yesText="Continue"
              noText="Cancel"
              onYes={() => {
                setShowPwpZeroQtyConfirm(false);
                setShowPromoTip(false);
                setPendingStep("");
                handleAddToCart({
                  orp: true,
                  term: true,
                  virtual: true,
                  bestDeal: true,
                  pwp: true,
                });
              }}
              onNo={() => {
                setShowPwpZeroQtyConfirm(false);
              }}
              onClose={() => setShowPwpZeroQtyConfirm(false)}
            />
          )}

          {showAddToCartSuccess.show && (
            <AddToCartSuccess
              text={showAddToCartSuccess.text}
              tick={showAddToCartSuccess.tick}
              onClose={() => {
                setShowAddToCartSuccess({ show: false, text: "" });
              }}
            />
          )}

          <div className="productdetail-content">
            {canView ? (
              <>
                <div className="productdetail-main-v2">
                  <div className="productdetail-left-v2">
                    {/* Step 1 */}
                    <div className="productdetail-card">
                      {productData.filter_label?.includes("coming_soon") ? (
                        <div className="productdetail-cardtitle-container orange">
                          <div className="productdetail-cardtitle">
                            <Calendar size={20} />
                            <div>COMING SOON</div>
                          </div>
                        </div>
                      ) : (
                        <div className="productdetail-cardtitle-container">
                          <div
                            className="productdetail-cardtitle"
                            style={{ border: "none" }}
                          >
                            {allowAddToCart ? (
                              <div className="pd-num-success">
                                <Check size={16} />
                              </div>
                            ) : (
                              <div className="pd-num">1</div>
                            )}
                            <div>Select Quantity</div>
                          </div>
                          {localStorage.getItem("salesman_id") && (
                            <div className="pd-qty-tooltip-wrapper-v2">
                              <span className="pd-qty-tooltip-icon-v2">
                                <Info size={20} />
                              </span>
                              <div className="pd-qty-tooltip-box-v2">
                                <div>
                                  <table>
                                    {/* {packing_quantity > 1 && (
                                      <tr>
                                        <td>Min order quantity</td>
                                        <td>:</td>
                                        <td style={{ textAlign: "right" }}>
                                          <strong>{packing_quantity}</strong>
                                        </td>
                                      </tr>
                                    )}
                                    {stepValue > 1 && (
                                      <tr>
                                        <td>Order in multiples of</td>
                                        <td>:</td>
                                        <td style={{ textAlign: "right" }}>
                                          <strong>{stepValue}</strong>
                                        </td>
                                      </tr>
                                    )} */}
                                    {getStockDisplayRows().map((row) => (
                                      <tr key={row.key}>
                                        <td>{row.label}</td>
                                        <td>:</td>
                                        <td style={{ textAlign: "right" }}>
                                          <strong>{row.qty ?? 0}</strong>
                                        </td>
                                      </tr>
                                    ))}
                                  </table>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}

                      <div
                        className="productdetail-carddetail"
                        style={{ flexDirection: "column" }}
                      >
                        <div style={{ display: "flex", gap: "28px" }}>
                          {/* LEFT: Images */}
                          <div className="pd-carddetail-left">
                            <div className="productimage-container-v2">
                              {/* Previous Button - Only show if more than 1 image */}
                              {images.length > 1 && (
                                <button
                                  className="image-nav-button-v2 image-nav-prev"
                                  onClick={handlePrevImage}
                                >
                                  <ChevronLeft size={16} />
                                </button>
                              )}

                              {images[slideIndex]?.type === "video" ? (
                                // Video display
                                <div className="video-container">
                                  {/* Overlays inside video-container */}
                                  {isLoggedIn &&
                                    !isDiscontinued &&
                                    (notforsell ? (
                                      <div className="product-discontinued-overlay">
                                        Not for Sell
                                      </div>
                                    ) : freeGiftOutOfStock ? (
                                      <div className="product-outofstock-overlay">
                                        Free Gift Out of Stock
                                      </div>
                                    ) : !canBuy ? (
                                      <div className="product-outofstock-overlay">
                                        Out of stock
                                      </div>
                                    ) : null)}

                                  {isDiscontinued && (
                                    <div className="product-discontinued-overlay">
                                      Discontinued
                                    </div>
                                  )}

                                  <video
                                    ref={videoRef}
                                    controls
                                    autoPlay
                                    muted
                                    className="main-product-video"
                                    src={images[slideIndex].url}
                                    poster={
                                      images.find((img) => img.type === "image")
                                        ?.url || undefined
                                    }
                                    key={slideIndex}
                                  >
                                    Your browser does not support the video tag.
                                  </video>
                                </div>
                              ) : (
                                // Image display with magnifier
                                <div
                                  className="image-magnifier-container-v2"
                                  onMouseMove={handleMouseMove}
                                  onMouseEnter={handleMouseEnter}
                                  onMouseLeave={handleMouseLeave}
                                >
                                  {isLoggedIn &&
                                    !isDiscontinued &&
                                    // priority: Not for Sell > Free Gift Out of Stock > Out of stock
                                    (notforsell ? (
                                      <div className="product-discontinued-overlay">
                                        Not for Sell
                                      </div>
                                    ) : freeGiftOutOfStock ? (
                                      <div className="product-outofstock-overlay">
                                        Free Gift Out of Stock
                                      </div>
                                    ) : !canBuy ? (
                                      <div className="product-outofstock-overlay">
                                        Out of stock
                                      </div>
                                    ) : null)}

                                  {isDiscontinued && (
                                    <div className="product-discontinued-overlay">
                                      Discontinued
                                    </div>
                                  )}
                                  <FallbackImg
                                    key={images[slideIndex]?.url}
                                    ref={imageRef}
                                    src={images[slideIndex]?.url}
                                    alt={product.item_name || "Product"}
                                    className="main-product-image"
                                    onClick={handleImageClick}
                                  />

                                  {/* Magnifier Lens */}
                                  {showMagnifier && (
                                    <div
                                      className="magnifier-lens-v2"
                                      style={{
                                        left: `${cursorPosition.x - 25}px`,
                                        top: `${cursorPosition.y - 25}px`,
                                      }}
                                    />
                                  )}
                                </div>
                              )}

                              {/* Next Button - Only show if more than 1 image */}
                              {images.length > 1 && (
                                <button
                                  className="image-nav-button-v2 image-nav-next"
                                  onClick={handleNextImage}
                                >
                                  <ChevronRight size={16} />
                                </button>
                              )}

                              {/* Magnified View - only for images */}
                              {showMagnifier &&
                                images[slideIndex]?.type === "image" && (
                                  <div
                                    ref={magnifierRef}
                                    className="magnifier-result"
                                    style={{
                                      backgroundImage: `url(${images[slideIndex].url})`,
                                      backgroundPosition: `${magnifierPosition.x}% ${magnifierPosition.y}%`,
                                    }}
                                  />
                                )}
                            </div>

                            {/* Slideshow Indicators with scroll */}
                            {images.length > 1 && (
                              <div className="productimage-thumb-wrapper-v2">
                                <button
                                  className="thumb-scroll-btn-v2 thumb-scroll-left"
                                  onClick={() => {
                                    const container = document.querySelector(
                                      ".productimage-thumb-container-v2",
                                    );
                                    container.scrollLeft -= 200;
                                  }}
                                  style={{
                                    display:
                                      images.length > 3 ? "flex" : "none",
                                  }}
                                >
                                  <ChevronLeft size={16} />
                                </button>

                                <div className="productimage-thumb-container-v2">
                                  {images.map((item, idx) => {
                                    if (item.type === "video") {
                                      const posterImage = images.find(
                                        (img) => img.type === "image",
                                      )?.url;
                                      return (
                                        <div
                                          key={idx}
                                          className={`video-thumb-wrapper-v2${
                                            slideIndex === idx ? " active" : ""
                                          }`}
                                          onClick={() => setSlideIndex(idx)}
                                        >
                                          <FallbackImg
                                            src={posterImage}
                                            alt="Video thumbnail"
                                            className="productimage-thumb-v2"
                                          />
                                          <div
                                            className="video-play-overlay"
                                            onClick={(e) =>
                                              handlePlayIconClick(e, idx)
                                            }
                                          >
                                            <Play
                                              size={16}
                                              color={"#fffffff"}
                                              fill={"#ffffff"}
                                            />
                                          </div>
                                        </div>
                                      );
                                    } else {
                                      return (
                                        <FallbackImg
                                          key={idx}
                                          src={item.thumb}
                                          alt={`${product.item_name || "Product"} - Image ${
                                            idx + 1
                                          }`}
                                          className={`productimage-thumb-v2${
                                            slideIndex === idx ? " active" : ""
                                          }`}
                                          onClick={() => setSlideIndex(idx)}
                                        />
                                      );
                                    }
                                  })}
                                </div>

                                <button
                                  className="thumb-scroll-btn-v2 thumb-scroll-right"
                                  onClick={() => {
                                    const container = document.querySelector(
                                      ".productimage-thumb-container-v2",
                                    );
                                    container.scrollLeft += 200;
                                  }}
                                  style={{
                                    display:
                                      images.length > 3 ? "flex" : "none",
                                  }}
                                >
                                  <ChevronRight size={16} />
                                </button>
                              </div>
                            )}
                          </div>

                          {/* RIGHT: Details */}
                          <div className="pd-carddetail-right-v2">
                            <div className="productspecs-v2">
                              <div className="productdetailcode-container-v2">
                                <div className="productdetailcode-v2">
                                  {product.item_code || "N/A"}
                                </div>

                                <div className="productdetailname-v2">
                                  {product.item_name || "Product Name"}
                                </div>

                                {sellingPoints && sellingPoints.length > 0 && (
                                  <div className="product-highlights-v2">
                                    {sellingPoints.map((point, index) => (
                                      <span
                                        key={index}
                                        className="highlight-text-v2"
                                      >
                                        {point}
                                      </span>
                                    ))}
                                  </div>
                                )}
                              </div>

                              {isLoggedIn && (
                                <div className="producthistory-actions">
                                  {isLoggedIn && history.length > 0 ? (
                                    <div
                                      className="producthistory-v2 active"
                                      onClick={() =>
                                        setShowPurchaseHistory(true)
                                      }
                                    >
                                      <History size={16} />
                                    </div>
                                  ) : (
                                    <div
                                      className="producthistory-v2-wrapper"
                                      style={{
                                        cursor: "not-allowed",
                                        display: "inline-block",
                                      }}
                                      title="No Purchase History"
                                    >
                                      <div
                                        className="producthistory-v2"
                                        onClick={() =>
                                          setShowPurchaseHistory(true)
                                        }
                                        style={{ pointerEvents: "none" }}
                                      >
                                        <History size={16} />
                                      </div>
                                    </div>
                                  )}

                                  {!isDiscontinued && isLoggedIn && (
                                    <div
                                      className={`heart-v2 ${
                                        isFavourite ? " wishlist-active" : ""
                                      }`}
                                      onClick={() => {
                                        if (!canOrder || favoriteLoading)
                                          return;
                                        // Use the route `item_id` (path param) so add/fav payloads
                                        // include the correct item_id instead of the bundle's product.id
                                        handleFavoriteToggle(
                                          item_id,
                                          pricing.pricing_type,
                                        );
                                      }}
                                      style={{
                                        cursor: canOrder
                                          ? favoriteLoading
                                            ? "wait"
                                            : "pointer"
                                          : "not-allowed",
                                        opacity: canOrder
                                          ? favoriteLoading
                                            ? 0.6
                                            : 1
                                          : 0.5,
                                      }}
                                      title={
                                        canOrder
                                          ? isFavourite
                                            ? "Remove from favorite"
                                            : "Add to favorite"
                                          : "No permission"
                                      }
                                    >
                                      <Heart
                                        key={`favorite-${item_id}-${isFavourite}`}
                                        size={16}
                                        fill={isFavourite ? "#e7000b" : "none"}
                                      />
                                    </div>
                                  )}

                                  {(product?.mag_link ||
                                    productData?.mag_link ||
                                    (productData?.bundle_items &&
                                      productData.bundle_items.some(
                                        (it) => it.mag_link,
                                      )) ||
                                    (productData?.bundle_items &&
                                      productData.bundle_items.some(
                                        (it) =>
                                          it.product && it.product.mag_link,
                                      ))) && (
                                    <div
                                      className="magazine-link-v2"
                                      onClick={handleMagazineClick}
                                      title="View Magazine"
                                    >
                                      <BookOpen size={16} />
                                    </div>
                                  )}

                                  {isLoggedIn && (
                                    <div
                                      className="sharenetwork-v2"
                                      style={{ position: "relative" }}
                                      onClick={handleShareClick}
                                    >
                                      <Share2 size={16} />

                                      {showShareMenu && (
                                        <div
                                          className="share-popup-v2"
                                          ref={shareMenuRef}
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          <div className="share-popup-arrow-v2"></div>
                                          <div className="share-popup-title">
                                            Share via:
                                          </div>
                                          <div className="share-popup-icons">
                                            <span
                                              className="share-icon facebook"
                                              onClick={() =>
                                                handleShareOption("facebook")
                                              }
                                            >
                                              <FontAwesomeIcon
                                                icon={faFacebookF}
                                              />
                                            </span>
                                            <span
                                              className="share-icon twitter"
                                              onClick={() =>
                                                handleShareOption("twitter")
                                              }
                                            >
                                              <FontAwesomeIcon
                                                icon={faXTwitter}
                                              />
                                            </span>
                                            <span
                                              className="share-icon whatsapp"
                                              onClick={() =>
                                                handleShareOption("whatsapp")
                                              }
                                            >
                                              <FontAwesomeIcon
                                                icon={faWhatsapp}
                                              />
                                            </span>
                                            <span
                                              className="share-icon copy"
                                              onClick={() =>
                                                handleShareOption("copy")
                                              }
                                            >
                                              <Share2 size={16} />
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>

                            {canBuy ? (
                              <>
                                <div className="productinfo-v2">
                                  <div className="productdetailtype">
                                    RCP{" "}
                                    <span style={{ color: "#737373" }}>
                                      RM{" "}
                                      {formatCurrency(
                                        pricing?.rcp ?? product.rcp,
                                      )}
                                    </span>
                                  </div>

                                  <div className="productprice-container-v2">
                                    {selectedTags.some(
                                      (tag) => tag.type === 4,
                                    ) &&
                                      (() => {
                                        const focTag = selectedTags.find(
                                          (tag) => tag.type === 4,
                                        );
                                        return (
                                          <>
                                            {focTag.offerType === "1" &&
                                            focTag.offerId !== "0" ? (
                                              <span className="productprice orange">
                                                RM{" "}
                                                {getFocDiscountPricePerUnit(
                                                  selectedTags,
                                                  productData,
                                                )}
                                              </span>
                                            ) : focTag.offerId !== "0" ? (
                                              <span className="productprice orange">
                                                RM{" "}
                                                {getFocPricePerUnit(
                                                  selectedTags,
                                                  productData,
                                                  quantity,
                                                )}
                                              </span>
                                            ) : null}
                                          </>
                                        );
                                      })()}

                                    {selectedTags.some(
                                      (tag) => tag.type === 3,
                                    ) &&
                                      (() => {
                                        const discountTag = selectedTags.find(
                                          (tag) => tag.type === 3,
                                        );
                                        const promo =
                                          productData.promotion.find(
                                            (p) => p.id === discountTag?.id,
                                          );
                                        return (
                                          <span className="productprice orange">
                                            RM{" "}
                                            {getItemDiscountPricePerUnit(promo)}
                                          </span>
                                        );
                                      })()}

                                    {displayPrice.price > 0 ? (
                                      displayPrice.original ? (
                                        <>
                                          <div
                                            className={`productprice${
                                              hasItemDiscountSelected ||
                                              hasFocSelected
                                                ? " line-through"
                                                : ""
                                            }`}
                                          >
                                            RM{" "}
                                            {displayPrice.original
                                              ? formatCurrency(
                                                  displayPrice.original,
                                                )
                                              : "0.00"}
                                          </div>
                                          {!hasItemDiscountSelected &&
                                            !hasFocSelected && (
                                              <div
                                                style={{ height: "15.2px" }}
                                              ></div>
                                            )}
                                        </>
                                      ) : (
                                        <>
                                          <div className="productprice">
                                            RM{" "}
                                            {displayPrice.price
                                              ? formatCurrency(
                                                  displayPrice.price,
                                                )
                                              : "0.00"}
                                          </div>
                                          <div
                                            style={{ height: "15.2px" }}
                                          ></div>
                                        </>
                                      )
                                    ) : null}
                                  </div>

                                  {productData.product_type !== "RCP" && (
                                    <div className="productdetail-pricingtypetag">
                                      {productData.product_type || "N/A"}
                                    </div>
                                  )}
                                </div>

                                <div className="productinput-v2">
                                  <div className="main-productqty-container">
                                    <div className="main-productqty">
                                      <button
                                        className="main-minus-qty-btn"
                                        onClick={handleDecrease}
                                        type="button"
                                        disabled={
                                          (hasDisplayDiscountSelected &&
                                            quantity <=
                                              (() => {
                                                const displayTag =
                                                  selectedTags.find(
                                                    (tag) => tag.type === 6,
                                                  );
                                                const promo =
                                                  productData.promotion.find(
                                                    (p) =>
                                                      p.id === displayTag?.id,
                                                  );
                                                const dd =
                                                  promo?.display_discount
                                                    ?.display_discount?.[0];
                                                const offerOrder = dd
                                                  ? parseInt(dd.order, 10)
                                                  : 1;
                                                return offerOrder + 1;
                                              })()) ||
                                          productData?.filter_label?.includes(
                                            "out_of_stock",
                                          )
                                        }
                                      >
                                        <Minus size={16} />
                                      </button>

                                      <input
                                        type="text"
                                        className="productqty-value-v2"
                                        value={quantityInputStr}
                                        onChange={handleQuantityInputChange}
                                        onBlur={handleQuantityBlur}
                                        // readOnly={currentType === 4}
                                      />

                                      <button
                                        className="main-plus-qty-btn"
                                        onClick={handleIncrease}
                                        type="button"
                                        disabled={
                                          (hasFocSelected &&
                                            quantity >=
                                              getFocMaxQty(
                                                productData.promotion
                                                  .find((p) =>
                                                    currentFocTag.id.startsWith(
                                                      p.id,
                                                    ),
                                                  )
                                                  ?.quantity_offer.find(
                                                    (qo) =>
                                                      qo.id ===
                                                      currentFocTag.id.split(
                                                        "_",
                                                      )[1],
                                                  ),
                                                productData.promotion.find(
                                                  (p) =>
                                                    currentFocTag.id.startsWith(
                                                      p.id,
                                                    ),
                                                ),
                                              )) ||
                                          (hasDisplayDiscountSelected &&
                                            quantity + groupQty >
                                              getDisplayDiscountMaxQty()) ||
                                          (!hasFocSelected &&
                                            !hasDisplayDiscountSelected &&
                                            quantity + stepValue >
                                              (hasItemDiscountSelected &&
                                              hasPwpSelected
                                                ? Math.max(
                                                    getMaxQuantity(),
                                                    getPWPMaxQty(),
                                                  )
                                                : hasPwpSelected
                                                  ? getPWPMaxQty()
                                                  : getMaxQuantity())) ||
                                          productData?.filter_label?.includes(
                                            "out_of_stock",
                                          )
                                        }
                                      >
                                        <Plus size={16} />
                                      </button>
                                    </div>
                                    {quantity > 0 && (
                                      <div
                                        style={{
                                          color: "#737373",
                                          fontSize: "12px",
                                        }}
                                      >
                                        = {quantity} unit
                                      </div>
                                    )}
                                    {focTotal > 0 && (
                                      <span
                                        style={{
                                          color: "#9810FA",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {" "}
                                        + FOC {focTotal}
                                      </span>
                                    )}
                                  </div>

                                  <div>
                                    {!isQuantityValid() && (
                                      <div className="quantity-error-v2">
                                        Maximum {getMaxQuantity()} items
                                        available
                                      </div>
                                    )}
                                    {freeGiftOutOfStock && (
                                      <div className="quantity-error-v2">
                                        Free Gift out of stock
                                      </div>
                                    )}
                                    {invalidPackingQty && (
                                      <div className="quantity-error-v2">
                                        Please enter a quantity that is a
                                        multiple of {packing_quantity}
                                      </div>
                                    )}
                                    {invalidDiscountQty && (
                                      <div className="quantity-error-v2">
                                        Please enter a quantity that is a
                                        multiple of {groupQty}
                                      </div>
                                    )}
                                    {/* {isFocQtyExceeded && (
                                    <div className="quantity-error">
                                      This tier requires {quantity} units, but
                                      only {getFocMaxQty()}{" "}
                                      {getFocMaxQty() === 1
                                        ? "unit is"
                                        : "units are"}{" "}
                                      available for this promotion.
                                    </div>
                                  )} */}
                                    {(quantity === 0 ||
                                      quantityInputStr === "") && (
                                      <div
                                        style={{
                                          color: "#a1a1a1",
                                          fontSize: "11px",
                                        }}
                                      >
                                        Enter a quantity to continue
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </>
                            ) : (
                              // if product is outofstock
                              <div className="productinfo-v2">
                                <div className="productdetailtype">
                                  <span style={{ color: "#6b7280" }}>RCP</span>
                                </div>

                                <div className="productprice-container-v2">
                                  {displayPrice.price > 0 && (
                                    <div className="productprice">
                                      RM{" "}
                                      {displayPrice.price
                                        ? formatCurrency(displayPrice.price)
                                        : "0.00"}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}

                            {(isLoggedIn &&
                              isItemLimited() &&
                              !isDiscontinued) ||
                            (isLoggedIn &&
                              productData?.filter_label?.includes(
                                "out_of_stock",
                              ) &&
                              !isDiscontinued) ||
                            (isLoggedIn &&
                              freeGiftOutOfStock &&
                              !isDiscontinued) ? (
                              <div style={{ marginTop: "16px" }}>
                                {!inWishlist ? (
                                  <div
                                    className="pd-button"
                                    onClick={
                                      canOrder && !wishlistLoading
                                        ? handleWishlistToggle
                                        : undefined
                                    }
                                    disabled={!canOrder || wishlistLoading}
                                    style={{
                                      opacity: canOrder
                                        ? wishlistLoading
                                          ? 0.6
                                          : 1
                                        : 0.5,
                                      cursor: canOrder
                                        ? wishlistLoading
                                          ? "wait"
                                          : "pointer"
                                        : "not-allowed",
                                    }}
                                    title={canOrder ? "" : "No permission"}
                                  >
                                    <Bookmark size={20} />
                                    ADD TO WISHLIST
                                  </div>
                                ) : (
                                  <div
                                    className="pd-inwishlist-button"
                                    onClick={
                                      canOrder && !wishlistLoading
                                        ? handleWishlistToggle
                                        : undefined
                                    }
                                    disabled={!canOrder || wishlistLoading}
                                    style={{
                                      opacity: canOrder
                                        ? wishlistLoading
                                          ? 0.6
                                          : 1
                                        : 0.5,
                                      cursor: canOrder
                                        ? wishlistLoading
                                          ? "wait"
                                          : "pointer"
                                        : "not-allowed",
                                    }}
                                    title={canOrder ? "" : "No permission"}
                                  >
                                    <Bookmark size={20} fill={"#f54a00"} />
                                    IN WISHLIST
                                  </div>
                                )}
                              </div>
                            ) : null}

                            {!isLoggedIn && (
                              <div style={{ marginTop: "16px" }}>
                                <div
                                  className="pd-button"
                                  onClick={() => {
                                    window.location.href = REDIRECT_LOGIN_URL;
                                  }}
                                >
                                  Login / Register To Buy
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {isLoggedIn &&
                          canBuy &&
                          productData.promotion &&
                          productData.promotion.length > 0 &&
                          renderAllPromotion()}
                      </div>
                    </div>

                    {/* Step 2 */}
                    {!productData.filter_label?.includes("coming_soon") &&
                      branches.length !== 1 && (
                        <div className="productdetail-card">
                          <div className="productdetail-cardtitle">
                            {!canBuy || quantity === 0 ? (
                              <div className="pd-num-lock">
                                <Lock size={12} />
                              </div>
                            ) : allowAddToCart ? (
                              <div className="pd-num-success">
                                <Check size={16} />
                              </div>
                            ) : (
                              <div className="pd-num">2</div>
                            )}
                            <div>Branch Allocation</div>
                          </div>

                          <div
                            className="productdetail-carddetail"
                            style={{ flexDirection: "column" }}
                          >
                            {!canBuy ? (
                              <div className="pd-step2-lock">
                                <div>
                                  <Lock size={48} />
                                </div>
                                <div>The item is currently unavailable</div>
                              </div>
                            ) : quantity === 0 || quantityInputStr === "" ? (
                              <div className="pd-step2-lock">
                                <div>
                                  <Lock size={48} />
                                </div>
                                <div>
                                  Select a quantity above to configure branch
                                  allocation
                                </div>
                              </div>
                            ) : (
                              <>
                                {/* <div className="pd-quickactions">
                                  <div className="pd-quickactions-title">
                                    Quick Actions
                                  </div>

                                  <div className="pd-quickactions-cardcontainer">
                                    <div
                                      className={`pd-quickactions-card ${distributionMode === "hq" ? "active" : ""}`}
                                      onClick={handleAllToHQ}
                                    >
                                      <Zap size={16} />{" "}
                                      {String(branches[0]?.branch_id) !== "0"
                                        ? `All to ${branches[0]?.branch_code || branches[0]?.branch_name || "Branch"}`
                                        : "All to HQ"}
                                    </div>

                                    <div
                                      className={`pd-quickactions-card ${distributionMode === "custom" ? "active" : ""} ${branches.length <= 1 ? "disabled" : ""}`}
                                      onClick={() => {
                                        if (branches.length <= 1) return;
                                        setDistributionMode("custom");
                                        setAllowAddToCart(false);
                                      }}
                                      style={{
                                        opacity: branches.length <= 1 ? 0.5 : 1,
                                        cursor:
                                          branches.length <= 1
                                            ? "not-allowed"
                                            : "pointer",
                                      }}
                                    >
                                      Custom
                                    </div>
                                  </div>
                                </div> */}

                                <div className="pd-dropdown-reminder">
                                  Tap an item to open branch allocation. HQ
                                  receives the remainder automatically.
                                </div>

                                <div
                                  className="pd-dropdown"
                                  key={distributionPrefix}
                                >
                                  {/* Trigger */}
                                  <button
                                    className="pd-dropdown-trigger"
                                    onClick={toggleOpen}
                                    type="button"
                                  >
                                    <div className="pd-dropdown-triggeritem-left">
                                      <div className="pd-dropdown-icon">
                                        <FallbackImg
                                          src={
                                            productData?.item_photo?.[0]
                                              ?.thumb_url
                                          }
                                          alt={product.item_name}
                                          width="36"
                                          height="36"
                                          onClick={() =>
                                            handlePromotionImageClick(
                                              productData?.item_photo?.[0]
                                                ?.photo_url,
                                            )
                                          }
                                        />
                                      </div>
                                      <div className="pd-dropdown-triggeritem">
                                        <div
                                          style={{
                                            color: "#6b7280",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {product.item_code}
                                        </div>
                                        {isDistributionVisited ? (
                                          (() => {
                                            const hqQty = calculateHQQuantity();
                                            const hqFocQty =
                                              calculateHQFocQuantity();

                                            const allocatedCount = branches
                                              .slice(1)
                                              .filter(
                                                (b) =>
                                                  (branchQuantities[
                                                    b.branch_id
                                                  ] || 0) > 0 ||
                                                  (branchFocQuantities[
                                                    b.branch_id
                                                  ] || 0) > 0,
                                              ).length;

                                            const hqAllocated =
                                              hqQty > 0 || hqFocQty > 0;

                                            if (allocatedCount === 0) {
                                              return (
                                                <div className="pd-dropdown-allocation success">
                                                  <Building2
                                                    size={12}
                                                    className="pd-dropdown-building-icon"
                                                  />
                                                  All to HQ
                                                </div>
                                              );
                                            }
                                            const label = hqAllocated
                                              ? `HQ and ${allocatedCount} ${allocatedCount === 1 ? "branch" : "branches"}`
                                              : `${allocatedCount} ${allocatedCount === 1 ? "branch" : "branches"}`;
                                            return (
                                              <div className="pd-dropdown-allocation">
                                                <CircleSmall
                                                  size={12}
                                                  className="pd-dropdown-circlesmall-icon"
                                                />
                                                {label}
                                              </div>
                                            );
                                          })()
                                        ) : (
                                          <div className="pd-dropdown-allocation">
                                            <CircleSmall
                                              size={12}
                                              fill={"#d4d4d4"}
                                              color={"#d4d4d4"}
                                            />
                                            Tap to configure
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="pd-dropdown-triggeritem-right">
                                      <div style={{ color: "#6b7280" }}>
                                        {displayDiscountInfo &&
                                        displayDiscountInfo.orderQty > 0 ? (
                                          <>
                                            {displayDiscountInfo.orderQty}{" "}
                                            {displayDiscountInfo.orderQty > 1
                                              ? "units"
                                              : "unit"}
                                          </>
                                        ) : (
                                          <>
                                            {distributionItem.qty}{" "}
                                            {distributionItem.qty > 1
                                              ? "units"
                                              : "unit"}
                                          </>
                                        )}

                                        {focTotal > 0 && (
                                          <span style={{ color: "#8200db" }}>
                                            {" "}
                                            + {focTotal}{" "}
                                            {focTotal > 1 ? "units" : "unit"}
                                          </span>
                                        )}
                                        {displayDiscountInfo &&
                                          displayDiscountInfo.groupQty > 1 && (
                                            <span style={{ color: "#bb4d00" }}>
                                              {" "}
                                              + Discount{" "}
                                              {Math.floor(
                                                quantity /
                                                  (displayDiscountInfo.groupQty ||
                                                    1),
                                              )}
                                            </span>
                                          )}
                                      </div>

                                      <ChevronDown
                                        size={16}
                                        style={{
                                          transform: isDistributionOpen
                                            ? "rotate(180deg)"
                                            : "rotate(0deg)",
                                          transition: "transform 0.25s ease",
                                        }}
                                      />
                                    </div>
                                  </button>

                                  {/* Collapsible body */}
                                  <div
                                    style={{
                                      display: isDistributionOpen
                                        ? "block"
                                        : "none",
                                    }}
                                  >
                                    <div className="atc-branch-searchbar-container">
                                      <div className="atc-branch-searchbar">
                                        <Search size={14} color={"#a1a1a1"} />
                                        <input
                                          placeholder="Search by branch name or code..."
                                          value={searchInput}
                                          onChange={(e) =>
                                            setSearchInput(e.target.value)
                                          }
                                        />
                                        <X
                                          className="atc-branch-searchbar-remove"
                                          size={12}
                                          style={{
                                            visibility: searchInput
                                              ? "visible"
                                              : "hidden",
                                            pointerEvents: searchInput
                                              ? "auto"
                                              : "none",
                                          }}
                                          onClick={() => setSearchInput("")}
                                        />
                                      </div>
                                    </div>

                                    <div className="atc-branches">
                                      {(() => {
                                        const filtered = branches.filter(
                                          (branch) =>
                                            !searchInput ||
                                            branch.branch_name
                                              ?.toLowerCase()
                                              .includes(
                                                searchInput.toLowerCase(),
                                              ) ||
                                            branch.branch_code
                                              ?.toLowerCase()
                                              .includes(
                                                searchInput.toLowerCase(),
                                              ),
                                        );
                                        if (filtered.length === 0) {
                                          return (
                                            <div className="atc-branches-empty">
                                              No branches match "{searchInput}"
                                            </div>
                                          );
                                        }
                                        return filtered.map((branch) => {
                                          const isHQ =
                                            branch.branch_id ===
                                            branches[0]?.branch_id;
                                          const displayQuantity = isHQ
                                            ? calculateHQQuantity()
                                            : branchQuantities[
                                                branch.branch_id
                                              ] || 0;
                                          const focQty =
                                            branchFocQuantities[
                                              branch.branch_id
                                            ] || 0;
                                          const discountQty =
                                            branchDiscountQuantities[
                                              branch.branch_id
                                            ] || 0;
                                          return (
                                            <div key={branch.branch_id}>
                                              <div
                                                className={`atc-branchname-container-v2 ${isHQ && "hq"}`}
                                              >
                                                <div className="atc-branchname-v2">
                                                  <div className="atc-branch-firstcapital">
                                                    {branch.branch_code
                                                      ?.charAt(0)
                                                      .toUpperCase()}
                                                  </div>

                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      {branch.branch_code}
                                                    </div>
                                                    {isHQ && (
                                                      <div className="pd-firstbranch-tag">
                                                        auto remainder
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>

                                                {/* Quantity 区域 */}
                                                <div className="atc-productqty-container-v2">
                                                  <div className="atc-productqty-v2">
                                                    <button
                                                      className="atc-productqty-minus-btn-v2"
                                                      onClick={() =>
                                                        handleBranchDecrease(
                                                          branch.branch_id,
                                                        )
                                                      }
                                                      type="button"
                                                      disabled={
                                                        isHQ ||
                                                        displayQuantity === 0
                                                      }
                                                    >
                                                      <Minus size={12} />
                                                    </button>
                                                    <input
                                                      type="text"
                                                      className="atc-productqty-value-v2"
                                                      value={displayQuantity}
                                                      onChange={(e) =>
                                                        handleBranchQuantityInputChange(
                                                          branch.branch_id,
                                                          e.target.value,
                                                        )
                                                      }
                                                      readOnly={isHQ}
                                                    />
                                                    <button
                                                      className="atc-productqty-plus-btn-v2"
                                                      onClick={() =>
                                                        handleBranchIncrease(
                                                          branch.branch_id,
                                                        )
                                                      }
                                                      type="button"
                                                      disabled={
                                                        isHQ ||
                                                        calculateHQQuantity() ===
                                                          0
                                                      }
                                                    >
                                                      <Plus size={12} />
                                                    </button>
                                                  </div>
                                                  {invalidBranchQty[
                                                    branch.branch_id
                                                  ] && (
                                                    <div className="quantity-error">
                                                      Please enter a quantity
                                                      that is a multiple of{" "}
                                                      {packing_quantity}
                                                    </div>
                                                  )}
                                                </div>

                                                {/* F.O.C 区域，结构和样式完全一样 */}
                                                {/* FOC 分配栏 */}
                                                {focTotal > 0 && (
                                                  <div className="atc-productqty-container-v2 foc">
                                                    <div className="atc-productqty-v2">
                                                      <button
                                                        className="atc-productqty-minus-btn-v2"
                                                        onClick={() =>
                                                          handleFocDecrease(
                                                            branch.branch_id,
                                                          )
                                                        }
                                                        type="button"
                                                        disabled={
                                                          isHQ || focQty === 0
                                                        }
                                                      >
                                                        <Minus size={12} />
                                                      </button>
                                                      <input
                                                        type="text"
                                                        className="atc-productqty-value-v2"
                                                        value={
                                                          isHQ
                                                            ? calculateHQFocQuantity()
                                                            : focQty
                                                        }
                                                        readOnly
                                                      />
                                                      <button
                                                        className="atc-productqty-plus-btn-v2"
                                                        onClick={() =>
                                                          handleFocIncrease(
                                                            branch.branch_id,
                                                          )
                                                        }
                                                        type="button"
                                                        disabled={
                                                          isHQ ||
                                                          calculateHQFocQuantity() ===
                                                            0
                                                        }
                                                      >
                                                        <Plus size={12} />
                                                      </button>
                                                    </div>
                                                  </div>
                                                )}

                                                {/* Display Discount 分配栏 */}
                                                {displayDiscountInfo &&
                                                  displayDiscountInfo.groupQty >
                                                    1 && (
                                                    <div className="atc-productqty-container-v2">
                                                      <div className="atc-productqty-v2">
                                                        <button
                                                          className="atc-productqty-minus-btn-v2"
                                                          onClick={() =>
                                                            handleDiscountDecrease(
                                                              branch.branch_id,
                                                            )
                                                          }
                                                          type="button"
                                                          disabled={
                                                            isHQ ||
                                                            discountQty === 0
                                                          }
                                                        >
                                                          <Minus size={12} />
                                                        </button>
                                                        <input
                                                          type="text"
                                                          className="atc-productqty-value-v2"
                                                          value={
                                                            isHQ
                                                              ? calculateHQDiscountQuantity()
                                                              : discountQty
                                                          }
                                                          readOnly
                                                        />
                                                        <button
                                                          className="atc-productqty-plus-btn-v2"
                                                          onClick={() =>
                                                            handleDiscountIncrease(
                                                              branch.branch_id,
                                                            )
                                                          }
                                                          type="button"
                                                          disabled={
                                                            isHQ ||
                                                            calculateHQDiscountQuantity() ===
                                                              0
                                                          }
                                                        >
                                                          <Plus size={12} />
                                                        </button>
                                                      </div>
                                                    </div>
                                                  )}
                                              </div>
                                            </div>
                                          );
                                        });
                                      })()}
                                    </div>
                                  </div>
                                </div>

                                {pwpItems.map((pwpItem) => {
                                  const tagId = pwpItem.promotionId;
                                  const promo = (
                                    promotionForDisplay || []
                                  ).find((p) => (p.tag_id ?? p.id) === tagId);
                                  const tagQuantities =
                                    branchPwpQuantities[tagId] || {};
                                  const isOpen = !!isPwpDistributionOpen[tagId];
                                  const isVisited =
                                    !!isPwpDistributionVisited[tagId];
                                  const searchInputForTag =
                                    pwpSearchInput[tagId] || "";
                                  return (
                                    <div
                                      className="pd-dropdown"
                                      key={`pwp-dist-${tagId}`}
                                    >
                                      <button
                                        className="pd-dropdown-trigger"
                                        onClick={() => {
                                          setIsPwpDistributionOpen((prev) => ({
                                            ...prev,
                                            [tagId]: !prev[tagId],
                                          }));
                                          setIsPwpDistributionVisited(
                                            (prev) => ({
                                              ...prev,
                                              [tagId]: true,
                                            }),
                                          );
                                        }}
                                        type="button"
                                      >
                                        <div className="pd-dropdown-triggeritem-left">
                                          <div className="pd-dropdown-icon">
                                            <FallbackImg
                                              src={promo?.thumb_url}
                                              alt={pwpItem.item_name}
                                              width="36"
                                              height="36"
                                              onClick={() =>
                                                handlePromotionImageClick(
                                                  promo?.img_url,
                                                )
                                              }
                                            />
                                          </div>
                                          <div className="pd-dropdown-triggeritem">
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: "8px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  color: "#6b7280",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                {pwpItem.item_code}
                                              </div>
                                              <div className="pd-dropdown-pwp-tag">
                                                PWP
                                              </div>
                                            </div>
                                            {isVisited ? (
                                              (() => {
                                                const hqQty =
                                                  calculateHQPwpQuantity(tagId);
                                                const allocatedCount = branches
                                                  .slice(1)
                                                  .filter(
                                                    (b) =>
                                                      (tagQuantities[
                                                        b.branch_id
                                                      ] || 0) > 0,
                                                  ).length;
                                                if (allocatedCount === 0) {
                                                  return (
                                                    <div className="pd-dropdown-allocation success">
                                                      <Building2
                                                        size={12}
                                                        className="pd-dropdown-building-icon"
                                                      />
                                                      All to HQ
                                                    </div>
                                                  );
                                                }
                                                const label =
                                                  hqQty > 0
                                                    ? `HQ and ${allocatedCount} ${allocatedCount === 1 ? "branch" : "branches"}`
                                                    : `${allocatedCount} ${allocatedCount === 1 ? "branch" : "branches"}`;
                                                return (
                                                  <div className="pd-dropdown-allocation">
                                                    <CircleSmall
                                                      size={12}
                                                      className="pd-dropdown-circlesmall-icon"
                                                    />
                                                    {label}
                                                  </div>
                                                );
                                              })()
                                            ) : (
                                              <div className="pd-dropdown-allocation">
                                                <CircleSmall
                                                  size={12}
                                                  fill={"#d4d4d4"}
                                                  color={"#d4d4d4"}
                                                />
                                                Tap to configure
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                        <div className="pd-dropdown-triggeritem-right">
                                          <div style={{ color: "#6b7280" }}>
                                            {pwpItem.quantity}{" "}
                                            {pwpItem.quantity > 1
                                              ? "units"
                                              : "unit"}
                                          </div>
                                          <ChevronDown
                                            size={16}
                                            style={{
                                              transform: isOpen
                                                ? "rotate(180deg)"
                                                : "rotate(0deg)",
                                              transition:
                                                "transform 0.25s ease",
                                            }}
                                          />
                                        </div>
                                      </button>

                                      <div
                                        style={{
                                          display: isOpen ? "block" : "none",
                                        }}
                                      >
                                        <div className="atc-branch-searchbar-container">
                                          <div className="atc-branch-searchbar">
                                            <Search
                                              size={14}
                                              color={"#a1a1a1"}
                                            />
                                            <input
                                              placeholder="Search by branch name or code..."
                                              value={searchInputForTag}
                                              onChange={(e) =>
                                                setPwpSearchInput((prev) => ({
                                                  ...prev,
                                                  [tagId]: e.target.value,
                                                }))
                                              }
                                            />
                                            <X
                                              className="atc-branch-searchbar-remove"
                                              size={12}
                                              style={{
                                                visibility: searchInputForTag
                                                  ? "visible"
                                                  : "hidden",
                                                pointerEvents: searchInputForTag
                                                  ? "auto"
                                                  : "none",
                                              }}
                                              onClick={() =>
                                                setPwpSearchInput((prev) => ({
                                                  ...prev,
                                                  [tagId]: "",
                                                }))
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="atc-branches">
                                          {(() => {
                                            const filtered = branches.filter(
                                              (branch) =>
                                                !searchInputForTag ||
                                                branch.branch_name
                                                  ?.toLowerCase()
                                                  .includes(
                                                    searchInputForTag.toLowerCase(),
                                                  ) ||
                                                branch.branch_code
                                                  ?.toLowerCase()
                                                  .includes(
                                                    searchInputForTag.toLowerCase(),
                                                  ),
                                            );
                                            if (filtered.length === 0) {
                                              return (
                                                <div className="atc-branches-empty">
                                                  No branches match "
                                                  {searchInputForTag}"
                                                </div>
                                              );
                                            }
                                            return filtered.map((branch) => {
                                              const isHQ =
                                                branch.branch_id ===
                                                branches[0]?.branch_id;
                                              const pwpQty =
                                                tagQuantities[
                                                  branch.branch_id
                                                ] || 0;
                                              return (
                                                <div key={branch.branch_id}>
                                                  <div
                                                    className={`atc-branchname-container-v2 ${isHQ && "hq"}`}
                                                  >
                                                    <div className="atc-branchname-v2">
                                                      <div className="atc-branch-firstcapital">
                                                        {branch.branch_code
                                                          ?.charAt(0)
                                                          .toUpperCase()}
                                                      </div>
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          gap: "8px",
                                                        }}
                                                      >
                                                        <div>
                                                          {branch.branch_code}
                                                        </div>
                                                        {isHQ && (
                                                          <div className="pd-firstbranch-tag">
                                                            auto remainder
                                                          </div>
                                                        )}
                                                      </div>
                                                    </div>
                                                    <div className="atc-productqty-container-v2">
                                                      <div className="atc-productqty-v2">
                                                        <button
                                                          className="atc-productqty-minus-btn-v2"
                                                          onClick={() =>
                                                            handlePwpDecrease(
                                                              tagId,
                                                              branch.branch_id,
                                                            )
                                                          }
                                                          type="button"
                                                          disabled={
                                                            isHQ || pwpQty === 0
                                                          }
                                                        >
                                                          <Minus size={12} />
                                                        </button>
                                                        <input
                                                          type="text"
                                                          className="atc-productqty-value-v2"
                                                          value={
                                                            isHQ
                                                              ? calculateHQPwpQuantity(
                                                                  tagId,
                                                                )
                                                              : pwpQty
                                                          }
                                                          readOnly
                                                        />
                                                        <button
                                                          className="atc-productqty-plus-btn-v2"
                                                          onClick={() =>
                                                            handlePwpIncrease(
                                                              tagId,
                                                              branch.branch_id,
                                                            )
                                                          }
                                                          type="button"
                                                          disabled={
                                                            isHQ ||
                                                            calculateHQPwpQuantity(
                                                              tagId,
                                                            ) === 0
                                                          }
                                                        >
                                                          <Plus size={12} />
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              );
                                            });
                                          })()}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}

                                {!allDistTriggersVisited && (
                                  <div className="pd-dropdown-reminder-2">
                                    <TriangleAlert size={14} />
                                    Tap each item above to review its allocation
                                    before confirming.
                                  </div>
                                )}

                                {!allowAddToCart ? (
                                  <div
                                    className={`pd-button${
                                      !allDistTriggersVisited ||
                                      invalidPackingQty ||
                                      invalidDiscountQty ||
                                      !isQuantityValid() ||
                                      freeGiftOutOfStock ||
                                      // isFocQtyExceeded ||
                                      quantityInputStr === "" ||
                                      Object.values(invalidBranchQty).some(
                                        Boolean,
                                      )
                                        ? " disabled"
                                        : ""
                                    }`}
                                    onClick={() => {
                                      if (
                                        !invalidPackingQty &&
                                        !invalidDiscountQty &&
                                        isQuantityValid() &&
                                        !freeGiftOutOfStock &&
                                        // !isFocQtyExceeded &&
                                        quantityInputStr !== "" &&
                                        !Object.values(invalidBranchQty).some(
                                          Boolean,
                                        ) &&
                                        (distributionMode !== "custom" ||
                                          allDistTriggersVisited)
                                      ) {
                                        setAllowAddToCart(true);
                                      }
                                    }}
                                  >
                                    Confirm Allocation
                                  </div>
                                ) : (
                                  <div className="pd-allocation-confirm">
                                    <Check size={16} /> Allocation confirmed —
                                    ready add to cart
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      )}

                    {/* Product Info */}
                    <div className="productdetail-card">
                      <div className="productdetail-cardtab-container">
                        {[
                          { key: "specification", label: "Specification" },
                          { key: "features", label: "Features" },
                          { key: "whats-in-box", label: "What's In the Box" },
                          { key: "packing-detail", label: "Packing Detail" },
                          {
                            key: "item-replacement",
                            label: "Replacement Parts",
                          },
                        ].map((tab) => (
                          <button
                            key={tab.key}
                            type="button"
                            className={`productdetail-cardtab${activeDetailTab === tab.key ? " active" : ""}`}
                            onClick={() => setActiveDetailTab(tab.key)}
                          >
                            {tab.label}
                          </button>
                        ))}
                      </div>

                      <div className="productdetail-carddetail">
                        {activeDetailTab === "specification" && (
                          <div className="productdetail-table">
                            {specifications.map((spec, index) => (
                              <div
                                className="productdetail-tableitem"
                                key={index}
                              >
                                <div className="pd-tableitem-left">
                                  {spec.spec_type}
                                </div>
                                <div className="pd-tableitem-right">
                                  {spec.spec_attr}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}

                        {activeDetailTab === "features" && (
                          <div className="productdetail-table">
                            {features.map((feature, index) => (
                              <div
                                className="productdetail-tableitem"
                                key={index}
                              >
                                <div className="pd-tableitem-left">
                                  {feature.feat_type}
                                </div>
                                <div className="pd-tableitem-right">
                                  {feature.feat_attr}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}

                        {activeDetailTab === "whats-in-box" && (
                          <ul className="productdetail-ul">
                            {whatsInBox.map((item, index) => (
                              <li className="productdetail-ulitem" key={index}>
                                {item.name} x {item.quantity}
                              </li>
                            ))}
                          </ul>
                        )}

                        {activeDetailTab === "packing-detail" && (
                          <div style={{ width: "100%" }}>
                            <div className="packing-img-v2">
                              <FallbackImg
                                src={CBM}
                                alt="cbm"
                                width="300"
                                height="200"
                              />
                            </div>

                            {packingDetails.items.length > 0 ? (
                              <div className="packing-table-container-v2">
                                <div className="packing-table">
                                  {/* Header Row */}
                                  <div className="packing-firstrow-v2">
                                    <div></div>
                                    {packingDetails.items.map((item, index) => (
                                      <div key={`${item.uom_name}-${index}`}>
                                        {item.uom_name}
                                        {/* 如果有多个相同的UOM，显示序号 */}
                                        {packingDetails.items.filter(
                                          (p) => p.uom_name === item.uom_name,
                                        ).length > 1 &&
                                          ` ${
                                            packingDetails.items.filter(
                                              (p, i) =>
                                                p.uom_name === item.uom_name &&
                                                i <= index,
                                            ).length
                                          }`}
                                      </div>
                                    ))}
                                  </div>

                                  {/* Length Row */}
                                  <div className="packing-row-v2">
                                    <span>Length</span>
                                    {packingDetails.items.map((item, index) => (
                                      <div key={`length-${index}`}>
                                        {item.packing_dimension_l
                                          ? `${item.packing_dimension_l} cm`
                                          : "-"}
                                      </div>
                                    ))}
                                  </div>

                                  {/* Width Row */}
                                  <div className="packing-row-v2">
                                    <span>Width</span>
                                    {packingDetails.items.map((item, index) => (
                                      <div key={`width-${index}`}>
                                        {item.packing_dimension_w
                                          ? `${item.packing_dimension_w} cm`
                                          : "-"}
                                      </div>
                                    ))}
                                  </div>

                                  {/* Height Row */}
                                  <div className="packing-row-v2">
                                    <span>Height</span>
                                    {packingDetails.items.map((item, index) => (
                                      <div key={`height-${index}`}>
                                        {item.packing_dimension_h
                                          ? `${item.packing_dimension_h} cm`
                                          : "-"}
                                      </div>
                                    ))}
                                  </div>

                                  {/* CBM Row */}
                                  <div className="packing-row-v2">
                                    <span>CBM</span>
                                    {packingDetails.items.map((item, index) => {
                                      if (
                                        item.packing_dimension_l &&
                                        item.packing_dimension_w &&
                                        item.packing_dimension_h
                                      ) {
                                        const cbm = (
                                          (parseFloat(
                                            item.packing_dimension_l,
                                          ) *
                                            parseFloat(
                                              item.packing_dimension_w,
                                            ) *
                                            parseFloat(
                                              item.packing_dimension_h,
                                            )) /
                                          1000000
                                        ).toFixed(4);
                                        return (
                                          <div key={`cbm-${index}`}>
                                            {cbm} m³
                                          </div>
                                        );
                                      }
                                      return <div key={`cbm-${index}`}>-</div>;
                                    })}
                                  </div>

                                  {/* Weight Row */}
                                  <div className="packing-row-v2">
                                    <span>Weight</span>
                                    {packingDetails.items.map((item, index) => (
                                      <div key={`weight-${index}`}>
                                        {item.packing_weight
                                          ? `${item.packing_weight} kg`
                                          : "-"}
                                      </div>
                                    ))}
                                  </div>

                                  {/* Quantity Row */}
                                  <div className="packing-row-v2">
                                    <span>Quantity</span>
                                    {packingDetails.items.map((item, index) => (
                                      <div key={`quantity-${index}`}>
                                        {item.packing_quantity
                                          ? `${item.packing_quantity} pcs`
                                          : "-"}
                                      </div>
                                    ))}
                                  </div>

                                  {/* Barcode */}
                                  <div className="packing-row-v2">
                                    <span>Barcode</span>
                                    {packingDetails.items.map((item, index) => (
                                      <div key={`barcode-${index}`}>
                                        {item.packing_barcode
                                          ? `${item.packing_barcode}`
                                          : "-"}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div
                                style={{
                                  textAlign: "center",
                                  color: "#999",
                                  padding: "20px",
                                }}
                              >
                                No packing details available
                              </div>
                            )}
                          </div>
                        )}

                        {activeDetailTab === "item-replacement" && (
                          <>
                            {itemReplacement.length > 0 ? (
                              <div className="productdetail-table">
                                {itemReplacement.map((item, index) => (
                                  <div
                                    className="productdetail-tablewithphoto"
                                    key={index}
                                    onClick={() =>
                                      navigate(`/productdetail/${item.id}`, {
                                        state: { navKey: Date.now() },
                                      })
                                    }
                                  >
                                    {item.stock_quantity <= 0 && (
                                      <div className="pd-tableitem-overlay">
                                        Out of stock
                                      </div>
                                    )}
                                    <div className="pd-tableitem-photo">
                                      <FallbackImg
                                        src={item.photo_url}
                                        width="100%"
                                        height="100%"
                                      />
                                    </div>
                                    <div className="pd-tableitem-info">
                                      <div className="pd-tableitem-itemcode">
                                        {item.item_code}
                                      </div>
                                      <div className="pd-tableitem-itemname">
                                        {item.item_name}
                                      </div>
                                    </div>
                                    <div className="pd-tableitem-chevron">
                                      <ChevronRight size={16} />
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="productdetail-table">
                                <div className="productdetail-tablewithphoto-empty">
                                  <div className="pd-tableitem-circleicon">
                                    <ChevronDown size={24} />
                                  </div>
                                  No Replacement Parts Available
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>

                    {/* You May Also Like */}
                    {youMayAlsoLikeItems && youMayAlsoLikeItems.length > 0 && (
                      <div className="productdetail-card">
                        <div
                          className="productdetail-cardtitle"
                          style={{ justifyContent: "space-between" }}
                        >
                          <div>You May Also Like</div>
                          {youMayAlsoLikePage < youMayAlsoLikeTotalPages && (
                            <button
                              onClick={handleLoadMoreYouMayAlsoLike}
                              disabled={youMayAlsoLikeLoading}
                              className="view-all-btn"
                            >
                              {youMayAlsoLikeLoading ? (
                                "Loading..."
                              ) : (
                                <div style={{ display: "flex" }}>
                                  View All <ChevronRight size={16} />
                                </div>
                              )}
                            </button>
                          )}
                        </div>
                        <div className="productdetail-carddetail">
                          <div className="pd-alsolike">
                            {/* Filter out current item itself */}
                            {youMayAlsoLikeItems
                              .filter((item) => {
                                const isCurrentRegularItem =
                                  String(item.id || item.item_id) ===
                                  String(item_id);
                                const isCurrentBundle =
                                  bundleId &&
                                  String(item.package_id) === String(bundleId);
                                return (
                                  !isCurrentRegularItem && !isCurrentBundle
                                );
                              })
                              .map((item) => {
                                const category = formatProductCategory(item);
                                const pricing = getProductPricing(
                                  item,
                                  isLoggedIn,
                                );
                                const outOfStock = isOutOfStock_YouMayAlsoLike(
                                  item,
                                  pricing,
                                  isLoggedIn,
                                );
                                const isDiscontinued = item.status == 2;

                                const OVERLAY_LABELS = [
                                  {
                                    tag: "discontinued",
                                    text: "DISCONTINUED",
                                  },
                                  { tag: "coming_soon", text: "COMING SOON" },
                                  {
                                    tag: "not_for_sell",
                                    text: "NOT FOR SELL",
                                  },
                                  {
                                    tag: "out_of_stock",
                                    text: "OUT OF STOCK",
                                  },
                                ];

                                const matchedLabel = item.labels?.find(
                                  (label) =>
                                    OVERLAY_LABELS.some(
                                      (o) => o.tag === label.tag,
                                    ),
                                );

                                const overlayText = matchedLabel
                                  ? OVERLAY_LABELS.find(
                                      (o) => o.tag === matchedLabel.tag,
                                    )?.text
                                  : null;

                                return (
                                  <div
                                    key={item.item_id || item.id}
                                    className="pd-alsolikecard"
                                  >
                                    <Link
                                      to={`/productdetail/${item.item_id || item.id}${item.package_id ? `?isBundle=1&bundleId=${item.package_id}` : ""}`}
                                      state={{ navKey: Date.now() }}
                                      style={{
                                        textDecoration: "none",
                                        color: "inherit",
                                      }}
                                    >
                                      {pricing.discountPercent > 0 &&
                                        !outOfStock && (
                                          <div className="pd-discount-percent">
                                            -{pricing.discountPercent}%
                                          </div>
                                        )}
                                      <div className="pd-alsolikecard-inner">
                                        <div className="pd-alsolikecard-image">
                                          <FallbackImg
                                            src={item.thumb_url}
                                            alt={item.item_code}
                                            className="main-product-image"
                                          />
                                          {item.item_video && (
                                            <div className="video-icon_v2">
                                              <CirclePlay
                                                className="circleplay-icon_v2"
                                                size={16}
                                              />
                                            </div>
                                          )}
                                          {matchedLabel && (
                                            <div className="pd-overlay_v2">
                                              <div className="pd-overlay-text_v2">
                                                {overlayText}
                                              </div>
                                              <div className="pd-eta-pill_v2">
                                                <CalendarDays size={13} />
                                                <span>
                                                  {item.eta_date
                                                    ? formatDate(item.eta_date)
                                                    : "--"}
                                                </span>
                                              </div>
                                            </div>
                                          )}
                                        </div>

                                        <div className="pd-alsolikecard-info">
                                          <div className="pd-alsolikecard-info-code">
                                            {item.item_code ||
                                              item.package_name}
                                          </div>
                                          <div
                                            className="pd-alsolikecard-info-name"
                                            title={
                                              item.nick_name ||
                                              item.item_name ||
                                              item.package_description
                                            }
                                          >
                                            {item.nick_name ||
                                              item.item_name ||
                                              item.package_description}
                                          </div>

                                          {/* {isOutOfStock_YouMayAlsoLike(
                                          item,
                                          pricing,
                                          isLoggedIn,
                                        ) && !isDiscontinued ? (
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <button
                                              className="pd-button"
                                              onClick={(e) => {
                                                if (!canOrder) return;
                                                e.stopPropagation();
                                                e.preventDefault();
                                                if (
                                                  !localStorage.getItem(
                                                    "access_token",
                                                  )
                                                ) {
                                                  setShowLoginPrompt(true);
                                                  return;
                                                }
                                                handleWishlistToggle(
                                                  item.id,
                                                  item.product_type,
                                                );
                                              }}
                                              disabled={!canOrder}
                                              style={{
                                                opacity: canOrder ? 1 : 0.5,
                                                cursor: canOrder
                                                  ? "pointer"
                                                  : "not-allowed",
                                                padding: "8px 16px",
                                              }}
                                              title={
                                                canOrder ? "" : "No permission"
                                              }
                                            >
                                              {wishlistStatus[String(item.id)]
                                                ? "Remove From Wishlist"
                                                : "Add To Wishlist"}
                                            </button>
                                          </div>
                                        ) : isDiscontinued ? ( */}

                                          {isDiscontinued || outOfStock ? (
                                            <span
                                              style={{ visibility: "hidden" }}
                                            >
                                              -
                                            </span>
                                          ) : !isDiscontinued && !outOfStock ? (
                                            <div className="price_v2">
                                              <span className="price-sub_v2">
                                                FROM
                                              </span>{" "}
                                              RM{" "}
                                              {pricing.displayPrice
                                                ? formatCurrency(
                                                    pricing.displayPrice,
                                                  )
                                                : "0.00"}
                                            </div>
                                          ) : null}
                                        </div>

                                        {/* {!isDiscontinued && !outOfStock && (
                                          <div
                                            className="promo-tag-container"
                                            style={{ marginTop: "8px" }}
                                          >
                                            {(() => {
                                              const tags = getPromotionTags(
                                                item.promotions,
                                              );
                                              const maxShow = 1;
                                              const hiddenTags =
                                                tags.slice(maxShow);

                                              return (
                                                <>
                                                  {tags
                                                    .slice(0, maxShow)
                                                    .map((tag, idx) => (
                                                      <div
                                                        className="promo-tag"
                                                        key={idx}
                                                      >
                                                        {tag.icon}
                                                        <span
                                                          className="promo-tag-text"
                                                          title={tag.label}
                                                        >
                                                          {tag.label}
                                                        </span>
                                                      </div>
                                                    ))}
                                                  {tags.length > maxShow && (
                                                    <div className="promo-add-tag">
                                                      +{tags.length - maxShow}
                                                      <div className="promo-tooltip">
                                                        {hiddenTags.map(
                                                          (tag, idx) => (
                                                            <div
                                                              className="promo-tag"
                                                              key={idx}
                                                            >
                                                              {tag.icon}
                                                              {tag.label}
                                                            </div>
                                                          ),
                                                        )}
                                                      </div>
                                                    </div>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </div>
                                        )} */}
                                      </div>
                                    </Link>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="productdetail-right-v2">
                    {/* Summary */}
                    {productData.filter_label?.includes("coming_soon") ? (
                      <div
                        className="productdetail-card"
                        style={{ backgroundColor: "#ffffff", padding: "24px" }}
                      >
                        <div className="productsummary-title">
                          Product Summary
                        </div>
                        <div className="productsummary-status">
                          <div className="productsummary-status-subtitle">
                            <Package size={20} color={"#f54a00"} />
                            Status
                          </div>
                          <div className="productsummary-status-title">
                            Coming Soon
                          </div>
                        </div>
                        <div className="productsummary-list">
                          <div className="productsummary-listitem">
                            <span>Model</span>
                            <div>{product.item_code}</div>
                          </div>
                          <div className="productsummary-listitem">
                            <span>Product</span>
                            <div>{product.product_name}</div>
                          </div>
                          <div className="productsummary-listitem">
                            <span>Expected Arrival</span>
                            <div>
                              {product.eta_date?.startsWith("0000")
                                ? "--"
                                : formatDate(product.eta_date)}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="productdetail-card">
                        <div className="productdetail-cardtitle">
                          Order Summary
                        </div>

                        <div
                          className="productdetail-carddetail"
                          style={{ flexDirection: "column" }}
                        >
                          {!canBuy ? (
                            <div className="pd-step2-lock">
                              <div>
                                <Lock size={48} />
                              </div>
                              <div>The item is currently unavailable</div>
                            </div>
                          ) : (
                            <>
                              <div className="pd-progress">
                                <div className="pd-progressitem">
                                  {allowAddToCart ? (
                                    <div className="pd-num-success">
                                      <Check size={16} />
                                    </div>
                                  ) : (
                                    <div className="pd-num">1</div>
                                  )}
                                  <div>
                                    <div>Quantity Selected</div>
                                    <div
                                      style={{
                                        color: "#6b7280",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {quantity} unit
                                    </div>
                                  </div>
                                </div>

                                <div className="pd-progressitem">
                                  {!canBuy ? (
                                    <div className="pd-num-lock">
                                      <Lock size={12} />
                                    </div>
                                  ) : allowAddToCart ? (
                                    <div className="pd-num-success">
                                      <Check size={16} />
                                    </div>
                                  ) : (
                                    <div className="pd-num">2</div>
                                  )}
                                  <div>
                                    <div>Branch Allocation</div>
                                    <div
                                      style={{
                                        color: "#6b7280",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {!canBuy ? (
                                        <>Not Configured</>
                                      ) : (
                                        <>{allocatedBranchSummary}</>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="productdetail-separator"></div>

                              <div className="pd-summary">
                                <div className="pd-summary-title">
                                  Selected Item
                                </div>

                                <div className="pd-summaryitem-box">
                                  <div className="pd-summaryitem-left">
                                    <FallbackImg
                                      src={
                                        productData?.item_photo?.[0]?.thumb_url
                                      }
                                      alt={product.item_name}
                                      width="56"
                                      height="56"
                                      onClick={() =>
                                        handlePromotionImageClick(
                                          productData?.item_photo?.[0]
                                            ?.photo_url,
                                        )
                                      }
                                      style={{ cursor: "pointer" }}
                                    />
                                  </div>

                                  <div style={{ flex: "1" }}>
                                    <div className="pd-summaryitem-righttop">
                                      <div className="pd-summaryitem-itemcode">
                                        {product.item_code}
                                      </div>
                                      <div className="pd-summaryitem-itemname">
                                        {product.item_name}
                                      </div>
                                    </div>

                                    <div className="pd-summaryitem-rightbot">
                                      <div className="pd-summaryitem-info-1">
                                        <span>Unit price</span>
                                        <span>
                                          x {quantity}{" "}
                                          {quantity.length > 0
                                            ? "units"
                                            : "unit"}
                                        </span>
                                      </div>

                                      <div className="pd-summaryitem-info-2">
                                        <span style={{ color: "#6b7280" }}>
                                          RM{" "}
                                          {formatCurrency(
                                            displayPrice.original ??
                                              displayPrice.price,
                                          )}
                                        </span>

                                        <span style={{ display: "flex" }}>
                                          RM
                                          <div className="pd-summaryitem-price">
                                            {formatCurrency(
                                              selectedItemSubtotal,
                                            )}
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {getSelectedPromotionsForDisplay().length > 0 && (
                                <>
                                  <div className="productdetail-separator"></div>

                                  <div className="pd-summary">
                                    <div className="pd-summary-title">
                                      Applied Promotions
                                    </div>

                                    {renderSelectedPromotion()}
                                  </div>
                                </>
                              )}

                              <div className="productdetail-separator"></div>

                              <div className="pd-summaryitem-container">
                                <span style={{ color: "#6b7280" }}>
                                  Subtotal
                                </span>
                                <span style={{ display: "flex" }}>
                                  RM
                                  <div className="pd-price">
                                    {formatCurrency(calculateSubtotal())}
                                  </div>
                                </span>
                              </div>
                              {calculateDiscount() > 0 && (
                                <div className="pd-summaryitem-container">
                                  <span style={{ color: "#6b7280" }}>
                                    Discount
                                  </span>
                                  <span
                                    style={{
                                      color: "#00a63e",
                                      display: "flex",
                                    }}
                                  >
                                    - RM
                                    <div className="pd-price">
                                      {formatCurrency(calculateDiscount())}
                                    </div>
                                  </span>
                                </div>
                              )}
                              {calculatePwpSubtotal() > 0 && (
                                <div className="pd-summaryitem-container">
                                  <span style={{ color: "#6b7280" }}>
                                    PWP Purchase
                                  </span>
                                  <span style={{ display: "flex" }}>
                                    + RM
                                    <div className="pd-price">
                                      {formatCurrency(calculatePwpSubtotal())}
                                    </div>
                                  </span>
                                </div>
                              )}

                              <div className="pd-summaryitem-totalprice-container">
                                <span>Total Payable</span>
                                <span
                                  className="pd-totalprice"
                                  style={{ display: "flex", fontSize: "18px" }}
                                >
                                  RM
                                  <div className="pd-price">
                                    {formatCurrency(calculateTotal())}
                                  </div>
                                </span>
                              </div>

                              <div className="productdetail-separator"></div>

                              {allowAddToCart ? (
                                <div style={{ display: "flex", gap: "8px" }}>
                                  <div
                                    className="pd-button"
                                    onClick={() =>
                                      handleAddToCart({ buyNow: false })
                                    }
                                    style={{ width: "50%" }}
                                  >
                                    {isSubmitting ? (
                                      "Processing..."
                                    ) : (
                                      <>
                                        <ShoppingCart size={16} /> Add To Cart
                                      </>
                                    )}
                                  </div>
                                  <div
                                    className="pd-button orange"
                                    onClick={() =>
                                      handleAddToCart({ buyNow: true })
                                    }
                                    style={{ width: "50%" }}
                                  >
                                    {isSubmitting ? (
                                      "Processing..."
                                    ) : (
                                      <>
                                        <ShoppingCart size={16} /> Buy Now
                                      </>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div className="pd-reminder">
                                  Complete branch allocation to add to cart
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Image Modal */}
                {showImageModal && images[slideIndex]?.type === "image" && (
                  <div className="image-modal" onClick={handleCloseModal}>
                    <div
                      className="image-modal-content"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <button
                        className="modal-close"
                        onClick={handleCloseModal}
                      >
                        <X size={16} />
                      </button>

                      {/* Previous Button in Modal */}
                      {images.length > 1 && (
                        <button
                          className="modal-nav-prev"
                          onClick={(e) => {
                            e.stopPropagation();
                            handlePrevImage();
                          }}
                        >
                          <ChevronLeft size={16} />
                        </button>
                      )}

                      <FallbackImg
                        key={images[slideIndex]?.url}
                        src={images[slideIndex]?.url}
                        alt={product.item_name || "Product"}
                        className="modal-image"
                        onClick={(e) => e.stopPropagation()}
                      />

                      {/* Next Button in Modal */}
                      {images.length > 1 && (
                        <button
                          className="modal-nav-next"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleNextImage();
                          }}
                        >
                          <ChevronRight size={16} />
                        </button>
                      )}

                      {/* Image Counter */}
                      {images.length > 1 && (
                        <div className="modal-image-counter">
                          {slideIndex + 1} / {images.length}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Image Modal - promotion */}
                {showPromotionImageModal && (
                  <div
                    className="image-modal"
                    onClick={() => setShowPromotionImageModal(false)}
                  >
                    <div
                      className="image-modal-content"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <button
                        className="modal-close"
                        onClick={() => setShowPromotionImageModal(false)}
                      >
                        <X size={16} />
                      </button>
                      <FallbackImg
                        src={modalPromotionImageUrl}
                        alt="Promotion"
                        className="modal-image"
                      />
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div
                style={{
                  minHeight: "60vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span style={{ color: "#b71c1c", fontWeight: 600 }}>
                  You do not have permission to view this section.
                </span>
              </div>
            )}
          </div>
        </>
      )}

      {showRegionPopup && (
        <MultiPurpose
          title="Select Order Region"
          yesText="Continue"
          noText="Cancel"
          onYes={() => {
            setSelectedRegion(tempSelectedRegion);
            setShowRegionPopup(false);
          }}
          onNo={() => {
            setShowRegionPopup(false);
            // Came from Compare Product: cancel goes back there, not to the list.
            if (location.state?.from === "compareproduct") navigate(-1);
            else navigate("/productlist");
          }}
          onClose={() => {
            setShowRegionPopup(false);
            if (location.state?.from === "compareproduct") navigate(-1);
            else navigate("/productlist");
          }}
        >
          <div>
            <div style={{ textAlign: "left", marginBottom: "24px" }}>
              Please select a region to continue order:
            </div>
            {branchRegions.map((region) => {
              const hasStock =
                !regionAvailability || regionAvailability[region] !== false;
              return (
                <label
                  key={region}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "10px",
                    cursor: "pointer",
                    fontWeight: tempSelectedRegion === region ? "600" : "400",
                  }}
                >
                  <input
                    type="radio"
                    name="region"
                    value={region}
                    checked={tempSelectedRegion === region}
                    onChange={() => setTempSelectedRegion(region)}
                  />
                  {REGION_LABELS[region] || region}
                  {!hasStock && (
                    <span
                      style={{
                        color: "#c0392b",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      (Not Available)
                    </span>
                  )}
                </label>
              );
            })}
          </div>
        </MultiPurpose>
      )}
    </div>
  );
};

export default ProductDetailv2;
